/* tslint:disable */
/* eslint-disable */
/**
 * WineMS.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {number}
     * @memberof AddressDto
     */
    addressIdNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    streetAndNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    postalCode?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserBaseDto
 */
export interface ApplicationUserBaseDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserBaseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserBaseDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserBaseDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserBaseDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserBaseDto
     */
    emailConfirmed?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationUserDetailsDto
 */
export interface ApplicationUserDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDetailsDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserDetailsDto
     */
    roles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDetailsDto
     */
    auth0Id?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserDto
 */
export interface ApplicationUserDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserDto
     */
    auth0Id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserDto
     */
    roles?: Array<ApplicationUserRole> | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserMcpDto
 */
export interface ApplicationUserMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserMcpDto
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserMinimalDto
 */
export interface ApplicationUserMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserMinimalDto
     */
    userName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserRegisterDto
 */
export interface ApplicationUserRegisterDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserRegisterDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUserRegisterDto
     */
    withInvitation?: boolean;
    /**
     * 
     * @type {Array<ApplicationUserRole>}
     * @memberof ApplicationUserRegisterDto
     */
    roles?: Array<ApplicationUserRole> | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserRegisterDto
     */
    auth0Id?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationUserRole {
    Admin = 'Admin',
    ProductManager = 'ProductManager',
    OrderManager = 'OrderManager',
    UserManager = 'UserManager',
    CanReadWarehouse = 'CanReadWarehouse',
    CanUpdateContractors = 'CanUpdateContractors',
    ManageUsers = 'ManageUsers',
    ReadWarehouses = 'ReadWarehouses',
    ManageWarehouses = 'ManageWarehouses',
    ReadStock = 'ReadStock',
    ManageStock = 'ManageStock',
    ReadProducts = 'ReadProducts',
    ManageProducts = 'ManageProducts',
    ReadProduction = 'ReadProduction',
    ManageProduction = 'ManageProduction',
    ReadAnalytics = 'ReadAnalytics',
    ManageAnalytics = 'ManageAnalytics',
    ReadContractors = 'ReadContractors',
    ManageContractors = 'ManageContractors',
    ReadMeetings = 'ReadMeetings',
    ManageMeetings = 'ManageMeetings',
    ManageSettings = 'ManageSettings',
    ReadOperations = 'ReadOperations',
    ManageOperations = 'ManageOperations',
    ReadInventory = 'ReadInventory',
    ManageInventory = 'ManageInventory',
    NexoSync = 'NexoSync'
}

/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryCreateDto
 */
export interface ApplicationUserUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryDetailsDto
 */
export interface ApplicationUserUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryDto
 */
export interface ApplicationUserUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ApplicationUserUpdateHistoryUpdateDto
 */
export interface ApplicationUserUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    applicationUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUserUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface BatchNumberCreateDto
 */
export interface BatchNumberCreateDto {
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberCreateDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberCreateDto
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface BatchNumberDto
 */
export interface BatchNumberDto {
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BatchNumberDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof BatchNumberDto
     */
    unit?: UnitOfMeasureDto;
    /**
     * 
     * @type {number}
     * @memberof BatchNumberDto
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface CardToken
 */
export interface CardToken {
    /**
     * 
     * @type {string}
     * @memberof CardToken
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardToken
     */
    brandImageUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CardToken
     */
    preferred?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CardToken
     */
    status?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CardToken
     */
    cardExpirationMonth?: number;
    /**
     * 
     * @type {number}
     * @memberof CardToken
     */
    cardExpirationYear?: number;
    /**
     * 
     * @type {string}
     * @memberof CardToken
     */
    cardNumberMasked?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardToken
     */
    cardScheme?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardToken
     */
    cardBrand?: string | null;
}
/**
 * 
 * @export
 * @interface CloudflarePagesDeployment
 */
export interface CloudflarePagesDeployment {
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeployment
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeployment
     */
    project_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeployment
     */
    created_on?: string;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeployment
     */
    modified_on?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeployment
     */
    project_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeployment
     */
    environment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeployment
     */
    url?: string | null;
    /**
     * 
     * @type {Array<CloudflarePagesDeploymentStage>}
     * @memberof CloudflarePagesDeployment
     */
    stages?: Array<CloudflarePagesDeploymentStage> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CloudflarePagesDeployment
     */
    is_skipped?: boolean;
}
/**
 * 
 * @export
 * @interface CloudflarePagesDeploymentStage
 */
export interface CloudflarePagesDeploymentStage {
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeploymentStage
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeploymentStage
     */
    started_on?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeploymentStage
     */
    ended_on?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudflarePagesDeploymentStage
     */
    status?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataCreateDto
 */
export interface CompanyDataCreateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataCreateDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataDetailsDto
 */
export interface CompanyDataDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDetailsDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataDto
 */
export interface CompanyDataDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataMcpDto
 */
export interface CompanyDataMcpDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMcpDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataMinimalDto
 */
export interface CompanyDataMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataMinimalDto
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateDto
 */
export interface CompanyDataUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    taxIdentificationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateDto
     */
    bankAccountNumber?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryCreateDto
 */
export interface CompanyDataUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryDetailsDto
 */
export interface CompanyDataUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryDto
 */
export interface CompanyDataUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CompanyDataUpdateHistoryUpdateDto
 */
export interface CompanyDataUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    companyDataId?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDataUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorCreateDto
 */
export interface ContractorCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorCreateDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorCreateDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorCreateDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorCreateDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorCreateDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorCreateDto
     */
    merchant?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @interface ContractorDetailsDto
 */
export interface ContractorDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorDetailsDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDetailsDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorDetailsDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorDetailsDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDetailsDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorDetailsDto
     */
    merchant?: ApplicationUserDto;
    /**
     * 
     * @type {Array<StockOperationMinimalDto>}
     * @memberof ContractorDetailsDto
     */
    stockOperations?: Array<StockOperationMinimalDto> | null;
}
/**
 * 
 * @export
 * @interface ContractorDto
 */
export interface ContractorDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorDto
     */
    merchant?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @interface ContractorMcpDto
 */
export interface ContractorMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorMcpDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorMcpDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    merchantName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    mainAddressStreet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    mainAddressCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorMcpDto
     */
    mainAddressPostalCode?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateDto
 */
export interface ContractorUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<PhoneNumberDto>}
     * @memberof ContractorUpdateDto
     */
    phoneNumbers?: Array<PhoneNumberDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateDto
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    pipedriveOrganizationId?: number | null;
    /**
     * 
     * @type {AddressDto}
     * @memberof ContractorUpdateDto
     */
    mainAddress?: AddressDto;
    /**
     * 
     * @type {Array<AddressDto>}
     * @memberof ContractorUpdateDto
     */
    addresses?: Array<AddressDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateDto
     */
    merchantId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateDto
     */
    merchant?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryCreateDto
 */
export interface ContractorUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryDetailsDto
 */
export interface ContractorUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryDto
 */
export interface ContractorUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ContractorUpdateHistoryUpdateDto
 */
export interface ContractorUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface CropCreateDto
 */
export interface CropCreateDto {
    /**
     * 
     * @type {number}
     * @memberof CropCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CropStrainDto>}
     * @memberof CropCreateDto
     */
    cropStrains?: Array<CropStrainDto> | null;
}
/**
 * 
 * @export
 * @interface CropDetailsDto
 */
export interface CropDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof CropDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CropStrainPlantCountDto>}
     * @memberof CropDetailsDto
     */
    cropStrains?: Array<CropStrainPlantCountDto> | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof CropDetailsDto
     */
    stockOperations?: Array<StockOperationDto> | null;
}
/**
 * 
 * @export
 * @interface CropDto
 */
export interface CropDto {
    /**
     * 
     * @type {number}
     * @memberof CropDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface CropMcpDto
 */
export interface CropMcpDto {
    /**
     * 
     * @type {number}
     * @memberof CropMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CropMcpDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface CropStrainDto
 */
export interface CropStrainDto {
    /**
     * 
     * @type {number}
     * @memberof CropStrainDto
     */
    cropId?: number;
    /**
     * 
     * @type {CropDto}
     * @memberof CropStrainDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof CropStrainDto
     */
    strainId?: number;
    /**
     * 
     * @type {StrainDto}
     * @memberof CropStrainDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {number}
     * @memberof CropStrainDto
     */
    plantCount?: number;
}
/**
 * 
 * @export
 * @interface CropStrainMinimalDto
 */
export interface CropStrainMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof CropStrainMinimalDto
     */
    cropId?: number;
    /**
     * 
     * @type {number}
     * @memberof CropStrainMinimalDto
     */
    strainId?: number;
    /**
     * 
     * @type {number}
     * @memberof CropStrainMinimalDto
     */
    plantCount?: number;
}
/**
 * 
 * @export
 * @interface CropStrainPlantCountDto
 */
export interface CropStrainPlantCountDto {
    /**
     * 
     * @type {number}
     * @memberof CropStrainPlantCountDto
     */
    cropId?: number;
    /**
     * 
     * @type {number}
     * @memberof CropStrainPlantCountDto
     */
    strainId?: number;
    /**
     * 
     * @type {StrainDto}
     * @memberof CropStrainPlantCountDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {number}
     * @memberof CropStrainPlantCountDto
     */
    plantCount?: number;
}
/**
 * 
 * @export
 * @interface CropUpdateDto
 */
export interface CropUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof CropUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CropUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CropUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CropUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CropStrainMinimalDto>}
     * @memberof CropUpdateDto
     */
    cropStrains?: Array<CropStrainMinimalDto> | null;
}
/**
 * 
 * @export
 * @interface DeployPageDto
 */
export interface DeployPageDto {
    /**
     * 
     * @type {string}
     * @memberof DeployPageDto
     */
    projectName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeployPageDto
     */
    domains?: Array<string> | null;
    /**
     * 
     * @type {CloudflarePagesDeployment}
     * @memberof DeployPageDto
     */
    latestDeployment?: CloudflarePagesDeployment;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Direction {
    Up = 'Up',
    Down = 'Down'
}

/**
 * 
 * @export
 * @interface InventoryOperationCreateDto
 */
export interface InventoryOperationCreateDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationCreateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationCreateDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationCreateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationCreateDto
     */
    documentNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationDetailDto
 */
export interface InventoryOperationDetailDto {
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    inventoryOperationId?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailDto
     */
    quantity?: number;
}
/**
 * 
 * @export
 * @interface InventoryOperationDetailsDto
 */
export interface InventoryOperationDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationDetailsDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationDetailsDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDetailsDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDetailsDto
     */
    documentNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationDto
 */
export interface InventoryOperationDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationDto
     */
    documentNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationMcpDto
 */
export interface InventoryOperationMcpDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    productName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    warehouseName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    unitId?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    unitName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationMcpDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationMcpDto
     */
    batchNumber?: string | null;
}
/**
 * 
 * @export
 * @interface InventoryOperationUpdateDto
 */
export interface InventoryOperationUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof InventoryOperationUpdateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {Array<InventoryOperationDetailDto>}
     * @memberof InventoryOperationUpdateDto
     */
    inventoryOperationDetails?: Array<InventoryOperationDetailDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InventoryOperationUpdateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InventoryOperationUpdateDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryOperationUpdateDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface InvoicePreviewDto
 */
export interface InvoicePreviewDto {
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    requestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    contractorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    contractorNip?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    netValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    vatValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    grossValue?: number;
    /**
     * 
     * @type {Array<InvoiceRowPreviewDto>}
     * @memberof InvoicePreviewDto
     */
    rows?: Array<InvoiceRowPreviewDto> | null;
}
/**
 * 
 * @export
 * @interface InvoiceRowPreviewDto
 */
export interface InvoiceRowPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof InvoiceRowPreviewDto
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceRowPreviewDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceRowPreviewDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    netPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    vatRate?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    netValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceRowPreviewDto
     */
    grossValue?: number;
}
/**
 * 
 * @export
 * @interface JsonNode
 */
export interface JsonNode {
    /**
     * 
     * @type {JsonNodeOptions}
     * @memberof JsonNode
     */
    options?: JsonNodeOptions;
    /**
     * 
     * @type {JsonNode}
     * @memberof JsonNode
     */
    parent?: JsonNode;
    /**
     * 
     * @type {JsonNode}
     * @memberof JsonNode
     */
    root?: JsonNode;
}
/**
 * 
 * @export
 * @interface JsonNodeOptions
 */
export interface JsonNodeOptions {
    /**
     * 
     * @type {boolean}
     * @memberof JsonNodeOptions
     */
    propertyNameCaseInsensitive?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum JsonPatchOperationType {
    Add = 'Add',
    Remove = 'Remove',
    Replace = 'Replace',
    Move = 'Move',
    Copy = 'Copy',
    Test = 'Test',
    Invalid = 'Invalid'
}

/**
 * 
 * @export
 * @interface McpJsonRpcRequest
 */
export interface McpJsonRpcRequest {
    /**
     * 
     * @type {string}
     * @memberof McpJsonRpcRequest
     */
    jsonrpc?: string | null;
    /**
     * 
     * @type {JsonNode}
     * @memberof McpJsonRpcRequest
     */
    id?: JsonNode;
    /**
     * 
     * @type {string}
     * @memberof McpJsonRpcRequest
     */
    method?: string | null;
    /**
     * 
     * @type {{ [key: string]: JsonNode; }}
     * @memberof McpJsonRpcRequest
     */
    params?: { [key: string]: JsonNode; } | null;
}
/**
 * 
 * @export
 * @interface MeetingChangeStatusDto
 */
export interface MeetingChangeStatusDto {
    /**
     * 
     * @type {MeetingStatus}
     * @memberof MeetingChangeStatusDto
     */
    newStatus?: MeetingStatus;
    /**
     * 
     * @type {string}
     * @memberof MeetingChangeStatusDto
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingChangeStatusDto
     */
    newStartTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingChangeStatusDto
     */
    meetingId?: number;
}
/**
 * 
 * @export
 * @interface MeetingDetailsDto
 */
export interface MeetingDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    pipedriveActivityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    startTime?: string | null;
    /**
     * 
     * @type {MeetingStatus}
     * @memberof MeetingDetailsDto
     */
    status?: MeetingStatus;
    /**
     * 
     * @type {MeetingForm}
     * @memberof MeetingDetailsDto
     */
    form?: MeetingForm;
    /**
     * 
     * @type {string}
     * @memberof MeetingDetailsDto
     */
    message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    contractorId?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingDetailsDto
     */
    parentId?: number | null;
    /**
     * 
     * @type {MeetingSimpleDto}
     * @memberof MeetingDetailsDto
     */
    parent?: MeetingSimpleDto;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof MeetingDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {ContractorDto}
     * @memberof MeetingDetailsDto
     */
    contractor?: ContractorDto;
}
/**
 * 
 * @export
 * @interface MeetingDto
 */
export interface MeetingDto {
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    pipedriveActivityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    startTime?: string | null;
    /**
     * 
     * @type {MeetingStatus}
     * @memberof MeetingDto
     */
    status?: MeetingStatus;
    /**
     * 
     * @type {MeetingForm}
     * @memberof MeetingDto
     */
    form?: MeetingForm;
    /**
     * 
     * @type {string}
     * @memberof MeetingDto
     */
    message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    contractorId?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingDto
     */
    parentId?: number | null;
    /**
     * 
     * @type {MeetingSimpleDto}
     * @memberof MeetingDto
     */
    parent?: MeetingSimpleDto;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof MeetingDto
     */
    createdBy?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MeetingForm {
    InPerson = 'InPerson',
    Phone = 'Phone',
    Online = 'Online',
    Other = 'Other'
}

/**
 * 
 * @export
 * @interface MeetingSimpleDto
 */
export interface MeetingSimpleDto {
    /**
     * 
     * @type {number}
     * @memberof MeetingSimpleDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingSimpleDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingSimpleDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingSimpleDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSimpleDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSimpleDto
     */
    startTime?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MeetingStatus {
    Scheduled = 'Scheduled',
    Canceled = 'Canceled',
    Rescheduled = 'Rescheduled',
    Done = 'Done'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OperationType {
    Create = 'Create',
    Delete = 'Delete',
    Edit = 'Edit',
    Assign = 'Assign'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OrderCreateResult {
    Success = 'Success',
    Redirect = 'Redirect'
}

/**
 * 
 * @export
 * @interface PaginatedMcpDtoApplicationUserMcpDto
 */
export interface PaginatedMcpDtoApplicationUserMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoApplicationUserMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoApplicationUserMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoApplicationUserMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ApplicationUserMcpDto>}
     * @memberof PaginatedMcpDtoApplicationUserMcpDto
     */
    items?: Array<ApplicationUserMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoCompanyDataMcpDto
 */
export interface PaginatedMcpDtoCompanyDataMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoCompanyDataMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoCompanyDataMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoCompanyDataMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CompanyDataMcpDto>}
     * @memberof PaginatedMcpDtoCompanyDataMcpDto
     */
    items?: Array<CompanyDataMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoContractorMcpDto
 */
export interface PaginatedMcpDtoContractorMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoContractorMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoContractorMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoContractorMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContractorMcpDto>}
     * @memberof PaginatedMcpDtoContractorMcpDto
     */
    items?: Array<ContractorMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoCropMcpDto
 */
export interface PaginatedMcpDtoCropMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoCropMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoCropMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoCropMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CropMcpDto>}
     * @memberof PaginatedMcpDtoCropMcpDto
     */
    items?: Array<CropMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoInventoryOperationMcpDto
 */
export interface PaginatedMcpDtoInventoryOperationMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoInventoryOperationMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoInventoryOperationMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoInventoryOperationMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<InventoryOperationMcpDto>}
     * @memberof PaginatedMcpDtoInventoryOperationMcpDto
     */
    items?: Array<InventoryOperationMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoProductMcpDto
 */
export interface PaginatedMcpDtoProductMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoProductMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoProductMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoProductMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ProductMcpDto>}
     * @memberof PaginatedMcpDtoProductMcpDto
     */
    items?: Array<ProductMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoStockMcpDto
 */
export interface PaginatedMcpDtoStockMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStockMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStockMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStockMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StockMcpDto>}
     * @memberof PaginatedMcpDtoStockMcpDto
     */
    items?: Array<StockMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoStockOperationMcpDto
 */
export interface PaginatedMcpDtoStockOperationMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStockOperationMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStockOperationMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStockOperationMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StockOperationMcpDto>}
     * @memberof PaginatedMcpDtoStockOperationMcpDto
     */
    items?: Array<StockOperationMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoStrainMcpDto
 */
export interface PaginatedMcpDtoStrainMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStrainMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStrainMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoStrainMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StrainMcpDto>}
     * @memberof PaginatedMcpDtoStrainMcpDto
     */
    items?: Array<StrainMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PaginatedMcpDtoWarehouseMcpDto
 */
export interface PaginatedMcpDtoWarehouseMcpDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoWarehouseMcpDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoWarehouseMcpDto
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMcpDtoWarehouseMcpDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<WarehouseMcpDto>}
     * @memberof PaginatedMcpDtoWarehouseMcpDto
     */
    items?: Array<WarehouseMcpDto> | null;
}
/**
 * 
 * @export
 * @interface PayByLink
 */
export interface PayByLink {
    /**
     * 
     * @type {string}
     * @memberof PayByLink
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayByLink
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayByLink
     */
    brandImageUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayByLink
     */
    status?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PayByLink
     */
    minAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PayByLink
     */
    maxAmount?: number;
}
/**
 * 
 * @export
 * @interface PayUAvailablePayMethods
 */
export interface PayUAvailablePayMethods {
    /**
     * 
     * @type {Array<PayByLink>}
     * @memberof PayUAvailablePayMethods
     */
    payByLinks?: Array<PayByLink> | null;
    /**
     * 
     * @type {Array<CardToken>}
     * @memberof PayUAvailablePayMethods
     */
    cardTokens?: Array<CardToken> | null;
}
/**
 * 
 * @export
 * @interface PayUOrderNotification
 */
export interface PayUOrderNotification {
    /**
     * 
     * @type {PayUOrderNotificationOrder}
     * @memberof PayUOrderNotification
     */
    order?: PayUOrderNotificationOrder;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotification
     */
    localReceiptDateTime?: string;
    /**
     * 
     * @type {Array<PayUOrderNotificationProperties>}
     * @memberof PayUOrderNotification
     */
    properties?: Array<PayUOrderNotificationProperties> | null;
}
/**
 * 
 * @export
 * @interface PayUOrderNotificationOrder
 */
export interface PayUOrderNotificationOrder {
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    orderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    extOrderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    orderCreateDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    notifyUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    customerIp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    merchantPosId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PayUOrderNotificationOrder
     */
    totalAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationOrder
     */
    status?: string | null;
    /**
     * 
     * @type {Array<PayUOrderProductRequest>}
     * @memberof PayUOrderNotificationOrder
     */
    products?: Array<PayUOrderProductRequest> | null;
}
/**
 * 
 * @export
 * @interface PayUOrderNotificationProperties
 */
export interface PayUOrderNotificationProperties {
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationProperties
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderNotificationProperties
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface PayUOrderProductRequest
 */
export interface PayUOrderProductRequest {
    /**
     * 
     * @type {string}
     * @memberof PayUOrderProductRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderProductRequest
     */
    unitPrice?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayUOrderProductRequest
     */
    quantity?: string | null;
}
/**
 * 
 * @export
 * @interface PhoneNumberDto
 */
export interface PhoneNumberDto {
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    contactPerson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhoneNumberDto
     */
    pipedrivePersonId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PhoneNumberDto
     */
    isPrimary?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberDto
     */
    jobTitle?: string | null;
}
/**
 * 
 * @export
 * @interface PhysicochemicalTestCreateDto
 */
export interface PhysicochemicalTestCreateDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestCreateDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestCreateDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestCreateDto
     */
    acidityPh?: number | null;
}
/**
 * 
 * @export
 * @interface PhysicochemicalTestDetailsDto
 */
export interface PhysicochemicalTestDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDetailsDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestDetailsDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDetailsDto
     */
    acidityPh?: number | null;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof PhysicochemicalTestDetailsDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface PhysicochemicalTestDto
 */
export interface PhysicochemicalTestDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestDto
     */
    acidityPh?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PhysicochemicalTestStage {
    Harvest = 'Harvest',
    Embossing = 'Embossing',
    Transfer = 'Transfer'
}

/**
 * 
 * @export
 * @interface PhysicochemicalTestUpdateDto
 */
export interface PhysicochemicalTestUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    productionProcessId?: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhysicochemicalTestUpdateDto
     */
    testDate?: string | null;
    /**
     * 
     * @type {PhysicochemicalTestStage}
     * @memberof PhysicochemicalTestUpdateDto
     */
    testStage?: PhysicochemicalTestStage;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    percentOfAlcohol?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    sugarGramPerLiter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PhysicochemicalTestUpdateDto
     */
    acidityPh?: number | null;
}
/**
 * 
 * @export
 * @interface PipedriveDealIntegrationProductDto
 */
export interface PipedriveDealIntegrationProductDto {
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    dealProductId?: number;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    pipedriveProductId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    productCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    itemPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    discountPercentage?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    comments?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationProductDto
     */
    isMapped?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    wineMsProductId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    wineMsUnitId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    availableQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationProductDto
     */
    reservedQuantity?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationProductDto
     */
    hasSufficientStock?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationProductDto
     */
    warning?: string | null;
}
/**
 * 
 * @export
 * @interface PipedriveDealIntegrationSummaryDto
 */
export interface PipedriveDealIntegrationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    pipedriveDealId?: number;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    title?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    pipelineId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    stageId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    isConfigured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    inConfiguredPipeline?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    isEditableStage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    action?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    warning?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    contractorName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    orderStatus?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    orderUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    productCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    hasUnmappedProducts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    hasStockIssues?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    hasMissingBatchNumbers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    canSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    canSendToWarehouse?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    canConfirm?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    confirmAction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    confirmButtonLabel?: string | null;
    /**
     * 
     * @type {Array<PipedriveDealIntegrationProductDto>}
     * @memberof PipedriveDealIntegrationSummaryDto
     */
    products?: Array<PipedriveDealIntegrationProductDto> | null;
}
/**
 * 
 * @export
 * @interface ProductCreateDto
 */
export interface ProductCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductCreateDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductCreateDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductCreateDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductCreateDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductCreateDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductCreateDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {ProductLabelDataDto}
     * @memberof ProductCreateDto
     */
    labelData?: ProductLabelDataDto;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductCreateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductCreateDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductCreateDto
     */
    prices?: Array<ProductPriceDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductCreateDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductCreateDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ProductDetailsDto
 */
export interface ProductDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductDetailsDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDetailsDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductDetailsDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductDetailsDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDetailsDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductDetailsDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductDetailsDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDetailsDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {ProductLabelDataDto}
     * @memberof ProductDetailsDto
     */
    labelData?: ProductLabelDataDto;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductDetailsDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductDetailsDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDetailsDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductDetailsDto
     */
    prices?: Array<ProductPriceDto> | null;
}
/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {ProductLabelDataDto}
     * @memberof ProductDto
     */
    labelData?: ProductLabelDataDto;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductDto
     */
    prices?: Array<ProductPriceDto> | null;
}
/**
 * 
 * @export
 * @interface ProductLabelDataDto
 */
export interface ProductLabelDataDto {
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    imagePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    ingredientsText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    bottlingMethod?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductLabelDataDto
     */
    energyKj?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductLabelDataDto
     */
    energyKcal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    fatTotal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    fatSaturated?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    carbohydratesTotal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    sugars?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    protein?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductLabelDataDto
     */
    salt?: string | null;
}
/**
 * 
 * @export
 * @interface ProductMcpDto
 */
export interface ProductMcpDto {
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductMcpDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    baseUnitName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    strainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    sweetness?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMcpDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductMcpDto
     */
    price?: number | null;
}
/**
 * 
 * @export
 * @interface ProductMinimalDto
 */
export interface ProductMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof ProductMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductMinimalDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductMinimalDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface ProductPriceCreateDto
 */
export interface ProductPriceCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceCreateDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @interface ProductPriceDetailsDto
 */
export interface ProductPriceDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDetailsDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @interface ProductPriceDto
 */
export interface ProductPriceDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @interface ProductPriceUpdateDto
 */
export interface ProductPriceUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPriceUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceUpdateDto
     */
    price?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductType {
    Wine = 'Wine',
    LabeledWine = 'LabeledWine',
    Fruit = 'Fruit',
    Juice = 'Juice',
    Sediment = 'Sediment',
    Pomace = 'Pomace',
    Bottle = 'Bottle',
    Other = 'Other',
    BottledWine = 'BottledWine'
}

/**
 * 
 * @export
 * @interface ProductUpdateDto
 */
export interface ProductUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    baseUnitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof ProductUpdateDto
     */
    baseUnit?: UnitOfMeasureDto;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductUpdateDto
     */
    auxiliaryUnitsIds?: Array<number> | null;
    /**
     * 
     * @type {Array<SimpleBaseUnitDto>}
     * @memberof ProductUpdateDto
     */
    auxiliaryUnits?: Array<SimpleBaseUnitDto> | null;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductUpdateDto
     */
    type?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductUpdateDto
     */
    additionalStrainIds?: Array<number> | null;
    /**
     * 
     * @type {WineColor}
     * @memberof ProductUpdateDto
     */
    color?: WineColor;
    /**
     * 
     * @type {WineSweetness}
     * @memberof ProductUpdateDto
     */
    sweetness?: WineSweetness;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    tasteNote?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateDto
     */
    productionYear?: string | null;
    /**
     * 
     * @type {ProductLabelDataDto}
     * @memberof ProductUpdateDto
     */
    labelData?: ProductLabelDataDto;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductUpdateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<StrainDto>}
     * @memberof ProductUpdateDto
     */
    additionalStrains?: Array<StrainDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateDto
     */
    price?: number | null;
    /**
     * 
     * @type {Array<ProductPriceDto>}
     * @memberof ProductUpdateDto
     */
    prices?: Array<ProductPriceDto> | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryCreateDto
 */
export interface ProductUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryDetailsDto
 */
export interface ProductUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryDto
 */
export interface ProductUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductUpdateHistoryUpdateDto
 */
export interface ProductUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessCreateDto
 */
export interface ProductionProcessCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessCreateDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessCreateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessCreateDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessCreateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessCreateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessCreateDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessDetailsDto
 */
export interface ProductionProcessDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessDetailsDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessDetailsDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDetailsDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessDetailsDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessDetailsDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessDto
 */
export interface ProductionProcessDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface ProductionProcessMinimalDto
 */
export interface ProductionProcessMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessMinimalDto
     */
    name?: string | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessMinimalDto
     */
    strain?: StrainDto;
}
/**
 * 
 * @export
 * @interface ProductionProcessStockDto
 */
export interface ProductionProcessStockDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof ProductionProcessStockDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    productId?: number;
    /**
     * 
     * @type {ProductDto}
     * @memberof ProductionProcessStockDto
     */
    product?: ProductDto;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessStockDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    unitId?: number;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof ProductionProcessStockDto
     */
    unit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    reservedQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessStockDto
     */
    lastChangedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessStockDto
     */
    productionProcessId?: number;
}
/**
 * 
 * @export
 * @interface ProductionProcessUpdateDto
 */
export interface ProductionProcessUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionProcessUpdateDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof ProductionProcessUpdateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof ProductionProcessUpdateDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionProcessUpdateDto
     */
    strainId?: number | null;
    /**
     * 
     * @type {StrainDto}
     * @memberof ProductionProcessUpdateDto
     */
    strain?: StrainDto;
    /**
     * 
     * @type {Array<PhysicochemicalTestDto>}
     * @memberof ProductionProcessUpdateDto
     */
    physicochemicalTests?: Array<PhysicochemicalTestDto> | null;
}
/**
 * 
 * @export
 * @interface ShopAddressShopAddressCreateDto
 */
export interface ShopAddressShopAddressCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressCreateDto
     */
    applicationUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    buildingNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    flatNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    vatId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressCreateDto
     */
    orderGuid?: string | null;
}
/**
 * 
 * @export
 * @interface ShopAddressShopAddressDetailsDto
 */
export interface ShopAddressShopAddressDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    applicationUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    buildingNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    flatNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    vatId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDetailsDto
     */
    orderGuid?: string | null;
}
/**
 * 
 * @export
 * @interface ShopAddressShopAddressDto
 */
export interface ShopAddressShopAddressDto {
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressDto
     */
    applicationUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    buildingNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    flatNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    vatId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressDto
     */
    orderGuid?: string | null;
}
/**
 * 
 * @export
 * @interface ShopAddressShopAddressUpdateDto
 */
export interface ShopAddressShopAddressUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    applicationUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    buildingNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    flatNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    vatId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopAddressShopAddressUpdateDto
     */
    orderGuid?: string | null;
}
/**
 * 
 * @export
 * @interface ShopBasketAddToBasketDto
 */
export interface ShopBasketAddToBasketDto {
    /**
     * 
     * @type {number}
     * @memberof ShopBasketAddToBasketDto
     */
    productPriceId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopBasketAddToBasketDto
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ShopBasketBasketDto
 */
export interface ShopBasketBasketDto {
    /**
     * 
     * @type {string}
     * @memberof ShopBasketBasketDto
     */
    id?: string;
    /**
     * 
     * @type {Array<ShopBasketBasketItemDto>}
     * @memberof ShopBasketBasketDto
     */
    items?: Array<ShopBasketBasketItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ShopBasketBasketDto
     */
    readDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopBasketBasketDto
     */
    discountCodeId?: number | null;
    /**
     * 
     * @type {ShopDiscountCodeDiscountCodeDto}
     * @memberof ShopBasketBasketDto
     */
    shopDiscountCode?: ShopDiscountCodeDiscountCodeDto;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ShopBasketBasketDto
     */
    user?: ApplicationUserDto;
}
/**
 * 
 * @export
 * @interface ShopBasketBasketItemDto
 */
export interface ShopBasketBasketItemDto {
    /**
     * 
     * @type {string}
     * @memberof ShopBasketBasketItemDto
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopBasketBasketItemDto
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopBasketBasketItemDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopBasketBasketItemDto
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopBasketBasketItemDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopBasketBasketItemDto
     */
    productPriceId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopBasketBasketItemDto
     */
    unit?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopBasketBasketItemDto
     */
    categoriesIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopBasketRemoveFromBasketDto
 */
export interface ShopBasketRemoveFromBasketDto {
    /**
     * 
     * @type {string}
     * @memberof ShopBasketRemoveFromBasketDto
     */
    basketItemId?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopBasketRemoveFromBasketDto
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface ShopCategoryCategoryCreateDto
 */
export interface ShopCategoryCategoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryCreateDto
     */
    parentCategoryId?: number | null;
    /**
     * 
     * @type {Array<ShopCategoryProductCategoryProductsMinimal>}
     * @memberof ShopCategoryCategoryCreateDto
     */
    products?: Array<ShopCategoryProductCategoryProductsMinimal> | null;
}
/**
 * 
 * @export
 * @interface ShopCategoryCategoryDetailsDto
 */
export interface ShopCategoryCategoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    parentCategoryId?: number | null;
    /**
     * 
     * @type {Array<ShopCategoryProductCategoryProductsMinimal>}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    products?: Array<ShopCategoryProductCategoryProductsMinimal> | null;
    /**
     * 
     * @type {ShopCategoryCategoryDto}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    parentCategory?: ShopCategoryCategoryDto;
    /**
     * 
     * @type {Array<ShopCategoryCategoryDto>}
     * @memberof ShopCategoryCategoryDetailsDto
     */
    categories?: Array<ShopCategoryCategoryDto> | null;
}
/**
 * 
 * @export
 * @interface ShopCategoryCategoryDto
 */
export interface ShopCategoryCategoryDto {
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryDto
     */
    parentCategoryId?: number | null;
    /**
     * 
     * @type {Array<ShopCategoryProductCategoryProductsMinimal>}
     * @memberof ShopCategoryCategoryDto
     */
    products?: Array<ShopCategoryProductCategoryProductsMinimal> | null;
}
/**
 * 
 * @export
 * @interface ShopCategoryCategoryUpdateDto
 */
export interface ShopCategoryCategoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    parentCategoryId?: number | null;
    /**
     * 
     * @type {Array<ShopCategoryProductCategoryProductsMinimal>}
     * @memberof ShopCategoryCategoryUpdateDto
     */
    products?: Array<ShopCategoryProductCategoryProductsMinimal> | null;
}
/**
 * 
 * @export
 * @interface ShopCategoryProductCategoryProductDto
 */
export interface ShopCategoryProductCategoryProductDto {
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    categoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    productPosition?: number;
    /**
     * 
     * @type {ShopCategoryCategoryDto}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    shopCategory?: ShopCategoryCategoryDto;
    /**
     * 
     * @type {ShopProductProductDto}
     * @memberof ShopCategoryProductCategoryProductDto
     */
    shopProduct?: ShopProductProductDto;
}
/**
 * 
 * @export
 * @interface ShopCategoryProductCategoryProductsMinimal
 */
export interface ShopCategoryProductCategoryProductsMinimal {
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductsMinimal
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopCategoryProductCategoryProductsMinimal
     */
    productName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopCategoryProductCategoryProductsMinimal
     */
    productPosition?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ShopDeliveryMethod {
    SelfPickup = 'SelfPickup',
    InPostParcelMachine = 'InPostParcelMachine',
    InPostCarrier = 'InPostCarrier',
    Electronic = 'Electronic'
}

/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeBulkCreateDto
 */
export interface ShopDiscountCodeDiscountCodeBulkCreateDto {
    /**
     * 
     * @type {ShopDiscountCodeDiscountCodeCreateDto}
     * @memberof ShopDiscountCodeDiscountCodeBulkCreateDto
     */
    shopDiscountCode?: ShopDiscountCodeDiscountCodeCreateDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShopDiscountCodeDiscountCodeBulkCreateDto
     */
    codes?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeBulkCreateResultDto
 */
export interface ShopDiscountCodeDiscountCodeBulkCreateResultDto {
    /**
     * 
     * @type {Array<ShopDiscountCodeDiscountCodeDetailsDto>}
     * @memberof ShopDiscountCodeDiscountCodeBulkCreateResultDto
     */
    createdCodes?: Array<ShopDiscountCodeDiscountCodeDetailsDto> | null;
}
/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeBulkDeleteDto
 */
export interface ShopDiscountCodeDiscountCodeBulkDeleteDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeBulkDeleteDto
     */
    ids?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeCreateDto
 */
export interface ShopDiscountCodeDiscountCodeCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {ShopDiscountType}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    shopDiscountType?: ShopDiscountType;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    discountValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    minimumOrderAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    usageLimit?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    minimumOrderAmountOnlyForApplicableProducts?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    applicableProductIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeCreateDto
     */
    applicableCategoryIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeDetailsDto
 */
export interface ShopDiscountCodeDiscountCodeDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {ShopDiscountType}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    shopDiscountType?: ShopDiscountType;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    discountValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    minimumOrderAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    usageLimit?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    minimumOrderAmountOnlyForApplicableProducts?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    applicableProductIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    applicableCategoryIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopOrderOrderDto>}
     * @memberof ShopDiscountCodeDiscountCodeDetailsDto
     */
    shopOrder?: Array<ShopOrderOrderDto> | null;
}
/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeDto
 */
export interface ShopDiscountCodeDiscountCodeDto {
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {ShopDiscountType}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    shopDiscountType?: ShopDiscountType;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    discountValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    minimumOrderAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    usageLimit?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    minimumOrderAmountOnlyForApplicableProducts?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    applicableProductIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeDto
     */
    applicableCategoryIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeResponseDto
 */
export interface ShopDiscountCodeDiscountCodeResponseDto {
    /**
     * 
     * @type {ShopDiscountCodeValidationMessage}
     * @memberof ShopDiscountCodeDiscountCodeResponseDto
     */
    responseMessage?: ShopDiscountCodeValidationMessage;
    /**
     * 
     * @type {ShopDiscountCodeDiscountCodeDto}
     * @memberof ShopDiscountCodeDiscountCodeResponseDto
     */
    shopDiscountCode?: ShopDiscountCodeDiscountCodeDto;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeResponseDto
     */
    applicableOrderAmount?: number | null;
}
/**
 * 
 * @export
 * @interface ShopDiscountCodeDiscountCodeUpdateDto
 */
export interface ShopDiscountCodeDiscountCodeUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {ShopDiscountType}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    shopDiscountType?: ShopDiscountType;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    discountValue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    minimumOrderAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    usageLimit?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    minimumOrderAmountOnlyForApplicableProducts?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    applicableProductIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopDiscountCodeDiscountCodeUpdateDto
     */
    applicableCategoryIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ShopDiscountCodeValidationMessage {
    Ok = 'Ok',
    CodeIncorrect = 'CodeIncorrect',
    OrderAmountNotReached = 'OrderAmountNotReached',
    CodeExpired = 'CodeExpired',
    UsageLimitReached = 'UsageLimitReached',
    CodeNotApplicable = 'CodeNotApplicable'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ShopDiscountType {
    Quota = 'Quota',
    Percent = 'Percent',
    FreeDelivery = 'FreeDelivery',
    BlackFriday = 'BlackFriday'
}

/**
 * 
 * @export
 * @interface ShopOrderInPostParcelMachineDetailsDto
 */
export interface ShopOrderInPostParcelMachineDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof ShopOrderInPostParcelMachineDetailsDto
     */
    parcelLockerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderInPostParcelMachineDetailsDto
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderInPostParcelMachineDetailsDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderInPostParcelMachineDetailsDto
     */
    locationDescription?: string | null;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderCreateDto
 */
export interface ShopOrderOrderCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateDto
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    clientId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ShopOrderOrderCreateDto
     */
    client?: ApplicationUserDto;
    /**
     * 
     * @type {ShopOrderUnregisteredUserDataDto}
     * @memberof ShopOrderOrderCreateDto
     */
    unregisteredUserData?: ShopOrderUnregisteredUserDataDto;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateDto
     */
    optionalMessage?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    deliveryAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderCreateDto
     */
    deliveryAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderOrderCreateDto
     */
    deliveryAddressSameAsBillingAddress?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    billingAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderCreateDto
     */
    billingAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    orderValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    orderOriginalValue?: number;
    /**
     * 
     * @type {ShopDeliveryMethod}
     * @memberof ShopOrderOrderCreateDto
     */
    shopDeliveryMethod?: ShopDeliveryMethod;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    deliveryCost?: number;
    /**
     * 
     * @type {ShopOrderPaymentStatus}
     * @memberof ShopOrderOrderCreateDto
     */
    shopOrderPaymentStatus?: ShopOrderPaymentStatus;
    /**
     * 
     * @type {ShopOrderOrderPaymentMethodDto}
     * @memberof ShopOrderOrderCreateDto
     */
    paymentMethod?: ShopOrderOrderPaymentMethodDto;
    /**
     * 
     * @type {ShopOrderInPostParcelMachineDetailsDto}
     * @memberof ShopOrderOrderCreateDto
     */
    inPostParcelMachineDetails?: ShopOrderInPostParcelMachineDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    shipmentId?: number | null;
    /**
     * 
     * @type {ShopOrderStage}
     * @memberof ShopOrderOrderCreateDto
     */
    shopOrderStage?: ShopOrderStage;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    discountCodeId?: number | null;
    /**
     * 
     * @type {ShopDiscountCodeDiscountCodeDto}
     * @memberof ShopOrderOrderCreateDto
     */
    shopDiscountCode?: ShopDiscountCodeDiscountCodeDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderCreateDto
     */
    refundsSum?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderCreateResultDto
 */
export interface ShopOrderOrderCreateResultDto {
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderCreateResultDto
     */
    paymentRedirectUri?: string | null;
    /**
     * 
     * @type {OrderCreateResult}
     * @memberof ShopOrderOrderCreateResultDto
     */
    orderCreateResult?: OrderCreateResult;
    /**
     * 
     * @type {ShopOrderPaymentMethod}
     * @memberof ShopOrderOrderCreateResultDto
     */
    orderPaymentMethod?: ShopOrderPaymentMethod;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderDeliveryVariantCostDto
 */
export interface ShopOrderOrderDeliveryVariantCostDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDeliveryVariantCostDto
     */
    deliveryCost?: number;
    /**
     * 
     * @type {ShopDeliveryMethod}
     * @memberof ShopOrderOrderDeliveryVariantCostDto
     */
    shopDeliveryMethod?: ShopDeliveryMethod;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderDetailsDto
 */
export interface ShopOrderOrderDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    clientId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ShopOrderOrderDetailsDto
     */
    client?: ApplicationUserDto;
    /**
     * 
     * @type {ShopOrderUnregisteredUserDataDto}
     * @memberof ShopOrderOrderDetailsDto
     */
    unregisteredUserData?: ShopOrderUnregisteredUserDataDto;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    optionalMessage?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    deliveryAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderDetailsDto
     */
    deliveryAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderOrderDetailsDto
     */
    deliveryAddressSameAsBillingAddress?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    billingAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderDetailsDto
     */
    billingAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    orderValue?: number;
    /**
     * 
     * @type {ShopDeliveryMethod}
     * @memberof ShopOrderOrderDetailsDto
     */
    shopDeliveryMethod?: ShopDeliveryMethod;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    deliveryCost?: number;
    /**
     * 
     * @type {ShopOrderPaymentStatus}
     * @memberof ShopOrderOrderDetailsDto
     */
    shopOrderPaymentStatus?: ShopOrderPaymentStatus;
    /**
     * 
     * @type {ShopOrderOrderPaymentMethodDto}
     * @memberof ShopOrderOrderDetailsDto
     */
    paymentMethod?: ShopOrderOrderPaymentMethodDto;
    /**
     * 
     * @type {ShopOrderInPostParcelMachineDetailsDto}
     * @memberof ShopOrderOrderDetailsDto
     */
    inPostParcelMachineDetails?: ShopOrderInPostParcelMachineDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    shipmentId?: number | null;
    /**
     * 
     * @type {ShopOrderStage}
     * @memberof ShopOrderOrderDetailsDto
     */
    shopOrderStage?: ShopOrderStage;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    discountCodeId?: number | null;
    /**
     * 
     * @type {ShopDiscountCodeDiscountCodeDto}
     * @memberof ShopOrderOrderDetailsDto
     */
    shopDiscountCode?: ShopDiscountCodeDiscountCodeDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    refundsSum?: number;
    /**
     * 
     * @type {Array<ShopOrderProductOrderProductDto>}
     * @memberof ShopOrderOrderDetailsDto
     */
    orderProducts?: Array<ShopOrderProductOrderProductDto> | null;
    /**
     * 
     * @type {Array<ShopOrderRefundOrderRefundDto>}
     * @memberof ShopOrderOrderDetailsDto
     */
    orderRefunds?: Array<ShopOrderRefundOrderRefundDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDetailsDto
     */
    payUOrderId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDetailsDto
     */
    orderOriginalValue?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderDto
 */
export interface ShopOrderOrderDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDto
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    clientId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ShopOrderOrderDto
     */
    client?: ApplicationUserDto;
    /**
     * 
     * @type {ShopOrderUnregisteredUserDataDto}
     * @memberof ShopOrderOrderDto
     */
    unregisteredUserData?: ShopOrderUnregisteredUserDataDto;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderDto
     */
    optionalMessage?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    deliveryAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderDto
     */
    deliveryAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderOrderDto
     */
    deliveryAddressSameAsBillingAddress?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    billingAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderDto
     */
    billingAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    orderValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    orderOriginalValue?: number;
    /**
     * 
     * @type {ShopDeliveryMethod}
     * @memberof ShopOrderOrderDto
     */
    shopDeliveryMethod?: ShopDeliveryMethod;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    deliveryCost?: number;
    /**
     * 
     * @type {ShopOrderPaymentStatus}
     * @memberof ShopOrderOrderDto
     */
    shopOrderPaymentStatus?: ShopOrderPaymentStatus;
    /**
     * 
     * @type {ShopOrderOrderPaymentMethodDto}
     * @memberof ShopOrderOrderDto
     */
    paymentMethod?: ShopOrderOrderPaymentMethodDto;
    /**
     * 
     * @type {ShopOrderInPostParcelMachineDetailsDto}
     * @memberof ShopOrderOrderDto
     */
    inPostParcelMachineDetails?: ShopOrderInPostParcelMachineDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    shipmentId?: number | null;
    /**
     * 
     * @type {ShopOrderStage}
     * @memberof ShopOrderOrderDto
     */
    shopOrderStage?: ShopOrderStage;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    discountCodeId?: number | null;
    /**
     * 
     * @type {ShopDiscountCodeDiscountCodeDto}
     * @memberof ShopOrderOrderDto
     */
    shopDiscountCode?: ShopDiscountCodeDiscountCodeDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderDto
     */
    refundsSum?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderMinimalDto
 */
export interface ShopOrderOrderMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {ShopOrderPaymentStatus}
     * @memberof ShopOrderOrderMinimalDto
     */
    shopOrderPaymentStatus?: ShopOrderPaymentStatus;
    /**
     * 
     * @type {ShopOrderStage}
     * @memberof ShopOrderOrderMinimalDto
     */
    shopOrderStage?: ShopOrderStage;
    /**
     * 
     * @type {ShopOrderOrderPaymentMethodDto}
     * @memberof ShopOrderOrderMinimalDto
     */
    paymentMethod?: ShopOrderOrderPaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderMinimalDto
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderMinimalDto
     */
    orderValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderMinimalDto
     */
    refundsSum?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderPaymentMethodDto
 */
export interface ShopOrderOrderPaymentMethodDto {
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderPaymentMethodDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderPaymentMethodDto
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderPlaceDto
 */
export interface ShopOrderOrderPlaceDto {
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderPlaceDto
     */
    basketId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderPlaceDto
     */
    turnstileToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderPlaceDto
     */
    optionalOrderMessage?: string | null;
}
/**
 * 
 * @export
 * @interface ShopOrderOrderUpdateDto
 */
export interface ShopOrderOrderUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderUpdateDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderUpdateDto
     */
    orderNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    clientId?: number | null;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof ShopOrderOrderUpdateDto
     */
    client?: ApplicationUserDto;
    /**
     * 
     * @type {ShopOrderUnregisteredUserDataDto}
     * @memberof ShopOrderOrderUpdateDto
     */
    unregisteredUserData?: ShopOrderUnregisteredUserDataDto;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderUpdateDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderUpdateDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderOrderUpdateDto
     */
    optionalMessage?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    deliveryAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderUpdateDto
     */
    deliveryAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderOrderUpdateDto
     */
    deliveryAddressSameAsBillingAddress?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    billingAddressId?: number | null;
    /**
     * 
     * @type {ShopAddressShopAddressDto}
     * @memberof ShopOrderOrderUpdateDto
     */
    billingAddress?: ShopAddressShopAddressDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    orderValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    orderOriginalValue?: number;
    /**
     * 
     * @type {ShopDeliveryMethod}
     * @memberof ShopOrderOrderUpdateDto
     */
    shopDeliveryMethod?: ShopDeliveryMethod;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    deliveryCost?: number;
    /**
     * 
     * @type {ShopOrderPaymentStatus}
     * @memberof ShopOrderOrderUpdateDto
     */
    shopOrderPaymentStatus?: ShopOrderPaymentStatus;
    /**
     * 
     * @type {ShopOrderOrderPaymentMethodDto}
     * @memberof ShopOrderOrderUpdateDto
     */
    paymentMethod?: ShopOrderOrderPaymentMethodDto;
    /**
     * 
     * @type {ShopOrderInPostParcelMachineDetailsDto}
     * @memberof ShopOrderOrderUpdateDto
     */
    inPostParcelMachineDetails?: ShopOrderInPostParcelMachineDetailsDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    shipmentId?: number | null;
    /**
     * 
     * @type {ShopOrderStage}
     * @memberof ShopOrderOrderUpdateDto
     */
    shopOrderStage?: ShopOrderStage;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    discountCodeId?: number | null;
    /**
     * 
     * @type {ShopDiscountCodeDiscountCodeDto}
     * @memberof ShopOrderOrderUpdateDto
     */
    shopDiscountCode?: ShopDiscountCodeDiscountCodeDto;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderOrderUpdateDto
     */
    refundsSum?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderPaymentMethod
 */
export interface ShopOrderPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof ShopOrderPaymentMethod
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderPaymentMethod
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ShopOrderPaymentStatus {
    Pending = 'Pending',
    WaitingForConfirmation = 'WaitingForConfirmation',
    Completed = 'Completed',
    Canceled = 'Canceled'
}

/**
 * 
 * @export
 * @interface ShopOrderProductOrderProductCreateDto
 */
export interface ShopOrderProductOrderProductCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    isElectronic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    productDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductCreateDto
     */
    productPreviewImageId?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderProductOrderProductDetailsDto
 */
export interface ShopOrderProductOrderProductDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    productId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    isElectronic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    productDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDetailsDto
     */
    productPreviewImageId?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderProductOrderProductDto
 */
export interface ShopOrderProductOrderProductDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    productId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderProductOrderProductDto
     */
    isElectronic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductDto
     */
    productDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductDto
     */
    productPreviewImageId?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderProductOrderProductStockUpdateDto
 */
export interface ShopOrderProductOrderProductStockUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductStockUpdateDto
     */
    orderId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderProductOrderProductStockUpdateDto
     */
    shouldUpdateStock?: boolean;
}
/**
 * 
 * @export
 * @interface ShopOrderProductOrderProductUpdateDto
 */
export interface ShopOrderProductOrderProductUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    isElectronic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    productDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderProductOrderProductUpdateDto
     */
    productPreviewImageId?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderRefundOrderRefundCreateDto
 */
export interface ShopOrderRefundOrderRefundCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    refundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    creationDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    extRefundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    statusCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    statusDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    statusDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundCreateDto
     */
    orderId?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderRefundOrderRefundDetailsDto
 */
export interface ShopOrderRefundOrderRefundDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    refundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    creationDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    extRefundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    statusCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    statusDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    statusDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    orderId?: number;
    /**
     * 
     * @type {ShopOrderOrderDto}
     * @memberof ShopOrderRefundOrderRefundDetailsDto
     */
    shopOrder?: ShopOrderOrderDto;
}
/**
 * 
 * @export
 * @interface ShopOrderRefundOrderRefundDto
 */
export interface ShopOrderRefundOrderRefundDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    refundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    creationDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    extRefundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    statusCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    statusDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    statusDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundDto
     */
    orderId?: number;
}
/**
 * 
 * @export
 * @interface ShopOrderRefundOrderRefundUpdateDto
 */
export interface ShopOrderRefundOrderRefundUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    refundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    creationDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    extRefundId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    statusCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    statusDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    statusDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    orderGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopOrderRefundOrderRefundUpdateDto
     */
    orderId?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ShopOrderSortDirection {
    DateAscending = 'DateAscending',
    DateDescending = 'DateDescending',
    CostAscending = 'CostAscending',
    CostDescending = 'CostDescending',
    OrderState = 'OrderState'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ShopOrderStage {
    Abandoned = 'Abandoned',
    New = 'New',
    WaitingForPayment = 'WaitingForPayment',
    Paid = 'Paid',
    Confirmed = 'Confirmed',
    Sent = 'Sent',
    Delivered = 'Delivered',
    Canceled = 'Canceled'
}

/**
 * 
 * @export
 * @interface ShopOrderUnregisteredUserDataDto
 */
export interface ShopOrderUnregisteredUserDataDto {
    /**
     * 
     * @type {string}
     * @memberof ShopOrderUnregisteredUserDataDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopOrderUnregisteredUserDataDto
     */
    lastName?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductDetailProductDetailCreateDto
 */
export interface ShopProductDetailProductDetailCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailCreateDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductDetailProductDetailDetailsDto
 */
export interface ShopProductDetailProductDetailDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDetailsDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductDetailProductDetailDto
 */
export interface ShopProductDetailProductDetailDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductDetailProductDetailUpdateDto
 */
export interface ShopProductDetailProductDetailUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductDetailProductDetailUpdateDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductImageProductImageDetailsDto
 */
export interface ShopProductImageProductImageDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    contentType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDetailsDto
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface ShopProductImageProductImageDto
 */
export interface ShopProductImageProductImageDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDto
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageDto
     */
    fileName?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductImageProductImageUpdateDto
 */
export interface ShopProductImageProductImageUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    contentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductImageProductImageUpdateDto
     */
    blobName?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductPriceProductPriceCreateDto
 */
export interface ShopProductPriceProductPriceCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    unitValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    taxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    unitStock?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceCreateDto
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface ShopProductPriceProductPriceDetailsDto
 */
export interface ShopProductPriceProductPriceDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    unitValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    taxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    unitStock?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDetailsDto
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface ShopProductPriceProductPriceDto
 */
export interface ShopProductPriceProductPriceDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDto
     */
    unitValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDto
     */
    taxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDto
     */
    unitStock?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceDto
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface ShopProductPriceProductPriceForShopDto
 */
export interface ShopProductPriceProductPriceForShopDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceForShopDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceForShopDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceForShopDto
     */
    unitValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceForShopDto
     */
    unitStock?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceForShopDto
     */
    taxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceForShopDto
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface ShopProductPriceProductPriceUpdateDto
 */
export interface ShopProductPriceProductPriceUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    unitValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    taxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    unitStock?: number;
    /**
     * 
     * @type {number}
     * @memberof ShopProductPriceProductPriceUpdateDto
     */
    productId?: number;
}
/**
 * 
 * @export
 * @interface ShopProductProductCreateDto
 */
export interface ShopProductProductCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductCreateDto
     */
    wineVariety?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopProductProductCreateDto
     */
    isElectronicProduct?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductCreateDto
     */
    categoriesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopCategoryCategoryDto>}
     * @memberof ShopProductProductCreateDto
     */
    categories?: Array<ShopCategoryCategoryDto> | null;
    /**
     * 
     * @type {Array<ShopProductPriceProductPriceDto>}
     * @memberof ShopProductProductCreateDto
     */
    prices?: Array<ShopProductPriceProductPriceDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductCreateDto
     */
    imagesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopProductImageProductImageDto>}
     * @memberof ShopProductProductCreateDto
     */
    productImageDtos?: Array<ShopProductImageProductImageDto> | null;
    /**
     * 
     * @type {Array<ShopProductDetailProductDetailDto>}
     * @memberof ShopProductProductCreateDto
     */
    details?: Array<ShopProductDetailProductDetailDto> | null;
    /**
     * 
     * @type {Array<ShopProductStatisticProductStatisticsDto>}
     * @memberof ShopProductProductCreateDto
     */
    statistics?: Array<ShopProductStatisticProductStatisticsDto> | null;
    /**
     * 
     * @type {Array<ShopTagTagDto>}
     * @memberof ShopProductProductCreateDto
     */
    tags?: Array<ShopTagTagDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductCreateDto
     */
    tagsIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopProductProductDetailsDto
 */
export interface ShopProductProductDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDetailsDto
     */
    wineVariety?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopProductProductDetailsDto
     */
    isElectronicProduct?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductDetailsDto
     */
    categoriesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopCategoryCategoryDto>}
     * @memberof ShopProductProductDetailsDto
     */
    categories?: Array<ShopCategoryCategoryDto> | null;
    /**
     * 
     * @type {Array<ShopProductPriceProductPriceDto>}
     * @memberof ShopProductProductDetailsDto
     */
    prices?: Array<ShopProductPriceProductPriceDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductDetailsDto
     */
    imagesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopProductImageProductImageDto>}
     * @memberof ShopProductProductDetailsDto
     */
    productImageDtos?: Array<ShopProductImageProductImageDto> | null;
    /**
     * 
     * @type {Array<ShopProductDetailProductDetailDto>}
     * @memberof ShopProductProductDetailsDto
     */
    details?: Array<ShopProductDetailProductDetailDto> | null;
    /**
     * 
     * @type {Array<ShopProductStatisticProductStatisticsDto>}
     * @memberof ShopProductProductDetailsDto
     */
    statistics?: Array<ShopProductStatisticProductStatisticsDto> | null;
    /**
     * 
     * @type {Array<ShopTagTagDto>}
     * @memberof ShopProductProductDetailsDto
     */
    tags?: Array<ShopTagTagDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductDetailsDto
     */
    tagsIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopProductImageProductImageDto>}
     * @memberof ShopProductProductDetailsDto
     */
    images?: Array<ShopProductImageProductImageDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShopProductProductDetailsDto
     */
    imagesUrls?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ShopProductProductDto
 */
export interface ShopProductProductDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductDto
     */
    wineVariety?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopProductProductDto
     */
    isElectronicProduct?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductDto
     */
    categoriesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopCategoryCategoryDto>}
     * @memberof ShopProductProductDto
     */
    categories?: Array<ShopCategoryCategoryDto> | null;
    /**
     * 
     * @type {Array<ShopProductPriceProductPriceDto>}
     * @memberof ShopProductProductDto
     */
    prices?: Array<ShopProductPriceProductPriceDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductDto
     */
    imagesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ShopProductImageProductImageDto>}
     * @memberof ShopProductProductDto
     */
    productImageDtos?: Array<ShopProductImageProductImageDto> | null;
    /**
     * 
     * @type {Array<ShopProductDetailProductDetailDto>}
     * @memberof ShopProductProductDto
     */
    details?: Array<ShopProductDetailProductDetailDto> | null;
    /**
     * 
     * @type {Array<ShopProductStatisticProductStatisticsDto>}
     * @memberof ShopProductProductDto
     */
    statistics?: Array<ShopProductStatisticProductStatisticsDto> | null;
    /**
     * 
     * @type {Array<ShopTagTagDto>}
     * @memberof ShopProductProductDto
     */
    tags?: Array<ShopTagTagDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductDto
     */
    tagsIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopProductProductTagsUpdateDto
 */
export interface ShopProductProductTagsUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductTagsUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductTagsUpdateDto
     */
    tagsIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopProductProductUpdateDto
 */
export interface ShopProductProductUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductProductUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductProductUpdateDto
     */
    wineVariety?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopProductProductUpdateDto
     */
    isElectronicProduct?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductUpdateDto
     */
    categoriesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductUpdateDto
     */
    imagesIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopProductProductUpdateDto
     */
    tagsIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ShopProductStatisticProductStatisticsCreateDto
 */
export interface ShopProductStatisticProductStatisticsCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsCreateDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductStatisticProductStatisticsDetailsDto
 */
export interface ShopProductStatisticProductStatisticsDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDetailsDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductStatisticProductStatisticsDto
 */
export interface ShopProductStatisticProductStatisticsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopProductStatisticProductStatisticsUpdateDto
 */
export interface ShopProductStatisticProductStatisticsUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    header?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShopProductStatisticProductStatisticsUpdateDto
     */
    content?: string | null;
}
/**
 * 
 * @export
 * @interface ShopTagTagCreateDto
 */
export interface ShopTagTagCreateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopTagTagCreateDto
     */
    productsIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagCreateDto
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface ShopTagTagDetailsDto
 */
export interface ShopTagTagDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopTagTagDetailsDto
     */
    productsIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagDetailsDto
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface ShopTagTagDto
 */
export interface ShopTagTagDto {
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopTagTagDto
     */
    productsIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagDto
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface ShopTagTagUpdateDto
 */
export interface ShopTagTagUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShopTagTagUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShopTagTagUpdateDto
     */
    productsIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof ShopTagTagUpdateDto
     */
    value?: string | null;
}
/**
 * 
 * @export
 * @interface SimpleBaseUnitDto
 */
export interface SimpleBaseUnitDto {
    /**
     * 
     * @type {number}
     * @memberof SimpleBaseUnitDto
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBaseUnitDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleBaseUnitDto
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimpleBaseUnitDto
     */
    conversionToBase?: number | null;
}
/**
 * 
 * @export
 * @interface StockDto
 */
export interface StockDto {
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    productId?: number;
    /**
     * 
     * @type {ProductDto}
     * @memberof StockDto
     */
    product?: ProductDto;
    /**
     * 
     * @type {string}
     * @memberof StockDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    unitId?: number;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof StockDto
     */
    unit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof StockDto
     */
    reservedQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockDto
     */
    lastChangedAt?: string | null;
}
/**
 * 
 * @export
 * @interface StockHistoryMinimalDto
 */
export interface StockHistoryMinimalDto {
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockHistoryMinimalDto
     */
    operationType?: StockOperationType;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    operationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    unitId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    unitCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {number}
     * @memberof StockHistoryMinimalDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockHistoryMinimalDto
     */
    isSourceWarehouse?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    warehouseName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockHistoryMinimalDto
     */
    destinationWarehouseName?: string | null;
}
/**
 * 
 * @export
 * @interface StockMcpDto
 */
export interface StockMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    productName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    warehouseName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    unitId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    unitName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof StockMcpDto
     */
    reservedQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    batchNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockMcpDto
     */
    lastChangedAt?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationCreateDto
 */
export interface StockOperationCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationCreateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationCreateDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationCreateDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationCreateDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailCreateDto>}
     * @memberof StockOperationCreateDto
     */
    stockOperationDetails?: Array<StockOperationDetailCreateDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationCreateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationCreateDto>}
     * @memberof StockOperationCreateDto
     */
    stockOperations?: Array<StockOperationCreateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationCreateDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationCreateDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationCreateDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationCreateDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationCreateDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationCreateDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationCreateDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationCreateDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationCreateDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationDetailCreateDto
 */
export interface StockOperationDetailCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailCreateDto
     */
    pipedriveDealProductId?: number | null;
    /**
     * 
     * @type {Array<BatchNumberCreateDto>}
     * @memberof StockOperationDetailCreateDto
     */
    batchNumbers?: Array<BatchNumberCreateDto> | null;
}
/**
 * 
 * @export
 * @interface StockOperationDetailDto
 */
export interface StockOperationDetailDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {ProductDto}
     * @memberof StockOperationDetailDto
     */
    product?: ProductDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailDto
     */
    pipedriveDealProductId?: number | null;
    /**
     * 
     * @type {Array<BatchNumberDto>}
     * @memberof StockOperationDetailDto
     */
    batchNumbers?: Array<BatchNumberDto> | null;
}
/**
 * 
 * @export
 * @interface StockOperationDetailsDto
 */
export interface StockOperationDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDetailsDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationDetailsDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationDetailsDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDetailsDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailDto>}
     * @memberof StockOperationDetailsDto
     */
    stockOperationDetails?: Array<StockOperationDetailDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationDetailsDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof StockOperationDetailsDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationDetailsDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationDetailsDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationDetailsDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationDetailsDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationDetailsDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailsDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDetailsDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDetailsDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDetailsDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationDto
 */
export interface StockOperationDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailDto>}
     * @memberof StockOperationDto
     */
    stockOperationDetails?: Array<StockOperationDetailDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof StockOperationDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationHistoryValues {
    Date = 'Date',
    Type = 'Type',
    Status = 'Status',
    Product = 'Product',
    Quantity = 'Quantity',
    Operation = 'Operation',
    Contractor = 'Contractor',
    BatchNumber = 'BatchNumber',
    DocumentNumber = 'DocumentNumber',
    StockOperationDetail = 'StockOperationDetail'
}

/**
 * 
 * @export
 * @interface StockOperationMcpDto
 */
export interface StockOperationMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    productName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMcpDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMcpDto
     */
    contractorName?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationMinimalDto
 */
export interface StockOperationMinimalDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationMinimalDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationMinimalDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationMinimalDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationMinimalDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalDto
     */
    isOrder?: boolean;
}
/**
 * 
 * @export
 * @interface StockOperationMinimalWithWarehouseDto
 */
export interface StockOperationMinimalWithWarehouseDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    date?: string;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {Array<StockOperationMinimalWithWarehouseDto>}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    stockOperations?: Array<StockOperationMinimalWithWarehouseDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationMinimalWithWarehouseDto
     */
    isOrder?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationStage {
    Harvest = 'Harvest',
    Embossing = 'Embossing',
    Transfer = 'Transfer',
    Racking = 'Racking',
    Fermentation = 'Fermentation',
    Stabilization = 'Stabilization',
    Bottling = 'Bottling',
    Labeling = 'Labeling'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationStatus {
    Draft = 'Draft',
    ForCompletion = 'ForCompletion',
    Published = 'Published'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StockOperationType {
    Pz = 'PZ',
    Wz = 'WZ',
    Mm = 'MM',
    Pw = 'PW',
    Rw = 'RW',
    Opp = 'OPP',
    Opw = 'OPW',
    Oi = 'OI',
    Vn = 'VN'
}

/**
 * 
 * @export
 * @interface StockOperationUpdateDto
 */
export interface StockOperationUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    warehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationUpdateDto
     */
    warehouse?: WarehouseDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    contractorId?: number | null;
    /**
     * 
     * @type {ContractorDto}
     * @memberof StockOperationUpdateDto
     */
    contractor?: ContractorDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    destinationWarehouseId?: number | null;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof StockOperationUpdateDto
     */
    destinationWarehouse?: WarehouseDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<StockOperationDetailDto>}
     * @memberof StockOperationUpdateDto
     */
    stockOperationDetails?: Array<StockOperationDetailDto> | null;
    /**
     * 
     * @type {StockOperationStatus}
     * @memberof StockOperationUpdateDto
     */
    status?: StockOperationStatus;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    publicationDate?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    parentStockOperationId?: number | null;
    /**
     * 
     * @type {Array<StockOperationDto>}
     * @memberof StockOperationUpdateDto
     */
    stockOperations?: Array<StockOperationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    productionProcessId?: number | null;
    /**
     * 
     * @type {ProductionProcessMinimalDto}
     * @memberof StockOperationUpdateDto
     */
    productionProcess?: ProductionProcessMinimalDto;
    /**
     * 
     * @type {StockOperationStage}
     * @memberof StockOperationUpdateDto
     */
    stage?: StockOperationStage;
    /**
     * 
     * @type {CropDto}
     * @memberof StockOperationUpdateDto
     */
    crop?: CropDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {Array<VinificationAdditiveDto>}
     * @memberof StockOperationUpdateDto
     */
    vinificationAdditives?: Array<VinificationAdditiveDto> | null;
    /**
     * 
     * @type {ApplicationUserMinimalDto}
     * @memberof StockOperationUpdateDto
     */
    createdBy?: ApplicationUserMinimalDto;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationUpdateDto
     */
    isOrder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StockOperationUpdateDto
     */
    hasRelatedInvoice?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateDto
     */
    pipedriveDealId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateDto
     */
    pipedriveNote?: string | null;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryCreateDto
 */
export interface StockOperationUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryCreateDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryDetailsDto
 */
export interface StockOperationUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperation?: StockOperationDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    type?: StockOperationType;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    quantity?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    unit?: UnitOfMeasureDto;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    documentNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    internalStockOperationWarehouseSourceId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDetailsDto
     */
    internalStockOperationWarehouseDestinationId?: number | null;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryDto
 */
export interface StockOperationUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface StockOperationUpdateHistoryUpdateDto
 */
export interface StockOperationUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationDetailId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
    /**
     * 
     * @type {BatchNumberDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    batchNumber?: BatchNumberDto;
    /**
     * 
     * @type {StockOperationDetailDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationDetail?: StockOperationDetailDto;
    /**
     * 
     * @type {StockOperationHistoryValues}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    changedValueName?: StockOperationHistoryValues;
    /**
     * 
     * @type {StockOperationType}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperationType?: StockOperationType;
    /**
     * 
     * @type {StockOperationDto}
     * @memberof StockOperationUpdateHistoryUpdateDto
     */
    stockOperation?: StockOperationDto;
}
/**
 * 
 * @export
 * @interface StrainCreateDto
 */
export interface StrainCreateDto {
    /**
     * 
     * @type {number}
     * @memberof StrainCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainCreateDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface StrainDetailsDto
 */
export interface StrainDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof StrainDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<ProductionProcessDto>}
     * @memberof StrainDetailsDto
     */
    productionProcesses?: Array<ProductionProcessDto> | null;
    /**
     * 
     * @type {Array<CropDto>}
     * @memberof StrainDetailsDto
     */
    crops?: Array<CropDto> | null;
    /**
     * 
     * @type {Array<CropStrainMinimalDto>}
     * @memberof StrainDetailsDto
     */
    cropStrains?: Array<CropStrainMinimalDto> | null;
}
/**
 * 
 * @export
 * @interface StrainDto
 */
export interface StrainDto {
    /**
     * 
     * @type {number}
     * @memberof StrainDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface StrainMcpDto
 */
export interface StrainMcpDto {
    /**
     * 
     * @type {number}
     * @memberof StrainMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainMcpDto
     */
    cropId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainMcpDto
     */
    cropName?: string | null;
}
/**
 * 
 * @export
 * @interface StrainUpdateDto
 */
export interface StrainUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof StrainUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof StrainUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StrainUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StrainUpdateDto
     */
    description?: string | null;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureCreateDto
 */
export interface UnitOfMeasureCreateDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureCreateDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureCreateDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureCreateDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureCreateDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureDetailsDto
 */
export interface UnitOfMeasureDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDetailsDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureDetailsDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureDetailsDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof UnitOfMeasureDetailsDto
     */
    baseUnitProducts?: Array<ProductDto> | null;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof UnitOfMeasureDetailsDto
     */
    auxilaryUnitsProducts?: Array<ProductDto> | null;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureDto
 */
export interface UnitOfMeasureDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface UnitOfMeasureUpdateDto
 */
export interface UnitOfMeasureUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitOfMeasureUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    conversionToBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitOfMeasureUpdateDto
     */
    baseUnitId?: number | null;
    /**
     * 
     * @type {SimpleBaseUnitDto}
     * @memberof UnitOfMeasureUpdateDto
     */
    baseUnit?: SimpleBaseUnitDto;
    /**
     * 
     * @type {Array<UnitOfMeasureDto>}
     * @memberof UnitOfMeasureUpdateDto
     */
    auxiliaryUnits?: Array<UnitOfMeasureDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitOfMeasureUpdateDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveCreateDto
 */
export interface VinificationAdditiveCreateDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveCreateDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveCreateDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveCreateDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveDetailsDto
 */
export interface VinificationAdditiveDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDetailsDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDetailsDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveDetailsDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveDto
 */
export interface VinificationAdditiveDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface VinificationAdditiveUpdateDto
 */
export interface VinificationAdditiveUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    stockOperationId?: number;
    /**
     * 
     * @type {string}
     * @memberof VinificationAdditiveUpdateDto
     */
    additiveName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof VinificationAdditiveUpdateDto
     */
    unitId?: number;
    /**
     * 
     * @type {UnitOfMeasureDto}
     * @memberof VinificationAdditiveUpdateDto
     */
    unit?: UnitOfMeasureDto;
}
/**
 * 
 * @export
 * @interface WarehouseCreateDto
 */
export interface WarehouseCreateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseCreateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseCreateDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseCreateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseCreateDto
     */
    type?: WarehouseType;
}
/**
 * 
 * @export
 * @interface WarehouseDetailsDto
 */
export interface WarehouseDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDetailsDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDetailsDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseDetailsDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseDetailsDto
     */
    type?: WarehouseType;
    /**
     * 
     * @type {WarehouseDto}
     * @memberof WarehouseDetailsDto
     */
    parentWarehouse?: WarehouseDto;
    /**
     * 
     * @type {Array<WarehouseDto>}
     * @memberof WarehouseDetailsDto
     */
    warehouses?: Array<WarehouseDto> | null;
}
/**
 * 
 * @export
 * @interface WarehouseDto
 */
export interface WarehouseDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseDto
     */
    type?: WarehouseType;
}
/**
 * 
 * @export
 * @interface WarehouseMcpDto
 */
export interface WarehouseMcpDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseMcpDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseMcpDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseMcpDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseMcpDto
     */
    isDeleted?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WarehouseType {
    Tank = 'Tank',
    Other = 'Other',
    FinishedProducts = 'FinishedProducts'
}

/**
 * 
 * @export
 * @interface WarehouseUpdateDto
 */
export interface WarehouseUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateDto
     */
    parentWarehouseId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseUpdateDto
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {WarehouseType}
     * @memberof WarehouseUpdateDto
     */
    type?: WarehouseType;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryCreateDto
 */
export interface WarehouseUpdateHistoryCreateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryCreateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryDetailsDto
 */
export interface WarehouseUpdateHistoryDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDetailsDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryDto
 */
export interface WarehouseUpdateHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @interface WarehouseUpdateHistoryUpdateDto
 */
export interface WarehouseUpdateHistoryUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    createdById?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    updatedAt?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    updatedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    newValue?: string | null;
    /**
     * 
     * @type {OperationType}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    operationType?: OperationType;
    /**
     * 
     * @type {ApplicationUserDto}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    createdBy?: ApplicationUserDto;
    /**
     * 
     * @type {number}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    warehouseId?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseUpdateHistoryUpdateDto
     */
    translatedChangedValueName?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WineColor {
    Red = 'Red',
    White = 'White',
    Rose = 'Rose',
    Orange = 'Orange'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum WineSweetness {
    Dry = 'Dry',
    SemiDry = 'SemiDry',
    SemiSweet = 'SemiSweet',
    Sweet = 'Sweet'
}


/**
 * ApplicationUserApi - axios parameter creator
 * @export
 */
export const ApplicationUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [auth0UserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDelete: async (auth0UserId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (auth0UserId !== undefined) {
                localVarQueryParameter['auth0UserId'] = auth0UserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserInviteUserPost: async (applicationUserRegisterDto?: ApplicationUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/inviteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserMerchantsGet: async (userId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPingHead: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPut: async (userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsGet: async (userId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/userDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsMinimalGet: async (userId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/userDetailsMinimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUsersGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUser/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationUserApi - functional programming interface
 * @export
 */
export const ApplicationUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [auth0UserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserDelete(auth0UserId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserDelete(auth0UserId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserInviteUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserRegisterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserInviteUserPost(applicationUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserMerchantsGet(userId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserMerchantsGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserPingHead(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserPingHead(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserPut(userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserPut(userId, applicationUserRegisterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUserDetailsGet(userId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserRegisterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUserDetailsGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUserDetailsMinimalGet(userId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserBaseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUserDetailsMinimalGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUsersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUsersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationUserApi - factory interface
 * @export
 */
export const ApplicationUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationUserApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [auth0UserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserDelete(auth0UserId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserDelete(auth0UserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserGet(options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserInviteUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): AxiosPromise<ApplicationUserRegisterDto> {
            return localVarFp.apiApplicationUserInviteUserPost(applicationUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserMerchantsGet(userId?: number, options?: any): AxiosPromise<Array<ApplicationUserDto>> {
            return localVarFp.apiApplicationUserMerchantsGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPingHead(options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserPingHead(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserPut(userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any): AxiosPromise<ApplicationUserDetailsDto> {
            return localVarFp.apiApplicationUserPut(userId, applicationUserRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsGet(userId?: number, options?: any): AxiosPromise<ApplicationUserRegisterDto> {
            return localVarFp.apiApplicationUserUserDetailsGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUserDetailsMinimalGet(userId?: number, options?: any): AxiosPromise<ApplicationUserBaseDto> {
            return localVarFp.apiApplicationUserUserDetailsMinimalGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUsersGet(options?: any): AxiosPromise<Array<ApplicationUserDto>> {
            return localVarFp.apiApplicationUserUsersGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationUserApi - object-oriented interface
 * @export
 * @class ApplicationUserApi
 * @extends {BaseAPI}
 */
export class ApplicationUserApi extends BaseAPI {
    /**
     * 
     * @param {string} [auth0UserId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserDelete(auth0UserId?: string, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserDelete(auth0UserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserGet(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserInviteUserPost(applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserInviteUserPost(applicationUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserMerchantsGet(userId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserMerchantsGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserPingHead(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserPingHead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {ApplicationUserRegisterDto} [applicationUserRegisterDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserPut(userId?: number, applicationUserRegisterDto?: ApplicationUserRegisterDto, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserPut(userId, applicationUserRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserUserDetailsGet(userId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserUserDetailsGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserUserDetailsMinimalGet(userId?: number, options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserUserDetailsMinimalGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserApi
     */
    public apiApplicationUserUsersGet(options?: any) {
        return ApplicationUserApiFp(this.configuration).apiApplicationUserUsersGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApplicationUserUpdateHistoryApi - axios parameter creator
 * @export
 */
export const ApplicationUserUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUserUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryHistoryUserIdGet: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryHistoryUserIdGet', 'userId', userId)
            const localVarPath = `/api/ApplicationUserUpdateHistory/history/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/ApplicationUserUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/ApplicationUserUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdPut: async (id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiApplicationUserUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/ApplicationUserUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryPost: async (applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicationUserUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationUserUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationUserUpdateHistoryApi - functional programming interface
 * @export
 */
export const ApplicationUserUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationUserUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryHistoryUserIdGet(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationUserUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryHistoryUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryIdPut(id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryIdPut(id, applicationUserUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationUserUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationUserUpdateHistoryApi - factory interface
 * @export
 */
export const ApplicationUserUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationUserUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryGet(options?: any): AxiosPromise<Array<ApplicationUserUpdateHistoryDto>> {
            return localVarFp.apiApplicationUserUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryHistoryUserIdGet(userId: number, options?: any): AxiosPromise<Array<ApplicationUserUpdateHistoryDto>> {
            return localVarFp.apiApplicationUserUpdateHistoryHistoryUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiApplicationUserUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<ApplicationUserUpdateHistoryDetailsDto> {
            return localVarFp.apiApplicationUserUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryIdPut(id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options?: any): AxiosPromise<ApplicationUserUpdateHistoryDetailsDto> {
            return localVarFp.apiApplicationUserUpdateHistoryIdPut(id, applicationUserUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options?: any): AxiosPromise<ApplicationUserUpdateHistoryDetailsDto> {
            return localVarFp.apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationUserUpdateHistoryApi - object-oriented interface
 * @export
 * @class ApplicationUserUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class ApplicationUserUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryGet(options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryHistoryUserIdGet(userId: number, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryHistoryUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryIdDelete(id: number, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryIdGet(id: number, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ApplicationUserUpdateHistoryUpdateDto} [applicationUserUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryIdPut(id: number, applicationUserUpdateHistoryUpdateDto?: ApplicationUserUpdateHistoryUpdateDto, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryIdPut(id, applicationUserUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApplicationUserUpdateHistoryCreateDto} [applicationUserUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationUserUpdateHistoryApi
     */
    public apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto?: ApplicationUserUpdateHistoryCreateDto, options?: any) {
        return ApplicationUserUpdateHistoryApiFp(this.configuration).apiApplicationUserUpdateHistoryPost(applicationUserUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyDataApi - axios parameter creator
 * @export
 */
export const CompanyDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataIdDelete', 'id', id)
            const localVarPath = `/api/CompanyData/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataIdGet', 'id', id)
            const localVarPath = `/api/CompanyData/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdPut: async (id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataIdPut', 'id', id)
            const localVarPath = `/api/CompanyData/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataMinimalGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyData/minimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyDataCreateDto} [companyDataCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataPost: async (companyDataCreateDto?: CompanyDataCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyDataApi - functional programming interface
 * @export
 */
export const CompanyDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataIdPut(id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataIdPut(id, companyDataUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataMinimalGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataMinimalGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompanyDataCreateDto} [companyDataCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataPost(companyDataCreateDto?: CompanyDataCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataPost(companyDataCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyDataApi - factory interface
 * @export
 */
export const CompanyDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyDataApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataGet(options?: any): AxiosPromise<Array<CompanyDataDto>> {
            return localVarFp.apiCompanyDataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyDataIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdGet(id: number, options?: any): AxiosPromise<CompanyDataDetailsDto> {
            return localVarFp.apiCompanyDataIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataIdPut(id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options?: any): AxiosPromise<CompanyDataDetailsDto> {
            return localVarFp.apiCompanyDataIdPut(id, companyDataUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataMinimalGet(options?: any): AxiosPromise<CompanyDataMinimalDto> {
            return localVarFp.apiCompanyDataMinimalGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyDataCreateDto} [companyDataCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataPost(companyDataCreateDto?: CompanyDataCreateDto, options?: any): AxiosPromise<CompanyDataDetailsDto> {
            return localVarFp.apiCompanyDataPost(companyDataCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyDataApi - object-oriented interface
 * @export
 * @class CompanyDataApi
 * @extends {BaseAPI}
 */
export class CompanyDataApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataGet(options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataIdDelete(id: number, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataIdGet(id: number, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CompanyDataUpdateDto} [companyDataUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataIdPut(id: number, companyDataUpdateDto?: CompanyDataUpdateDto, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataIdPut(id, companyDataUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataMinimalGet(options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataMinimalGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyDataCreateDto} [companyDataCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataApi
     */
    public apiCompanyDataPost(companyDataCreateDto?: CompanyDataCreateDto, options?: any) {
        return CompanyDataApiFp(this.configuration).apiCompanyDataPost(companyDataCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyDataUpdateHistoryApi - axios parameter creator
 * @export
 */
export const CompanyDataUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyDataUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/CompanyDataUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/CompanyDataUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdPut: async (id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCompanyDataUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/CompanyDataUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryPost: async (companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CompanyDataUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyDataUpdateHistoryApi - functional programming interface
 * @export
 */
export const CompanyDataUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyDataUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanyDataUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryIdPut(id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryIdPut(id, companyDataUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDataUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyDataUpdateHistoryApi - factory interface
 * @export
 */
export const CompanyDataUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyDataUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryGet(options?: any): AxiosPromise<Array<CompanyDataUpdateHistoryDto>> {
            return localVarFp.apiCompanyDataUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCompanyDataUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<CompanyDataUpdateHistoryDetailsDto> {
            return localVarFp.apiCompanyDataUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryIdPut(id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options?: any): AxiosPromise<CompanyDataUpdateHistoryDetailsDto> {
            return localVarFp.apiCompanyDataUpdateHistoryIdPut(id, companyDataUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options?: any): AxiosPromise<CompanyDataUpdateHistoryDetailsDto> {
            return localVarFp.apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyDataUpdateHistoryApi - object-oriented interface
 * @export
 * @class CompanyDataUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class CompanyDataUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryGet(options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryIdDelete(id: number, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryIdGet(id: number, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CompanyDataUpdateHistoryUpdateDto} [companyDataUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryIdPut(id: number, companyDataUpdateHistoryUpdateDto?: CompanyDataUpdateHistoryUpdateDto, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryIdPut(id, companyDataUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyDataUpdateHistoryCreateDto} [companyDataUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyDataUpdateHistoryApi
     */
    public apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto?: CompanyDataUpdateHistoryCreateDto, options?: any) {
        return CompanyDataUpdateHistoryApiFp(this.configuration).apiCompanyDataUpdateHistoryPost(companyDataUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContractorApi - axios parameter creator
 * @export
 */
export const ContractorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} encodedAuth0Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorCalendarEncodedAuth0IdIcsGet: async (encodedAuth0Id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'encodedAuth0Id' is not null or undefined
            assertParamExists('apiContractorCalendarEncodedAuth0IdIcsGet', 'encodedAuth0Id', encodedAuth0Id)
            const localVarPath = `/api/Contractor/calendar/{encodedAuth0Id}.ics`
                .replace(`{${"encodedAuth0Id"}}`, encodeURIComponent(String(encodedAuth0Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Contractor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdDelete', 'id', id)
            const localVarPath = `/api/Contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdGet', 'id', id)
            const localVarPath = `/api/Contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdMeetingsGet', 'id', id)
            const localVarPath = `/api/Contractor/{id}/meetings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingDto} [meetingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPost: async (id: string, meetingDto?: MeetingDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdMeetingsPost', 'id', id)
            const localVarPath = `/api/Contractor/{id}/meetings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPut: async (id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdMeetingsPut', 'id', id)
            const localVarPath = `/api/Contractor/{id}/meetings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingChangeStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateDto} [contractorUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdPut: async (id: number, contractorUpdateDto?: ContractorUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorIdPut', 'id', id)
            const localVarPath = `/api/Contractor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {boolean} [isMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsDateGet: async (date: string, isMonth?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiContractorMeetingsDateGet', 'date', date)
            const localVarPath = `/api/Contractor/meetings/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (isMonth !== undefined) {
                localVarQueryParameter['isMonth'] = isMonth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsYearDateGet: async (date: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiContractorMeetingsYearDateGet', 'date', date)
            const localVarPath = `/api/Contractor/meetings/year/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} mineOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMineOnlyContractorsByMerchantGet: async (mineOnly: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mineOnly' is not null or undefined
            assertParamExists('apiContractorMineOnlyContractorsByMerchantGet', 'mineOnly', mineOnly)
            const localVarPath = `/api/Contractor/{mineOnly}/contractorsByMerchant`
                .replace(`{${"mineOnly"}}`, encodeURIComponent(String(mineOnly)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContractorCreateDto} [contractorCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorPost: async (contractorCreateDto?: ContractorCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Contractor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorApi - functional programming interface
 * @export
 */
export const ContractorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} encodedAuth0Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorCalendarEncodedAuth0IdIcsGet(encodedAuth0Id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorCalendarEncodedAuth0IdIcsGet(encodedAuth0Id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdMeetingsGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdMeetingsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingDto} [meetingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdMeetingsPost(id: string, meetingDto?: MeetingDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdMeetingsPost(id, meetingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdMeetingsPut(id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdMeetingsPut(id, meetingChangeStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateDto} [contractorUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorIdPut(id: number, contractorUpdateDto?: ContractorUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorIdPut(id, contractorUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {boolean} [isMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorMeetingsDateGet(date: string, isMonth?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorMeetingsDateGet(date, isMonth, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorMeetingsYearDateGet(date: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeetingDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorMeetingsYearDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} mineOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorMineOnlyContractorsByMerchantGet(mineOnly: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorMineOnlyContractorsByMerchantGet(mineOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ContractorCreateDto} [contractorCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorPost(contractorCreateDto?: ContractorCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorPost(contractorCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractorApi - factory interface
 * @export
 */
export const ContractorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorApiFp(configuration)
    return {
        /**
         * 
         * @param {string} encodedAuth0Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorCalendarEncodedAuth0IdIcsGet(encodedAuth0Id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorCalendarEncodedAuth0IdIcsGet(encodedAuth0Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorGet(options?: any): AxiosPromise<Array<ContractorDto>> {
            return localVarFp.apiContractorGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdGet(id: number, options?: any): AxiosPromise<ContractorDetailsDto> {
            return localVarFp.apiContractorIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsGet(id: number, options?: any): AxiosPromise<Array<MeetingDto>> {
            return localVarFp.apiContractorIdMeetingsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingDto} [meetingDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPost(id: string, meetingDto?: MeetingDto, options?: any): AxiosPromise<Array<MeetingDto>> {
            return localVarFp.apiContractorIdMeetingsPost(id, meetingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdMeetingsPut(id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options?: any): AxiosPromise<Array<MeetingDto>> {
            return localVarFp.apiContractorIdMeetingsPut(id, meetingChangeStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateDto} [contractorUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorIdPut(id: number, contractorUpdateDto?: ContractorUpdateDto, options?: any): AxiosPromise<ContractorDetailsDto> {
            return localVarFp.apiContractorIdPut(id, contractorUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {boolean} [isMonth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsDateGet(date: string, isMonth?: boolean, options?: any): AxiosPromise<Array<MeetingDetailsDto>> {
            return localVarFp.apiContractorMeetingsDateGet(date, isMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMeetingsYearDateGet(date: string, options?: any): AxiosPromise<Array<MeetingDetailsDto>> {
            return localVarFp.apiContractorMeetingsYearDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} mineOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorMineOnlyContractorsByMerchantGet(mineOnly: boolean, options?: any): AxiosPromise<Array<ContractorDto>> {
            return localVarFp.apiContractorMineOnlyContractorsByMerchantGet(mineOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractorCreateDto} [contractorCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorPost(contractorCreateDto?: ContractorCreateDto, options?: any): AxiosPromise<ContractorDetailsDto> {
            return localVarFp.apiContractorPost(contractorCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractorApi - object-oriented interface
 * @export
 * @class ContractorApi
 * @extends {BaseAPI}
 */
export class ContractorApi extends BaseAPI {
    /**
     * 
     * @param {string} encodedAuth0Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorCalendarEncodedAuth0IdIcsGet(encodedAuth0Id: string, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorCalendarEncodedAuth0IdIcsGet(encodedAuth0Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorGet(options?: any) {
        return ContractorApiFp(this.configuration).apiContractorGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdDelete(id: number, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdGet(id: number, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdMeetingsGet(id: number, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdMeetingsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {MeetingDto} [meetingDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdMeetingsPost(id: string, meetingDto?: MeetingDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdMeetingsPost(id, meetingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {MeetingChangeStatusDto} [meetingChangeStatusDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdMeetingsPut(id: string, meetingChangeStatusDto?: MeetingChangeStatusDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdMeetingsPut(id, meetingChangeStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ContractorUpdateDto} [contractorUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorIdPut(id: number, contractorUpdateDto?: ContractorUpdateDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorIdPut(id, contractorUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {boolean} [isMonth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorMeetingsDateGet(date: string, isMonth?: boolean, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorMeetingsDateGet(date, isMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorMeetingsYearDateGet(date: string, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorMeetingsYearDateGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} mineOnly 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorMineOnlyContractorsByMerchantGet(mineOnly: boolean, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorMineOnlyContractorsByMerchantGet(mineOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorCreateDto} [contractorCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorApi
     */
    public apiContractorPost(contractorCreateDto?: ContractorCreateDto, options?: any) {
        return ContractorApiFp(this.configuration).apiContractorPost(contractorCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContractorUpdateHistoryApi - axios parameter creator
 * @export
 */
export const ContractorUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ContractorUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdHistoryGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdHistoryGet', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdPut: async (id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/ContractorUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryPost: async (contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ContractorUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contractorUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorUpdateHistoryApi - functional programming interface
 * @export
 */
export const ContractorUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdHistoryGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdHistoryGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryIdPut(id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryIdPut(id, contractorUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractorUpdateHistoryApi - factory interface
 * @export
 */
export const ContractorUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryGet(options?: any): AxiosPromise<Array<ContractorUpdateHistoryDto>> {
            return localVarFp.apiContractorUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<ContractorUpdateHistoryDetailsDto> {
            return localVarFp.apiContractorUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdHistoryGet(id: number, options?: any): AxiosPromise<Array<ContractorUpdateHistoryDto>> {
            return localVarFp.apiContractorUpdateHistoryIdHistoryGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryIdPut(id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options?: any): AxiosPromise<ContractorUpdateHistoryDetailsDto> {
            return localVarFp.apiContractorUpdateHistoryIdPut(id, contractorUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options?: any): AxiosPromise<ContractorUpdateHistoryDetailsDto> {
            return localVarFp.apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractorUpdateHistoryApi - object-oriented interface
 * @export
 * @class ContractorUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class ContractorUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryGet(options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdDelete(id: number, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdGet(id: number, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdHistoryGet(id: number, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdHistoryGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ContractorUpdateHistoryUpdateDto} [contractorUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryIdPut(id: number, contractorUpdateHistoryUpdateDto?: ContractorUpdateHistoryUpdateDto, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryIdPut(id, contractorUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorUpdateHistoryCreateDto} [contractorUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorUpdateHistoryApi
     */
    public apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto?: ContractorUpdateHistoryCreateDto, options?: any) {
        return ContractorUpdateHistoryApiFp(this.configuration).apiContractorUpdateHistoryPost(contractorUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CropApi - axios parameter creator
 * @export
 */
export const CropApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Crop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCropIdDelete', 'id', id)
            const localVarPath = `/api/Crop/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCropIdGet', 'id', id)
            const localVarPath = `/api/Crop/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CropUpdateDto} [cropUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdPut: async (id: number, cropUpdateDto?: CropUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCropIdPut', 'id', id)
            const localVarPath = `/api/Crop/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cropUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CropCreateDto} [cropCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropPost: async (cropCreateDto?: CropCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Crop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cropCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CropApi - functional programming interface
 * @export
 */
export const CropApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CropApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CropDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CropDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {CropUpdateDto} [cropUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropIdPut(id: number, cropUpdateDto?: CropUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CropDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropIdPut(id, cropUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CropCreateDto} [cropCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCropPost(cropCreateDto?: CropCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CropDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCropPost(cropCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CropApi - factory interface
 * @export
 */
export const CropApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CropApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropGet(options?: any): AxiosPromise<Array<CropDto>> {
            return localVarFp.apiCropGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiCropIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdGet(id: number, options?: any): AxiosPromise<CropDetailsDto> {
            return localVarFp.apiCropIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CropUpdateDto} [cropUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropIdPut(id: number, cropUpdateDto?: CropUpdateDto, options?: any): AxiosPromise<CropDetailsDto> {
            return localVarFp.apiCropIdPut(id, cropUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CropCreateDto} [cropCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCropPost(cropCreateDto?: CropCreateDto, options?: any): AxiosPromise<CropDetailsDto> {
            return localVarFp.apiCropPost(cropCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CropApi - object-oriented interface
 * @export
 * @class CropApi
 * @extends {BaseAPI}
 */
export class CropApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropGet(options?: any) {
        return CropApiFp(this.configuration).apiCropGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropIdDelete(id: number, options?: any) {
        return CropApiFp(this.configuration).apiCropIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropIdGet(id: number, options?: any) {
        return CropApiFp(this.configuration).apiCropIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CropUpdateDto} [cropUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropIdPut(id: number, cropUpdateDto?: CropUpdateDto, options?: any) {
        return CropApiFp(this.configuration).apiCropIdPut(id, cropUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CropCreateDto} [cropCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CropApi
     */
    public apiCropPost(cropCreateDto?: CropCreateDto, options?: any) {
        return CropApiFp(this.configuration).apiCropPost(cropCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeployPageApi - axios parameter creator
 * @export
 */
export const DeployPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeployPageProjectsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deploy-page/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeployPageProjectsProjectNameDeployPost: async (projectName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('apiDeployPageProjectsProjectNameDeployPost', 'projectName', projectName)
            const localVarPath = `/api/deploy-page/projects/{projectName}/deploy`
                .replace(`{${"projectName"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeployPageApi - functional programming interface
 * @export
 */
export const DeployPageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeployPageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeployPageProjectsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeployPageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeployPageProjectsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} projectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeployPageProjectsProjectNameDeployPost(projectName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudflarePagesDeployment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeployPageProjectsProjectNameDeployPost(projectName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeployPageApi - factory interface
 * @export
 */
export const DeployPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeployPageApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeployPageProjectsGet(options?: any): AxiosPromise<Array<DeployPageDto>> {
            return localVarFp.apiDeployPageProjectsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeployPageProjectsProjectNameDeployPost(projectName: string, options?: any): AxiosPromise<CloudflarePagesDeployment> {
            return localVarFp.apiDeployPageProjectsProjectNameDeployPost(projectName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeployPageApi - object-oriented interface
 * @export
 * @class DeployPageApi
 * @extends {BaseAPI}
 */
export class DeployPageApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeployPageApi
     */
    public apiDeployPageProjectsGet(options?: any) {
        return DeployPageApiFp(this.configuration).apiDeployPageProjectsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeployPageApi
     */
    public apiDeployPageProjectsProjectNameDeployPost(projectName: string, options?: any) {
        return DeployPageApiFp(this.configuration).apiDeployPageProjectsProjectNameDeployPost(projectName, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InventoryOperationApi - axios parameter creator
 * @export
 */
export const InventoryOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InventoryOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdDelete', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdGet', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdPut: async (id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdPut', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inventoryOperationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdStatusPut: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiInventoryOperationIdStatusPut', 'id', id)
            const localVarPath = `/api/InventoryOperation/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationPost: async (inventoryOperationCreateDto?: InventoryOperationCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/InventoryOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inventoryOperationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryOperationApi - functional programming interface
 * @export
 */
export const InventoryOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryOperationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdPut(id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdPut(id, inventoryOperationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationIdStatusPut(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationIdStatusPut(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInventoryOperationPost(inventoryOperationCreateDto?: InventoryOperationCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInventoryOperationPost(inventoryOperationCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InventoryOperationApi - factory interface
 * @export
 */
export const InventoryOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryOperationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationGet(options?: any): AxiosPromise<Array<InventoryOperationDto>> {
            return localVarFp.apiInventoryOperationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiInventoryOperationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdGet(id: number, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdPut(id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationIdPut(id, inventoryOperationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationIdStatusPut(id: number, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationIdStatusPut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInventoryOperationPost(inventoryOperationCreateDto?: InventoryOperationCreateDto, options?: any): AxiosPromise<InventoryOperationDetailsDto> {
            return localVarFp.apiInventoryOperationPost(inventoryOperationCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryOperationApi - object-oriented interface
 * @export
 * @class InventoryOperationApi
 * @extends {BaseAPI}
 */
export class InventoryOperationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationGet(options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdDelete(id: number, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdGet(id: number, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {InventoryOperationUpdateDto} [inventoryOperationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdPut(id: number, inventoryOperationUpdateDto?: InventoryOperationUpdateDto, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdPut(id, inventoryOperationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationIdStatusPut(id: number, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationIdStatusPut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryOperationCreateDto} [inventoryOperationCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryOperationApi
     */
    public apiInventoryOperationPost(inventoryOperationCreateDto?: InventoryOperationCreateDto, options?: any) {
        return InventoryOperationApiFp(this.configuration).apiInventoryOperationPost(inventoryOperationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * McpApi - axios parameter creator
 * @export
 */
export const McpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCompanyDataGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/company-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataContractorsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/contractors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCropsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/crops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataInventoryOperationsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/inventory-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataProductsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStockOperationsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/stock-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStocksGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/stocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStrainsGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/strains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataUsersGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataWarehousesGet: async (page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp/data/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpOptions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpPost: async (mcpJsonRpcRequest?: McpJsonRpcRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/mcp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mcpJsonRpcRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * McpApi - functional programming interface
 * @export
 */
export const McpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = McpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataCompanyDataGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoCompanyDataMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataCompanyDataGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataContractorsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoContractorMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataContractorsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataCropsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoCropMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataCropsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataInventoryOperationsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoInventoryOperationMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataInventoryOperationsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataProductsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoProductMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataProductsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataStockOperationsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoStockOperationMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataStockOperationsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataStocksGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoStockMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataStocksGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataStrainsGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoStrainMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataStrainsGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataUsersGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoApplicationUserMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataUsersGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpDataWarehousesGet(page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedMcpDtoWarehouseMcpDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpDataWarehousesGet(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpOptions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mcpPost(mcpJsonRpcRequest?: McpJsonRpcRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mcpPost(mcpJsonRpcRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * McpApi - factory interface
 * @export
 */
export const McpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = McpApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCompanyDataGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoCompanyDataMcpDto> {
            return localVarFp.mcpDataCompanyDataGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataContractorsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoContractorMcpDto> {
            return localVarFp.mcpDataContractorsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataCropsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoCropMcpDto> {
            return localVarFp.mcpDataCropsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataInventoryOperationsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoInventoryOperationMcpDto> {
            return localVarFp.mcpDataInventoryOperationsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataProductsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoProductMcpDto> {
            return localVarFp.mcpDataProductsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStockOperationsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoStockOperationMcpDto> {
            return localVarFp.mcpDataStockOperationsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStocksGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoStockMcpDto> {
            return localVarFp.mcpDataStocksGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataStrainsGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoStrainMcpDto> {
            return localVarFp.mcpDataStrainsGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataUsersGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoApplicationUserMcpDto> {
            return localVarFp.mcpDataUsersGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpDataWarehousesGet(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedMcpDtoWarehouseMcpDto> {
            return localVarFp.mcpDataWarehousesGet(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpGet(options?: any): AxiosPromise<void> {
            return localVarFp.mcpGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpOptions(options?: any): AxiosPromise<void> {
            return localVarFp.mcpOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpPost(mcpJsonRpcRequest?: McpJsonRpcRequest, options?: any): AxiosPromise<void> {
            return localVarFp.mcpPost(mcpJsonRpcRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * McpApi - object-oriented interface
 * @export
 * @class McpApi
 * @extends {BaseAPI}
 */
export class McpApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataCompanyDataGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataCompanyDataGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataContractorsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataContractorsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataCropsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataCropsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataInventoryOperationsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataInventoryOperationsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataProductsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataProductsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataStockOperationsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataStockOperationsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataStocksGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataStocksGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataStrainsGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataStrainsGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataUsersGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataUsersGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpDataWarehousesGet(page?: number, pageSize?: number, options?: any) {
        return McpApiFp(this.configuration).mcpDataWarehousesGet(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpGet(options?: any) {
        return McpApiFp(this.configuration).mcpGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpOptions(options?: any) {
        return McpApiFp(this.configuration).mcpOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {McpJsonRpcRequest} [mcpJsonRpcRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpApi
     */
    public mcpPost(mcpJsonRpcRequest?: McpJsonRpcRequest, options?: any) {
        return McpApiFp(this.configuration).mcpPost(mcpJsonRpcRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PhysicochemicalTestApi - axios parameter creator
 * @export
 */
export const PhysicochemicalTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PhysicochemicalTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPhysicochemicalTestIdDelete', 'id', id)
            const localVarPath = `/api/PhysicochemicalTest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPhysicochemicalTestIdGet', 'id', id)
            const localVarPath = `/api/PhysicochemicalTest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdPut: async (id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPhysicochemicalTestIdPut', 'id', id)
            const localVarPath = `/api/PhysicochemicalTest/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicochemicalTestUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestPost: async (physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PhysicochemicalTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(physicochemicalTestCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestProductionProcessGet: async (productionProcessId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PhysicochemicalTest/ProductionProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (productionProcessId !== undefined) {
                localVarQueryParameter['productionProcessId'] = productionProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhysicochemicalTestApi - functional programming interface
 * @export
 */
export const PhysicochemicalTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhysicochemicalTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhysicochemicalTestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhysicochemicalTestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestIdPut(id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhysicochemicalTestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestIdPut(id, physicochemicalTestUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestPost(physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhysicochemicalTestDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestPost(physicochemicalTestCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPhysicochemicalTestProductionProcessGet(productionProcessId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhysicochemicalTestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPhysicochemicalTestProductionProcessGet(productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PhysicochemicalTestApi - factory interface
 * @export
 */
export const PhysicochemicalTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhysicochemicalTestApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestGet(options?: any): AxiosPromise<Array<PhysicochemicalTestDto>> {
            return localVarFp.apiPhysicochemicalTestGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiPhysicochemicalTestIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdGet(id: number, options?: any): AxiosPromise<PhysicochemicalTestDetailsDto> {
            return localVarFp.apiPhysicochemicalTestIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestIdPut(id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options?: any): AxiosPromise<PhysicochemicalTestDetailsDto> {
            return localVarFp.apiPhysicochemicalTestIdPut(id, physicochemicalTestUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestPost(physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options?: any): AxiosPromise<PhysicochemicalTestDetailsDto> {
            return localVarFp.apiPhysicochemicalTestPost(physicochemicalTestCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPhysicochemicalTestProductionProcessGet(productionProcessId?: number, options?: any): AxiosPromise<Array<PhysicochemicalTestDto>> {
            return localVarFp.apiPhysicochemicalTestProductionProcessGet(productionProcessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhysicochemicalTestApi - object-oriented interface
 * @export
 * @class PhysicochemicalTestApi
 * @extends {BaseAPI}
 */
export class PhysicochemicalTestApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestGet(options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestIdDelete(id: number, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestIdGet(id: number, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {PhysicochemicalTestUpdateDto} [physicochemicalTestUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestIdPut(id: number, physicochemicalTestUpdateDto?: PhysicochemicalTestUpdateDto, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestIdPut(id, physicochemicalTestUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhysicochemicalTestCreateDto} [physicochemicalTestCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestPost(physicochemicalTestCreateDto?: PhysicochemicalTestCreateDto, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestPost(physicochemicalTestCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [productionProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhysicochemicalTestApi
     */
    public apiPhysicochemicalTestProductionProcessGet(productionProcessId?: number, options?: any) {
        return PhysicochemicalTestApiFp(this.configuration).apiPhysicochemicalTestProductionProcessGet(productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveAdminApi - axios parameter creator
 * @export
 */
export const PipedriveAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncActivitiesPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncDealsPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncOrganizationsPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncProductsPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive-app/admin/sync/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveAdminApi - functional programming interface
 * @export
 */
export const PipedriveAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncActivitiesPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncActivitiesPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncDealsPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncDealsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncOrganizationsPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncOrganizationsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppAdminSyncProductsPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppAdminSyncProductsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveAdminApi - factory interface
 * @export
 */
export const PipedriveAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncActivitiesPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncActivitiesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncDealsPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncDealsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncOrganizationsPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncOrganizationsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppAdminSyncProductsPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppAdminSyncProductsPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveAdminApi - object-oriented interface
 * @export
 * @class PipedriveAdminApi
 * @extends {BaseAPI}
 */
export class PipedriveAdminApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncActivitiesPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncActivitiesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncDealsPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncDealsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncOrganizationsPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncOrganizationsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAdminApi
     */
    public apiPipedriveAppAdminSyncProductsPost(options?: any) {
        return PipedriveAdminApiFp(this.configuration).apiPipedriveAppAdminSyncProductsPost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveAppApi - axios parameter creator
 * @export
 */
export const PipedriveAppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdConfirmPost: async (dealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('apiPipedriveAppDealsDealIdConfirmPost', 'dealId', dealId)
            const localVarPath = `/api/pipedrive-app/deals/{dealId}/confirm`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSummaryGet: async (dealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('apiPipedriveAppDealsDealIdSummaryGet', 'dealId', dealId)
            const localVarPath = `/api/pipedrive-app/deals/{dealId}/summary`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSyncPost: async (dealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('apiPipedriveAppDealsDealIdSyncPost', 'dealId', dealId)
            const localVarPath = `/api/pipedrive-app/deals/{dealId}/sync`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveAppApi - functional programming interface
 * @export
 */
export const PipedriveAppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveAppApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppDealsDealIdConfirmPost(dealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppDealsDealIdConfirmPost(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppDealsDealIdSummaryGet(dealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipedriveDealIntegrationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppDealsDealIdSummaryGet(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveAppDealsDealIdSyncPost(dealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveAppDealsDealIdSyncPost(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveAppApi - factory interface
 * @export
 */
export const PipedriveAppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveAppApiFp(configuration)
    return {
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdConfirmPost(dealId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppDealsDealIdConfirmPost(dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSummaryGet(dealId: number, options?: any): AxiosPromise<PipedriveDealIntegrationSummaryDto> {
            return localVarFp.apiPipedriveAppDealsDealIdSummaryGet(dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveAppDealsDealIdSyncPost(dealId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveAppDealsDealIdSyncPost(dealId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveAppApi - object-oriented interface
 * @export
 * @class PipedriveAppApi
 * @extends {BaseAPI}
 */
export class PipedriveAppApi extends BaseAPI {
    /**
     * 
     * @param {number} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAppApi
     */
    public apiPipedriveAppDealsDealIdConfirmPost(dealId: number, options?: any) {
        return PipedriveAppApiFp(this.configuration).apiPipedriveAppDealsDealIdConfirmPost(dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAppApi
     */
    public apiPipedriveAppDealsDealIdSummaryGet(dealId: number, options?: any) {
        return PipedriveAppApiFp(this.configuration).apiPipedriveAppDealsDealIdSummaryGet(dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveAppApi
     */
    public apiPipedriveAppDealsDealIdSyncPost(dealId: number, options?: any) {
        return PipedriveAppApiFp(this.configuration).apiPipedriveAppDealsDealIdSyncPost(dealId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveOAuthApi - axios parameter creator
 * @export
 */
export const PipedriveOAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveOauthCallbackGet: async (code?: string, error?: string, state?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive/oauth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveOAuthApi - functional programming interface
 * @export
 */
export const PipedriveOAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveOAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveOauthCallbackGet(code?: string, error?: string, state?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveOauthCallbackGet(code, error, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveOAuthApi - factory interface
 * @export
 */
export const PipedriveOAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveOAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {string} [error] 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveOauthCallbackGet(code?: string, error?: string, state?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveOauthCallbackGet(code, error, state, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveOAuthApi - object-oriented interface
 * @export
 * @class PipedriveOAuthApi
 * @extends {BaseAPI}
 */
export class PipedriveOAuthApi extends BaseAPI {
    /**
     * 
     * @param {string} [code] 
     * @param {string} [error] 
     * @param {string} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveOAuthApi
     */
    public apiPipedriveOauthCallbackGet(code?: string, error?: string, state?: string, options?: any) {
        return PipedriveOAuthApiFp(this.configuration).apiPipedriveOauthCallbackGet(code, error, state, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipedriveWebhookApi - axios parameter creator
 * @export
 */
export const PipedriveWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveWebhookPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pipedrive/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipedriveWebhookApi - functional programming interface
 * @export
 */
export const PipedriveWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipedriveWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPipedriveWebhookPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPipedriveWebhookPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipedriveWebhookApi - factory interface
 * @export
 */
export const PipedriveWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipedriveWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPipedriveWebhookPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiPipedriveWebhookPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipedriveWebhookApi - object-oriented interface
 * @export
 * @class PipedriveWebhookApi
 * @extends {BaseAPI}
 */
export class PipedriveWebhookApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipedriveWebhookApi
     */
    public apiPipedriveWebhookPost(options?: any) {
        return PipedriveWebhookApiFp(this.configuration).apiPipedriveWebhookPost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdDelete', 'id', id)
            const localVarPath = `/api/Product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdGet', 'id', id)
            const localVarPath = `/api/Product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdMinimalGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdMinimalGet', 'id', id)
            const localVarPath = `/api/Product/{id}/minimal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateDto} [productUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdPut: async (id: number, productUpdateDto?: ProductUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductIdPut', 'id', id)
            const localVarPath = `/api/Product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductCreateDto} [productCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPost: async (productCreateDto?: ProductCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('productsWarehouseWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/products/warehouse/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet: async (warehouseId: number, productionProcessId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet', 'warehouseId', warehouseId)
            // verify required parameter 'productionProcessId' is not null or undefined
            assertParamExists('productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet', 'productionProcessId', productionProcessId)
            const localVarPath = `/products/warehouse/{warehouseId}/producitonProcess/{productionProcessId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)))
                .replace(`{${"productionProcessId"}}`, encodeURIComponent(String(productionProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdMinimalGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdMinimalGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateDto} [productUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIdPut(id: number, productUpdateDto?: ProductUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIdPut(id, productUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductCreateDto} [productCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPost(productCreateDto?: ProductCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPost(productCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsWarehouseWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsWarehouseWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId: number, productionProcessId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId, productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductGet(options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.apiProductGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdGet(id: number, options?: any): AxiosPromise<ProductDetailsDto> {
            return localVarFp.apiProductIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdMinimalGet(id: number, options?: any): AxiosPromise<ProductMinimalDto> {
            return localVarFp.apiProductIdMinimalGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateDto} [productUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIdPut(id: number, productUpdateDto?: ProductUpdateDto, options?: any): AxiosPromise<ProductDetailsDto> {
            return localVarFp.apiProductIdPut(id, productUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductCreateDto} [productCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPost(productCreateDto?: ProductCreateDto, options?: any): AxiosPromise<ProductDetailsDto> {
            return localVarFp.apiProductPost(productCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.productsWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId: number, productionProcessId: number, options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId, productionProcessId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductGet(options?: any) {
        return ProductApiFp(this.configuration).apiProductGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdDelete(id: number, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdGet(id: number, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdMinimalGet(id: number, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdMinimalGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductUpdateDto} [productUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIdPut(id: number, productUpdateDto?: ProductUpdateDto, options?: any) {
        return ProductApiFp(this.configuration).apiProductIdPut(id, productUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductCreateDto} [productCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductPost(productCreateDto?: ProductCreateDto, options?: any) {
        return ProductApiFp(this.configuration).apiProductPost(productCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsWarehouseWarehouseIdGet(warehouseId: number, options?: any) {
        return ProductApiFp(this.configuration).productsWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {number} productionProcessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId: number, productionProcessId: number, options?: any) {
        return ProductApiFp(this.configuration).productsWarehouseWarehouseIdProducitonProcessProductionProcessIdGet(warehouseId, productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductPriceApi - axios parameter creator
 * @export
 */
export const ProductPriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductPriceIdDelete', 'id', id)
            const localVarPath = `/api/ProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductPriceIdGet', 'id', id)
            const localVarPath = `/api/ProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdPut: async (id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductPriceIdPut', 'id', id)
            const localVarPath = `/api/ProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productPriceUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductPriceCreateDto} [productPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPricePost: async (productPriceCreateDto?: ProductPriceCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productPriceCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductPriceApi - functional programming interface
 * @export
 */
export const ProductPriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductPriceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductPriceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPriceIdPut(id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPriceIdPut(id, productPriceUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductPriceCreateDto} [productPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPricePost(productPriceCreateDto?: ProductPriceCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPricePost(productPriceCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductPriceApi - factory interface
 * @export
 */
export const ProductPriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductPriceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceGet(options?: any): AxiosPromise<Array<ProductPriceDto>> {
            return localVarFp.apiProductPriceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductPriceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdGet(id: number, options?: any): AxiosPromise<ProductPriceDetailsDto> {
            return localVarFp.apiProductPriceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPriceIdPut(id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options?: any): AxiosPromise<ProductPriceDetailsDto> {
            return localVarFp.apiProductPriceIdPut(id, productPriceUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductPriceCreateDto} [productPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPricePost(productPriceCreateDto?: ProductPriceCreateDto, options?: any): AxiosPromise<ProductPriceDetailsDto> {
            return localVarFp.apiProductPricePost(productPriceCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductPriceApi - object-oriented interface
 * @export
 * @class ProductPriceApi
 * @extends {BaseAPI}
 */
export class ProductPriceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceGet(options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceIdDelete(id: number, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceIdGet(id: number, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductPriceUpdateDto} [productPriceUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPriceIdPut(id: number, productPriceUpdateDto?: ProductPriceUpdateDto, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPriceIdPut(id, productPriceUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductPriceCreateDto} [productPriceCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductPriceApi
     */
    public apiProductPricePost(productPriceCreateDto?: ProductPriceCreateDto, options?: any) {
        return ProductPriceApiFp(this.configuration).apiProductPricePost(productPriceCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductUpdateHistoryApi - axios parameter creator
 * @export
 */
export const ProductUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryHistoryProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiProductUpdateHistoryHistoryProductIdGet', 'productId', productId)
            const localVarPath = `/api/ProductUpdateHistory/history/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/ProductUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/ProductUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdPut: async (id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/ProductUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryPost: async (productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductUpdateHistoryApi - functional programming interface
 * @export
 */
export const ProductUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryHistoryProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryHistoryProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryIdPut(id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryIdPut(id, productUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdateHistoryPost(productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdateHistoryPost(productUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductUpdateHistoryApi - factory interface
 * @export
 */
export const ProductUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryGet(options?: any): AxiosPromise<Array<ProductUpdateHistoryDto>> {
            return localVarFp.apiProductUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryHistoryProductIdGet(productId: number, options?: any): AxiosPromise<Array<ProductUpdateHistoryDto>> {
            return localVarFp.apiProductUpdateHistoryHistoryProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<ProductUpdateHistoryDetailsDto> {
            return localVarFp.apiProductUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryIdPut(id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options?: any): AxiosPromise<ProductUpdateHistoryDetailsDto> {
            return localVarFp.apiProductUpdateHistoryIdPut(id, productUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdateHistoryPost(productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options?: any): AxiosPromise<ProductUpdateHistoryDetailsDto> {
            return localVarFp.apiProductUpdateHistoryPost(productUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductUpdateHistoryApi - object-oriented interface
 * @export
 * @class ProductUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class ProductUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryGet(options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryHistoryProductIdGet(productId: number, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryHistoryProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryIdDelete(id: number, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryIdGet(id: number, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductUpdateHistoryUpdateDto} [productUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryIdPut(id: number, productUpdateHistoryUpdateDto?: ProductUpdateHistoryUpdateDto, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryIdPut(id, productUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductUpdateHistoryCreateDto} [productUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductUpdateHistoryApi
     */
    public apiProductUpdateHistoryPost(productUpdateHistoryCreateDto?: ProductUpdateHistoryCreateDto, options?: any) {
        return ProductUpdateHistoryApiFp(this.configuration).apiProductUpdateHistoryPost(productUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductionProcessApi - axios parameter creator
 * @export
 */
export const ProductionProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsForCharacteristicsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess/detailsForCharacteristics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsMinimalGet: async (productionProcessId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess/detailsMinimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (productionProcessId !== undefined) {
                localVarQueryParameter['productionProcessId'] = productionProcessId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdDelete', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdGet', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdPut: async (id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdPut', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productionProcessUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdStatusPut: async (id: number, status?: StockOperationStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductionProcessIdStatusPut', 'id', id)
            const localVarPath = `/api/ProductionProcess/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessPost: async (productionProcessCreateDto?: ProductionProcessCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductionProcess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productionProcessCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessStatusStatusGet: async (status: StockOperationStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('apiProductionProcessStatusStatusGet', 'status', status)
            const localVarPath = `/api/ProductionProcess/status/{status}`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductionProcessApi - functional programming interface
 * @export
 */
export const ProductionProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductionProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessDetailsForCharacteristicsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessDetailsForCharacteristicsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessDetailsMinimalGet(productionProcessId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessDetailsMinimalGet(productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdPut(id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdPut(id, productionProcessUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessIdStatusPut(id: number, status?: StockOperationStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessIdStatusPut(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessPost(productionProcessCreateDto?: ProductionProcessCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductionProcessDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessPost(productionProcessCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductionProcessStatusStatusGet(status: StockOperationStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductionProcessStatusStatusGet(status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductionProcessApi - factory interface
 * @export
 */
export const ProductionProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductionProcessApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsForCharacteristicsGet(options?: any): AxiosPromise<Array<ProductionProcessDetailsDto>> {
            return localVarFp.apiProductionProcessDetailsForCharacteristicsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [productionProcessId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessDetailsMinimalGet(productionProcessId?: number, options?: any): AxiosPromise<ProductionProcessMinimalDto> {
            return localVarFp.apiProductionProcessDetailsMinimalGet(productionProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessGet(options?: any): AxiosPromise<Array<ProductionProcessDto>> {
            return localVarFp.apiProductionProcessGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductionProcessIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdGet(id: number, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdPut(id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessIdPut(id, productionProcessUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessIdStatusPut(id: number, status?: StockOperationStatus, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessIdStatusPut(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessPost(productionProcessCreateDto?: ProductionProcessCreateDto, options?: any): AxiosPromise<ProductionProcessDetailsDto> {
            return localVarFp.apiProductionProcessPost(productionProcessCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationStatus} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductionProcessStatusStatusGet(status: StockOperationStatus, options?: any): AxiosPromise<Array<ProductionProcessDto>> {
            return localVarFp.apiProductionProcessStatusStatusGet(status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductionProcessApi - object-oriented interface
 * @export
 * @class ProductionProcessApi
 * @extends {BaseAPI}
 */
export class ProductionProcessApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessDetailsForCharacteristicsGet(options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessDetailsForCharacteristicsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [productionProcessId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessDetailsMinimalGet(productionProcessId?: number, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessDetailsMinimalGet(productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessGet(options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdDelete(id: number, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdGet(id: number, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ProductionProcessUpdateDto} [productionProcessUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdPut(id: number, productionProcessUpdateDto?: ProductionProcessUpdateDto, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdPut(id, productionProcessUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessIdStatusPut(id: number, status?: StockOperationStatus, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessIdStatusPut(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductionProcessCreateDto} [productionProcessCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessPost(productionProcessCreateDto?: ProductionProcessCreateDto, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessPost(productionProcessCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationStatus} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductionProcessApi
     */
    public apiProductionProcessStatusStatusGet(status: StockOperationStatus, options?: any) {
        return ProductionProcessApiFp(this.configuration).apiProductionProcessStatusStatusGet(status, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RegonApi - axios parameter creator
 * @export
 */
export const RegonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [nip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRegonNipGet: async (nip?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Regon/nip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (nip !== undefined) {
                localVarQueryParameter['nip'] = nip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegonApi - functional programming interface
 * @export
 */
export const RegonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [nip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRegonNipGet(nip?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRegonNipGet(nip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RegonApi - factory interface
 * @export
 */
export const RegonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegonApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [nip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRegonNipGet(nip?: string, options?: any): AxiosPromise<ContractorDto> {
            return localVarFp.apiRegonNipGet(nip, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegonApi - object-oriented interface
 * @export
 * @class RegonApi
 * @extends {BaseAPI}
 */
export class RegonApi extends BaseAPI {
    /**
     * 
     * @param {string} [nip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegonApi
     */
    public apiRegonNipGet(nip?: string, options?: any) {
        return RegonApiFp(this.configuration).apiRegonNipGet(nip, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopAddressApi - axios parameter creator
 * @export
 */
export const ShopAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopAddressIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopAddress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopAddressIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopAddress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopAddressShopAddressUpdateDto} [shopAddressShopAddressUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressIdPut: async (id: number, shopAddressShopAddressUpdateDto?: ShopAddressShopAddressUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopAddressIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopAddress/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopAddressShopAddressUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopAddressShopAddressCreateDto} [shopAddressShopAddressCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressPost: async (shopAddressShopAddressCreateDto?: ShopAddressShopAddressCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopAddressShopAddressCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressUserAddressesUserIdGet: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiShopShopAddressUserAddressesUserIdGet', 'userId', userId)
            const localVarPath = `/api/shop/ShopAddress/userAddresses/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopAddressApi - functional programming interface
 * @export
 */
export const ShopAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopAddressGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopAddressShopAddressDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopAddressGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopAddressIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopAddressIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopAddressIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopAddressShopAddressDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopAddressIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopAddressShopAddressUpdateDto} [shopAddressShopAddressUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopAddressIdPut(id: number, shopAddressShopAddressUpdateDto?: ShopAddressShopAddressUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopAddressShopAddressDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopAddressIdPut(id, shopAddressShopAddressUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopAddressShopAddressCreateDto} [shopAddressShopAddressCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopAddressPost(shopAddressShopAddressCreateDto?: ShopAddressShopAddressCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopAddressShopAddressDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopAddressPost(shopAddressShopAddressCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopAddressUserAddressesUserIdGet(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopAddressShopAddressDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopAddressUserAddressesUserIdGet(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopAddressApi - factory interface
 * @export
 */
export const ShopAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopAddressApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressGet(options?: any): AxiosPromise<Array<ShopAddressShopAddressDto>> {
            return localVarFp.apiShopShopAddressGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopAddressIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressIdGet(id: number, options?: any): AxiosPromise<ShopAddressShopAddressDetailsDto> {
            return localVarFp.apiShopShopAddressIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopAddressShopAddressUpdateDto} [shopAddressShopAddressUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressIdPut(id: number, shopAddressShopAddressUpdateDto?: ShopAddressShopAddressUpdateDto, options?: any): AxiosPromise<ShopAddressShopAddressDetailsDto> {
            return localVarFp.apiShopShopAddressIdPut(id, shopAddressShopAddressUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopAddressShopAddressCreateDto} [shopAddressShopAddressCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressPost(shopAddressShopAddressCreateDto?: ShopAddressShopAddressCreateDto, options?: any): AxiosPromise<ShopAddressShopAddressDetailsDto> {
            return localVarFp.apiShopShopAddressPost(shopAddressShopAddressCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopAddressUserAddressesUserIdGet(userId: number, options?: any): AxiosPromise<Array<ShopAddressShopAddressDto>> {
            return localVarFp.apiShopShopAddressUserAddressesUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopAddressApi - object-oriented interface
 * @export
 * @class ShopAddressApi
 * @extends {BaseAPI}
 */
export class ShopAddressApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopAddressApi
     */
    public apiShopShopAddressGet(options?: any) {
        return ShopAddressApiFp(this.configuration).apiShopShopAddressGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopAddressApi
     */
    public apiShopShopAddressIdDelete(id: number, options?: any) {
        return ShopAddressApiFp(this.configuration).apiShopShopAddressIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopAddressApi
     */
    public apiShopShopAddressIdGet(id: number, options?: any) {
        return ShopAddressApiFp(this.configuration).apiShopShopAddressIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopAddressShopAddressUpdateDto} [shopAddressShopAddressUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopAddressApi
     */
    public apiShopShopAddressIdPut(id: number, shopAddressShopAddressUpdateDto?: ShopAddressShopAddressUpdateDto, options?: any) {
        return ShopAddressApiFp(this.configuration).apiShopShopAddressIdPut(id, shopAddressShopAddressUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopAddressShopAddressCreateDto} [shopAddressShopAddressCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopAddressApi
     */
    public apiShopShopAddressPost(shopAddressShopAddressCreateDto?: ShopAddressShopAddressCreateDto, options?: any) {
        return ShopAddressApiFp(this.configuration).apiShopShopAddressPost(shopAddressShopAddressCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopAddressApi
     */
    public apiShopShopAddressUserAddressesUserIdGet(userId: number, options?: any) {
        return ShopAddressApiFp(this.configuration).apiShopShopAddressUserAddressesUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopBasketApi - axios parameter creator
 * @export
 */
export const ShopBasketApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [discountCode] 
         * @param {number} [orderAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketApplyDiscountCodePost: async (discountCode?: string, orderAmount?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/basket/applyDiscountCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discountCode !== undefined) {
                localVarQueryParameter['discountCode'] = discountCode;
            }

            if (orderAmount !== undefined) {
                localVarQueryParameter['orderAmount'] = orderAmount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketDeleteBasketIdDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBasketDeleteBasketIdDelete', 'id', id)
            const localVarPath = `/api/basket/deleteBasket/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/basket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketGetAllBasketsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/basket/getAllBaskets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketGetBasketByIdIdGet: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBasketGetBasketByIdIdGet', 'id', id)
            const localVarPath = `/api/basket/getBasketById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopBasketAddToBasketDto} [shopBasketAddToBasketDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketPost: async (shopBasketAddToBasketDto?: ShopBasketAddToBasketDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/basket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopBasketAddToBasketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketRemoveDiscountCodeDelete: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/basket/removeDiscountCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopBasketRemoveFromBasketDto} [shopBasketRemoveFromBasketDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketRemoveFromBasketDelete: async (shopBasketRemoveFromBasketDto?: ShopBasketRemoveFromBasketDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/basket/removeFromBasket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopBasketRemoveFromBasketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopBasketApi - functional programming interface
 * @export
 */
export const ShopBasketApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopBasketApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [discountCode] 
         * @param {number} [orderAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketApplyDiscountCodePost(discountCode?: string, orderAmount?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopBasketBasketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketApplyDiscountCodePost(discountCode, orderAmount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketDeleteBasketIdDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopBasketBasketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketDeleteBasketIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopBasketBasketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketGetAllBasketsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopBasketBasketDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketGetAllBasketsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketGetBasketByIdIdGet(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopBasketBasketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketGetBasketByIdIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopBasketAddToBasketDto} [shopBasketAddToBasketDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketPost(shopBasketAddToBasketDto?: ShopBasketAddToBasketDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopBasketBasketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketPost(shopBasketAddToBasketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketRemoveDiscountCodeDelete(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopBasketBasketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketRemoveDiscountCodeDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopBasketRemoveFromBasketDto} [shopBasketRemoveFromBasketDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBasketRemoveFromBasketDelete(shopBasketRemoveFromBasketDto?: ShopBasketRemoveFromBasketDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopBasketBasketDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBasketRemoveFromBasketDelete(shopBasketRemoveFromBasketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopBasketApi - factory interface
 * @export
 */
export const ShopBasketApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopBasketApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [discountCode] 
         * @param {number} [orderAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketApplyDiscountCodePost(discountCode?: string, orderAmount?: number, options?: any): AxiosPromise<ShopBasketBasketDto> {
            return localVarFp.apiBasketApplyDiscountCodePost(discountCode, orderAmount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketDeleteBasketIdDelete(id: string, options?: any): AxiosPromise<ShopBasketBasketDto> {
            return localVarFp.apiBasketDeleteBasketIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketGet(options?: any): AxiosPromise<ShopBasketBasketDto> {
            return localVarFp.apiBasketGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketGetAllBasketsGet(options?: any): AxiosPromise<Array<ShopBasketBasketDto>> {
            return localVarFp.apiBasketGetAllBasketsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketGetBasketByIdIdGet(id: string, options?: any): AxiosPromise<ShopBasketBasketDto> {
            return localVarFp.apiBasketGetBasketByIdIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopBasketAddToBasketDto} [shopBasketAddToBasketDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketPost(shopBasketAddToBasketDto?: ShopBasketAddToBasketDto, options?: any): AxiosPromise<ShopBasketBasketDto> {
            return localVarFp.apiBasketPost(shopBasketAddToBasketDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketRemoveDiscountCodeDelete(options?: any): AxiosPromise<ShopBasketBasketDto> {
            return localVarFp.apiBasketRemoveDiscountCodeDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopBasketRemoveFromBasketDto} [shopBasketRemoveFromBasketDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBasketRemoveFromBasketDelete(shopBasketRemoveFromBasketDto?: ShopBasketRemoveFromBasketDto, options?: any): AxiosPromise<ShopBasketBasketDto> {
            return localVarFp.apiBasketRemoveFromBasketDelete(shopBasketRemoveFromBasketDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopBasketApi - object-oriented interface
 * @export
 * @class ShopBasketApi
 * @extends {BaseAPI}
 */
export class ShopBasketApi extends BaseAPI {
    /**
     * 
     * @param {string} [discountCode] 
     * @param {number} [orderAmount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketApplyDiscountCodePost(discountCode?: string, orderAmount?: number, options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketApplyDiscountCodePost(discountCode, orderAmount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketDeleteBasketIdDelete(id: string, options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketDeleteBasketIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketGet(options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketGetAllBasketsGet(options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketGetAllBasketsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketGetBasketByIdIdGet(id: string, options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketGetBasketByIdIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopBasketAddToBasketDto} [shopBasketAddToBasketDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketPost(shopBasketAddToBasketDto?: ShopBasketAddToBasketDto, options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketPost(shopBasketAddToBasketDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketRemoveDiscountCodeDelete(options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketRemoveDiscountCodeDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopBasketRemoveFromBasketDto} [shopBasketRemoveFromBasketDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopBasketApi
     */
    public apiBasketRemoveFromBasketDelete(shopBasketRemoveFromBasketDto?: ShopBasketRemoveFromBasketDto, options?: any) {
        return ShopBasketApiFp(this.configuration).apiBasketRemoveFromBasketDelete(shopBasketRemoveFromBasketDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopCategoryApi - axios parameter creator
 * @export
 */
export const ShopCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopCategoryIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopCategory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopCategoryIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopCategory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopCategoryCategoryUpdateDto} [shopCategoryCategoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryIdPut: async (id: number, shopCategoryCategoryUpdateDto?: ShopCategoryCategoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopCategoryIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopCategory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopCategoryCategoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryParentCategoriesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopCategory/parentCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopCategoryCategoryCreateDto} [shopCategoryCategoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryPost: async (shopCategoryCategoryCreateDto?: ShopCategoryCategoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopCategoryCategoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategorySubcategoriesCategoryIdGet: async (categoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('apiShopShopCategorySubcategoriesCategoryIdGet', 'categoryId', categoryId)
            const localVarPath = `/api/shop/ShopCategory/subcategories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopCategoryApi - functional programming interface
 * @export
 */
export const ShopCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopCategoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopCategoryCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopCategoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopCategoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopCategoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopCategoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopCategoryCategoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopCategoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopCategoryCategoryUpdateDto} [shopCategoryCategoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopCategoryIdPut(id: number, shopCategoryCategoryUpdateDto?: ShopCategoryCategoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopCategoryCategoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopCategoryIdPut(id, shopCategoryCategoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopCategoryParentCategoriesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopCategoryCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopCategoryParentCategoriesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopCategoryCategoryCreateDto} [shopCategoryCategoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopCategoryPost(shopCategoryCategoryCreateDto?: ShopCategoryCategoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopCategoryCategoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopCategoryPost(shopCategoryCategoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopCategorySubcategoriesCategoryIdGet(categoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopCategoryCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopCategorySubcategoriesCategoryIdGet(categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopCategoryApi - factory interface
 * @export
 */
export const ShopCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopCategoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryGet(options?: any): AxiosPromise<Array<ShopCategoryCategoryDto>> {
            return localVarFp.apiShopShopCategoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopCategoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryIdGet(id: number, options?: any): AxiosPromise<ShopCategoryCategoryDetailsDto> {
            return localVarFp.apiShopShopCategoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopCategoryCategoryUpdateDto} [shopCategoryCategoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryIdPut(id: number, shopCategoryCategoryUpdateDto?: ShopCategoryCategoryUpdateDto, options?: any): AxiosPromise<ShopCategoryCategoryDetailsDto> {
            return localVarFp.apiShopShopCategoryIdPut(id, shopCategoryCategoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryParentCategoriesGet(options?: any): AxiosPromise<Array<ShopCategoryCategoryDto>> {
            return localVarFp.apiShopShopCategoryParentCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopCategoryCategoryCreateDto} [shopCategoryCategoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategoryPost(shopCategoryCategoryCreateDto?: ShopCategoryCategoryCreateDto, options?: any): AxiosPromise<ShopCategoryCategoryDetailsDto> {
            return localVarFp.apiShopShopCategoryPost(shopCategoryCategoryCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopCategorySubcategoriesCategoryIdGet(categoryId: number, options?: any): AxiosPromise<Array<ShopCategoryCategoryDto>> {
            return localVarFp.apiShopShopCategorySubcategoriesCategoryIdGet(categoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopCategoryApi - object-oriented interface
 * @export
 * @class ShopCategoryApi
 * @extends {BaseAPI}
 */
export class ShopCategoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    public apiShopShopCategoryGet(options?: any) {
        return ShopCategoryApiFp(this.configuration).apiShopShopCategoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    public apiShopShopCategoryIdDelete(id: number, options?: any) {
        return ShopCategoryApiFp(this.configuration).apiShopShopCategoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    public apiShopShopCategoryIdGet(id: number, options?: any) {
        return ShopCategoryApiFp(this.configuration).apiShopShopCategoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopCategoryCategoryUpdateDto} [shopCategoryCategoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    public apiShopShopCategoryIdPut(id: number, shopCategoryCategoryUpdateDto?: ShopCategoryCategoryUpdateDto, options?: any) {
        return ShopCategoryApiFp(this.configuration).apiShopShopCategoryIdPut(id, shopCategoryCategoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    public apiShopShopCategoryParentCategoriesGet(options?: any) {
        return ShopCategoryApiFp(this.configuration).apiShopShopCategoryParentCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopCategoryCategoryCreateDto} [shopCategoryCategoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    public apiShopShopCategoryPost(shopCategoryCategoryCreateDto?: ShopCategoryCategoryCreateDto, options?: any) {
        return ShopCategoryApiFp(this.configuration).apiShopShopCategoryPost(shopCategoryCategoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopCategoryApi
     */
    public apiShopShopCategorySubcategoriesCategoryIdGet(categoryId: number, options?: any) {
        return ShopCategoryApiFp(this.configuration).apiShopShopCategorySubcategoriesCategoryIdGet(categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopDiscountCodeApi - axios parameter creator
 * @export
 */
export const ShopDiscountCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {number} [orderAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeApplyCodeGet: async (code?: string, orderAmount?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopDiscountCode/applyCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (orderAmount !== undefined) {
                localVarQueryParameter['orderAmount'] = orderAmount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeBulkDeleteDto} [shopDiscountCodeDiscountCodeBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeBulkDeletePost: async (shopDiscountCodeDiscountCodeBulkDeleteDto?: ShopDiscountCodeDiscountCodeBulkDeleteDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopDiscountCode/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopDiscountCodeDiscountCodeBulkDeleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeBulkCreateDto} [shopDiscountCodeDiscountCodeBulkCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeBulkPost: async (shopDiscountCodeDiscountCodeBulkCreateDto?: ShopDiscountCodeDiscountCodeBulkCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopDiscountCode/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopDiscountCodeDiscountCodeBulkCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopDiscountCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopDiscountCodeIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopDiscountCode/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopDiscountCodeIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopDiscountCode/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopDiscountCodeDiscountCodeUpdateDto} [shopDiscountCodeDiscountCodeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeIdPut: async (id: number, shopDiscountCodeDiscountCodeUpdateDto?: ShopDiscountCodeDiscountCodeUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopDiscountCodeIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopDiscountCode/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopDiscountCodeDiscountCodeUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeCreateDto} [shopDiscountCodeDiscountCodeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodePost: async (shopDiscountCodeDiscountCodeCreateDto?: ShopDiscountCodeDiscountCodeCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopDiscountCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopDiscountCodeDiscountCodeCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopDiscountCodeApi - functional programming interface
 * @export
 */
export const ShopDiscountCodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopDiscountCodeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {number} [orderAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodeApplyCodeGet(code?: string, orderAmount?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopDiscountCodeDiscountCodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodeApplyCodeGet(code, orderAmount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeBulkDeleteDto} [shopDiscountCodeDiscountCodeBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodeBulkDeletePost(shopDiscountCodeDiscountCodeBulkDeleteDto?: ShopDiscountCodeDiscountCodeBulkDeleteDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodeBulkDeletePost(shopDiscountCodeDiscountCodeBulkDeleteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeBulkCreateDto} [shopDiscountCodeDiscountCodeBulkCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodeBulkPost(shopDiscountCodeDiscountCodeBulkCreateDto?: ShopDiscountCodeDiscountCodeBulkCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopDiscountCodeDiscountCodeBulkCreateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodeBulkPost(shopDiscountCodeDiscountCodeBulkCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodeGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopDiscountCodeDiscountCodeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodeIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodeIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodeIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopDiscountCodeDiscountCodeDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodeIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopDiscountCodeDiscountCodeUpdateDto} [shopDiscountCodeDiscountCodeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodeIdPut(id: number, shopDiscountCodeDiscountCodeUpdateDto?: ShopDiscountCodeDiscountCodeUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopDiscountCodeDiscountCodeDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodeIdPut(id, shopDiscountCodeDiscountCodeUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeCreateDto} [shopDiscountCodeDiscountCodeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopDiscountCodePost(shopDiscountCodeDiscountCodeCreateDto?: ShopDiscountCodeDiscountCodeCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopDiscountCodeDiscountCodeDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopDiscountCodePost(shopDiscountCodeDiscountCodeCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopDiscountCodeApi - factory interface
 * @export
 */
export const ShopDiscountCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopDiscountCodeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {number} [orderAmount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeApplyCodeGet(code?: string, orderAmount?: number, options?: any): AxiosPromise<ShopDiscountCodeDiscountCodeResponseDto> {
            return localVarFp.apiShopShopDiscountCodeApplyCodeGet(code, orderAmount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeBulkDeleteDto} [shopDiscountCodeDiscountCodeBulkDeleteDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeBulkDeletePost(shopDiscountCodeDiscountCodeBulkDeleteDto?: ShopDiscountCodeDiscountCodeBulkDeleteDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopDiscountCodeBulkDeletePost(shopDiscountCodeDiscountCodeBulkDeleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeBulkCreateDto} [shopDiscountCodeDiscountCodeBulkCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeBulkPost(shopDiscountCodeDiscountCodeBulkCreateDto?: ShopDiscountCodeDiscountCodeBulkCreateDto, options?: any): AxiosPromise<ShopDiscountCodeDiscountCodeBulkCreateResultDto> {
            return localVarFp.apiShopShopDiscountCodeBulkPost(shopDiscountCodeDiscountCodeBulkCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeGet(options?: any): AxiosPromise<Array<ShopDiscountCodeDiscountCodeDto>> {
            return localVarFp.apiShopShopDiscountCodeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopDiscountCodeIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeIdGet(id: number, options?: any): AxiosPromise<ShopDiscountCodeDiscountCodeDetailsDto> {
            return localVarFp.apiShopShopDiscountCodeIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopDiscountCodeDiscountCodeUpdateDto} [shopDiscountCodeDiscountCodeUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodeIdPut(id: number, shopDiscountCodeDiscountCodeUpdateDto?: ShopDiscountCodeDiscountCodeUpdateDto, options?: any): AxiosPromise<ShopDiscountCodeDiscountCodeDetailsDto> {
            return localVarFp.apiShopShopDiscountCodeIdPut(id, shopDiscountCodeDiscountCodeUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopDiscountCodeDiscountCodeCreateDto} [shopDiscountCodeDiscountCodeCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopDiscountCodePost(shopDiscountCodeDiscountCodeCreateDto?: ShopDiscountCodeDiscountCodeCreateDto, options?: any): AxiosPromise<ShopDiscountCodeDiscountCodeDetailsDto> {
            return localVarFp.apiShopShopDiscountCodePost(shopDiscountCodeDiscountCodeCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopDiscountCodeApi - object-oriented interface
 * @export
 * @class ShopDiscountCodeApi
 * @extends {BaseAPI}
 */
export class ShopDiscountCodeApi extends BaseAPI {
    /**
     * 
     * @param {string} [code] 
     * @param {number} [orderAmount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodeApplyCodeGet(code?: string, orderAmount?: number, options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodeApplyCodeGet(code, orderAmount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopDiscountCodeDiscountCodeBulkDeleteDto} [shopDiscountCodeDiscountCodeBulkDeleteDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodeBulkDeletePost(shopDiscountCodeDiscountCodeBulkDeleteDto?: ShopDiscountCodeDiscountCodeBulkDeleteDto, options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodeBulkDeletePost(shopDiscountCodeDiscountCodeBulkDeleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopDiscountCodeDiscountCodeBulkCreateDto} [shopDiscountCodeDiscountCodeBulkCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodeBulkPost(shopDiscountCodeDiscountCodeBulkCreateDto?: ShopDiscountCodeDiscountCodeBulkCreateDto, options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodeBulkPost(shopDiscountCodeDiscountCodeBulkCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodeGet(options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodeIdDelete(id: number, options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodeIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodeIdGet(id: number, options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodeIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopDiscountCodeDiscountCodeUpdateDto} [shopDiscountCodeDiscountCodeUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodeIdPut(id: number, shopDiscountCodeDiscountCodeUpdateDto?: ShopDiscountCodeDiscountCodeUpdateDto, options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodeIdPut(id, shopDiscountCodeDiscountCodeUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopDiscountCodeDiscountCodeCreateDto} [shopDiscountCodeDiscountCodeCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopDiscountCodeApi
     */
    public apiShopShopDiscountCodePost(shopDiscountCodeDiscountCodeCreateDto?: ShopDiscountCodeDiscountCodeCreateDto, options?: any) {
        return ShopDiscountCodeApiFp(this.configuration).apiShopShopDiscountCodePost(shopDiscountCodeDiscountCodeCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopOrderApi - axios parameter creator
 * @export
 */
export const ShopOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderAvailablePaymentMethodsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/availablePaymentMethods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderCompletedOrdersGet: async (page?: number, sortDirection?: ShopOrderSortDirection, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/CompletedOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {ShopOrderStage} [orderStage] 
         * @param {string} [parcelSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderConfirmOrderPatch: async (orderGuid?: string, orderStage?: ShopOrderStage, parcelSize?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/confirmOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (orderGuid !== undefined) {
                localVarQueryParameter['orderGuid'] = orderGuid;
            }

            if (orderStage !== undefined) {
                localVarQueryParameter['orderStage'] = orderStage;
            }

            if (parcelSize !== undefined) {
                localVarQueryParameter['parcelSize'] = parcelSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderDeliveryCostGet: async (orderGuid?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/deliveryCost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderGuid !== undefined) {
                localVarQueryParameter['orderGuid'] = orderGuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderIdPut: async (id: number, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderOrderUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderInCompletedOrdersGet: async (page?: number, sortDirection?: ShopOrderSortDirection, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/InCompletedOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderMinimalGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/minimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidDetailsGet: async (orderGuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGuid' is not null or undefined
            assertParamExists('apiShopShopOrderOrderGuidDetailsGet', 'orderGuid', orderGuid)
            const localVarPath = `/api/shop/ShopOrder/{orderGuid}/details`
                .replace(`{${"orderGuid"}}`, encodeURIComponent(String(orderGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidDetailsMinimalGet: async (orderGuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGuid' is not null or undefined
            assertParamExists('apiShopShopOrderOrderGuidDetailsMinimalGet', 'orderGuid', orderGuid)
            const localVarPath = `/api/shop/ShopOrder/{orderGuid}/detailsMinimal`
                .replace(`{${"orderGuid"}}`, encodeURIComponent(String(orderGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidFillOrderClientDetailsPut: async (orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGuid' is not null or undefined
            assertParamExists('apiShopShopOrderOrderGuidFillOrderClientDetailsPut', 'orderGuid', orderGuid)
            const localVarPath = `/api/shop/ShopOrder/{orderGuid}/fillOrderClientDetails`
                .replace(`{${"orderGuid"}}`, encodeURIComponent(String(orderGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderOrderUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut: async (orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGuid' is not null or undefined
            assertParamExists('apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut', 'orderGuid', orderGuid)
            const localVarPath = `/api/shop/ShopOrder/{orderGuid}/fillOrderDeliveryDetails`
                .replace(`{${"orderGuid"}}`, encodeURIComponent(String(orderGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderOrderUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut: async (orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGuid' is not null or undefined
            assertParamExists('apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut', 'orderGuid', orderGuid)
            const localVarPath = `/api/shop/ShopOrder/{orderGuid}/fillOrderPaymentDetails`
                .replace(`{${"orderGuid"}}`, encodeURIComponent(String(orderGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderOrderUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrdersGet: async (page?: number, sortDirection?: ShopOrderSortDirection, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopOrderOrderPlaceDto} [shopOrderOrderPlaceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderPlaceOrderPost: async (shopOrderOrderPlaceDto?: ShopOrderOrderPlaceDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/placeOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderOrderPlaceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopOrderOrderCreateDto} [shopOrderOrderCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderPost: async (shopOrderOrderCreateDto?: ShopOrderOrderCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderOrderCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [shipmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderShipmentLabelGet: async (shipmentId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/shipmentLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (shipmentId !== undefined) {
                localVarQueryParameter['shipmentId'] = shipmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {ShopOrderStage} [orderStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderStatePatch: async (orderGuid?: string, orderStage?: ShopOrderStage, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrder/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderGuid !== undefined) {
                localVarQueryParameter['orderGuid'] = orderGuid;
            }

            if (orderStage !== undefined) {
                localVarQueryParameter['orderStage'] = orderStage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopOrderApi - functional programming interface
 * @export
 */
export const ShopOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderAvailablePaymentMethodsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayUAvailablePayMethods>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderAvailablePaymentMethodsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderCompletedOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderCompletedOrdersGet(page, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {ShopOrderStage} [orderStage] 
         * @param {string} [parcelSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderConfirmOrderPatch(orderGuid?: string, orderStage?: ShopOrderStage, parcelSize?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderConfirmOrderPatch(orderGuid, orderStage, parcelSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderDeliveryCostGet(orderGuid?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderOrderDeliveryVariantCostDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderDeliveryCostGet(orderGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderIdPut(id: number, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderIdPut(id, shopOrderOrderUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderInCompletedOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderInCompletedOrdersGet(page, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderMinimalGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderOrderMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderMinimalGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderOrderGuidDetailsGet(orderGuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderOrderGuidDetailsGet(orderGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderOrderGuidDetailsMinimalGet(orderGuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderOrderGuidDetailsMinimalGet(orderGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderOrderGuidFillOrderClientDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderOrderGuidFillOrderClientDetailsPut(orderGuid, shopOrderOrderUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut(orderGuid, shopOrderOrderUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut(orderGuid, shopOrderOrderUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderOrdersGet(page, sortDirection, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopOrderOrderPlaceDto} [shopOrderOrderPlaceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderPlaceOrderPost(shopOrderOrderPlaceDto?: ShopOrderOrderPlaceDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderPlaceOrderPost(shopOrderOrderPlaceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopOrderOrderCreateDto} [shopOrderOrderCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderPost(shopOrderOrderCreateDto?: ShopOrderOrderCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderPost(shopOrderOrderCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [shipmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderShipmentLabelGet(shipmentId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderShipmentLabelGet(shipmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {ShopOrderStage} [orderStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderStatePatch(orderGuid?: string, orderStage?: ShopOrderStage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderOrderCreateResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderStatePatch(orderGuid, orderStage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopOrderApi - factory interface
 * @export
 */
export const ShopOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopOrderApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderAvailablePaymentMethodsGet(options?: any): AxiosPromise<PayUAvailablePayMethods> {
            return localVarFp.apiShopShopOrderAvailablePaymentMethodsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderCompletedOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any): AxiosPromise<Array<ShopOrderOrderDto>> {
            return localVarFp.apiShopShopOrderCompletedOrdersGet(page, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {ShopOrderStage} [orderStage] 
         * @param {string} [parcelSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderConfirmOrderPatch(orderGuid?: string, orderStage?: ShopOrderStage, parcelSize?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopOrderConfirmOrderPatch(orderGuid, orderStage, parcelSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderDeliveryCostGet(orderGuid?: string, options?: any): AxiosPromise<Array<ShopOrderOrderDeliveryVariantCostDto>> {
            return localVarFp.apiShopShopOrderDeliveryCostGet(orderGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderGet(options?: any): AxiosPromise<Array<ShopOrderOrderDto>> {
            return localVarFp.apiShopShopOrderGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopOrderIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderIdGet(id: number, options?: any): AxiosPromise<ShopOrderOrderDetailsDto> {
            return localVarFp.apiShopShopOrderIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderIdPut(id: number, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): AxiosPromise<ShopOrderOrderDetailsDto> {
            return localVarFp.apiShopShopOrderIdPut(id, shopOrderOrderUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderInCompletedOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any): AxiosPromise<Array<ShopOrderOrderDto>> {
            return localVarFp.apiShopShopOrderInCompletedOrdersGet(page, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderMinimalGet(options?: any): AxiosPromise<Array<ShopOrderOrderMinimalDto>> {
            return localVarFp.apiShopShopOrderMinimalGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidDetailsGet(orderGuid: string, options?: any): AxiosPromise<ShopOrderOrderDetailsDto> {
            return localVarFp.apiShopShopOrderOrderGuidDetailsGet(orderGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidDetailsMinimalGet(orderGuid: string, options?: any): AxiosPromise<ShopOrderOrderMinimalDto> {
            return localVarFp.apiShopShopOrderOrderGuidDetailsMinimalGet(orderGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidFillOrderClientDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): AxiosPromise<ShopOrderOrderDto> {
            return localVarFp.apiShopShopOrderOrderGuidFillOrderClientDetailsPut(orderGuid, shopOrderOrderUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): AxiosPromise<ShopOrderOrderDto> {
            return localVarFp.apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut(orderGuid, shopOrderOrderUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderGuid 
         * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any): AxiosPromise<ShopOrderOrderDto> {
            return localVarFp.apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut(orderGuid, shopOrderOrderUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {ShopOrderSortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any): AxiosPromise<Array<ShopOrderOrderDto>> {
            return localVarFp.apiShopShopOrderOrdersGet(page, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopOrderOrderPlaceDto} [shopOrderOrderPlaceDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderPlaceOrderPost(shopOrderOrderPlaceDto?: ShopOrderOrderPlaceDto, options?: any): AxiosPromise<ShopOrderOrderDetailsDto> {
            return localVarFp.apiShopShopOrderPlaceOrderPost(shopOrderOrderPlaceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopOrderOrderCreateDto} [shopOrderOrderCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderPost(shopOrderOrderCreateDto?: ShopOrderOrderCreateDto, options?: any): AxiosPromise<ShopOrderOrderDetailsDto> {
            return localVarFp.apiShopShopOrderPost(shopOrderOrderCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [shipmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderShipmentLabelGet(shipmentId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopOrderShipmentLabelGet(shipmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {ShopOrderStage} [orderStage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderStatePatch(orderGuid?: string, orderStage?: ShopOrderStage, options?: any): AxiosPromise<ShopOrderOrderCreateResultDto> {
            return localVarFp.apiShopShopOrderStatePatch(orderGuid, orderStage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopOrderApi - object-oriented interface
 * @export
 * @class ShopOrderApi
 * @extends {BaseAPI}
 */
export class ShopOrderApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderAvailablePaymentMethodsGet(options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderAvailablePaymentMethodsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {ShopOrderSortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderCompletedOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderCompletedOrdersGet(page, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orderGuid] 
     * @param {ShopOrderStage} [orderStage] 
     * @param {string} [parcelSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderConfirmOrderPatch(orderGuid?: string, orderStage?: ShopOrderStage, parcelSize?: string, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderConfirmOrderPatch(orderGuid, orderStage, parcelSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orderGuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderDeliveryCostGet(orderGuid?: string, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderDeliveryCostGet(orderGuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderGet(options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderIdDelete(id: number, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderIdGet(id: number, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderIdPut(id: number, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderIdPut(id, shopOrderOrderUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {ShopOrderSortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderInCompletedOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderInCompletedOrdersGet(page, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderMinimalGet(options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderMinimalGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderOrderGuidDetailsGet(orderGuid: string, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderOrderGuidDetailsGet(orderGuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderOrderGuidDetailsMinimalGet(orderGuid: string, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderOrderGuidDetailsMinimalGet(orderGuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderGuid 
     * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderOrderGuidFillOrderClientDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderOrderGuidFillOrderClientDetailsPut(orderGuid, shopOrderOrderUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderGuid 
     * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderOrderGuidFillOrderDeliveryDetailsPut(orderGuid, shopOrderOrderUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderGuid 
     * @param {ShopOrderOrderUpdateDto} [shopOrderOrderUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut(orderGuid: string, shopOrderOrderUpdateDto?: ShopOrderOrderUpdateDto, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderOrderGuidFillOrderPaymentDetailsPut(orderGuid, shopOrderOrderUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {ShopOrderSortDirection} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderOrdersGet(page?: number, sortDirection?: ShopOrderSortDirection, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderOrdersGet(page, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopOrderOrderPlaceDto} [shopOrderOrderPlaceDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderPlaceOrderPost(shopOrderOrderPlaceDto?: ShopOrderOrderPlaceDto, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderPlaceOrderPost(shopOrderOrderPlaceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopOrderOrderCreateDto} [shopOrderOrderCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderPost(shopOrderOrderCreateDto?: ShopOrderOrderCreateDto, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderPost(shopOrderOrderCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [shipmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderShipmentLabelGet(shipmentId?: number, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderShipmentLabelGet(shipmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orderGuid] 
     * @param {ShopOrderStage} [orderStage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderApi
     */
    public apiShopShopOrderStatePatch(orderGuid?: string, orderStage?: ShopOrderStage, options?: any) {
        return ShopOrderApiFp(this.configuration).apiShopShopOrderStatePatch(orderGuid, orderStage, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopOrderProductApi - axios parameter creator
 * @export
 */
export const ShopOrderProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrderProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderProductIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopOrderProduct/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderProductIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopOrderProduct/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderProductOrderProductUpdateDto} [shopOrderProductOrderProductUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductIdPut: async (id: number, shopOrderProductOrderProductUpdateDto?: ShopOrderProductOrderProductUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderProductIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopOrderProduct/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderProductOrderProductUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductOrderProductsGet: async (orderId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrderProduct/orderProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopOrderProductOrderProductCreateDto} [shopOrderProductOrderProductCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductPost: async (shopOrderProductOrderProductCreateDto?: ShopOrderProductOrderProductCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrderProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderProductOrderProductCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopOrderProductOrderProductStockUpdateDto} [shopOrderProductOrderProductStockUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductUpdateStockPatch: async (shopOrderProductOrderProductStockUpdateDto?: ShopOrderProductOrderProductStockUpdateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrderProduct/updateStock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderProductOrderProductStockUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopOrderProductApi - functional programming interface
 * @export
 */
export const ShopOrderProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopOrderProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderProductGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderProductOrderProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderProductGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderProductIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderProductIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderProductIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderProductOrderProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderProductIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderProductOrderProductUpdateDto} [shopOrderProductOrderProductUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderProductIdPut(id: number, shopOrderProductOrderProductUpdateDto?: ShopOrderProductOrderProductUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderProductOrderProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderProductIdPut(id, shopOrderProductOrderProductUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderProductOrderProductsGet(orderId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderProductOrderProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderProductOrderProductsGet(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopOrderProductOrderProductCreateDto} [shopOrderProductOrderProductCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderProductPost(shopOrderProductOrderProductCreateDto?: ShopOrderProductOrderProductCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderProductOrderProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderProductPost(shopOrderProductOrderProductCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopOrderProductOrderProductStockUpdateDto} [shopOrderProductOrderProductStockUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderProductUpdateStockPatch(shopOrderProductOrderProductStockUpdateDto?: ShopOrderProductOrderProductStockUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderProductUpdateStockPatch(shopOrderProductOrderProductStockUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopOrderProductApi - factory interface
 * @export
 */
export const ShopOrderProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopOrderProductApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductGet(options?: any): AxiosPromise<Array<ShopOrderProductOrderProductDto>> {
            return localVarFp.apiShopShopOrderProductGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopOrderProductIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductIdGet(id: number, options?: any): AxiosPromise<ShopOrderProductOrderProductDetailsDto> {
            return localVarFp.apiShopShopOrderProductIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderProductOrderProductUpdateDto} [shopOrderProductOrderProductUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductIdPut(id: number, shopOrderProductOrderProductUpdateDto?: ShopOrderProductOrderProductUpdateDto, options?: any): AxiosPromise<ShopOrderProductOrderProductDetailsDto> {
            return localVarFp.apiShopShopOrderProductIdPut(id, shopOrderProductOrderProductUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductOrderProductsGet(orderId?: number, options?: any): AxiosPromise<Array<ShopOrderProductOrderProductDto>> {
            return localVarFp.apiShopShopOrderProductOrderProductsGet(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopOrderProductOrderProductCreateDto} [shopOrderProductOrderProductCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductPost(shopOrderProductOrderProductCreateDto?: ShopOrderProductOrderProductCreateDto, options?: any): AxiosPromise<ShopOrderProductOrderProductDetailsDto> {
            return localVarFp.apiShopShopOrderProductPost(shopOrderProductOrderProductCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopOrderProductOrderProductStockUpdateDto} [shopOrderProductOrderProductStockUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderProductUpdateStockPatch(shopOrderProductOrderProductStockUpdateDto?: ShopOrderProductOrderProductStockUpdateDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopOrderProductUpdateStockPatch(shopOrderProductOrderProductStockUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopOrderProductApi - object-oriented interface
 * @export
 * @class ShopOrderProductApi
 * @extends {BaseAPI}
 */
export class ShopOrderProductApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderProductApi
     */
    public apiShopShopOrderProductGet(options?: any) {
        return ShopOrderProductApiFp(this.configuration).apiShopShopOrderProductGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderProductApi
     */
    public apiShopShopOrderProductIdDelete(id: number, options?: any) {
        return ShopOrderProductApiFp(this.configuration).apiShopShopOrderProductIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderProductApi
     */
    public apiShopShopOrderProductIdGet(id: number, options?: any) {
        return ShopOrderProductApiFp(this.configuration).apiShopShopOrderProductIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopOrderProductOrderProductUpdateDto} [shopOrderProductOrderProductUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderProductApi
     */
    public apiShopShopOrderProductIdPut(id: number, shopOrderProductOrderProductUpdateDto?: ShopOrderProductOrderProductUpdateDto, options?: any) {
        return ShopOrderProductApiFp(this.configuration).apiShopShopOrderProductIdPut(id, shopOrderProductOrderProductUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderProductApi
     */
    public apiShopShopOrderProductOrderProductsGet(orderId?: number, options?: any) {
        return ShopOrderProductApiFp(this.configuration).apiShopShopOrderProductOrderProductsGet(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopOrderProductOrderProductCreateDto} [shopOrderProductOrderProductCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderProductApi
     */
    public apiShopShopOrderProductPost(shopOrderProductOrderProductCreateDto?: ShopOrderProductOrderProductCreateDto, options?: any) {
        return ShopOrderProductApiFp(this.configuration).apiShopShopOrderProductPost(shopOrderProductOrderProductCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopOrderProductOrderProductStockUpdateDto} [shopOrderProductOrderProductStockUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderProductApi
     */
    public apiShopShopOrderProductUpdateStockPatch(shopOrderProductOrderProductStockUpdateDto?: ShopOrderProductOrderProductStockUpdateDto, options?: any) {
        return ShopOrderProductApiFp(this.configuration).apiShopShopOrderProductUpdateStockPatch(shopOrderProductOrderProductStockUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopOrderRefundApi - axios parameter creator
 * @export
 */
export const ShopOrderRefundApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrderRefund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderRefundIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopOrderRefund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderRefundIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopOrderRefund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderRefundOrderRefundUpdateDto} [shopOrderRefundOrderRefundUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundIdPut: async (id: number, shopOrderRefundOrderRefundUpdateDto?: ShopOrderRefundOrderRefundUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopOrderRefundIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopOrderRefund/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderRefundOrderRefundUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopOrderRefundOrderRefundCreateDto} [shopOrderRefundOrderRefundCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundPost: async (shopOrderRefundOrderRefundCreateDto?: ShopOrderRefundOrderRefundCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrderRefund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopOrderRefundOrderRefundCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundRefundsForOrderGet: async (orderGuid?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopOrderRefund/refundsForOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (orderGuid !== undefined) {
                localVarQueryParameter['orderGuid'] = orderGuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopOrderRefundApi - functional programming interface
 * @export
 */
export const ShopOrderRefundApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopOrderRefundApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderRefundGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderRefundOrderRefundDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderRefundGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderRefundIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderRefundIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderRefundIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderRefundOrderRefundDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderRefundIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderRefundOrderRefundUpdateDto} [shopOrderRefundOrderRefundUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderRefundIdPut(id: number, shopOrderRefundOrderRefundUpdateDto?: ShopOrderRefundOrderRefundUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderRefundOrderRefundDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderRefundIdPut(id, shopOrderRefundOrderRefundUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopOrderRefundOrderRefundCreateDto} [shopOrderRefundOrderRefundCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderRefundPost(shopOrderRefundOrderRefundCreateDto?: ShopOrderRefundOrderRefundCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopOrderRefundOrderRefundDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderRefundPost(shopOrderRefundOrderRefundCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopOrderRefundRefundsForOrderGet(orderGuid?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopOrderRefundOrderRefundDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopOrderRefundRefundsForOrderGet(orderGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopOrderRefundApi - factory interface
 * @export
 */
export const ShopOrderRefundApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopOrderRefundApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundGet(options?: any): AxiosPromise<Array<ShopOrderRefundOrderRefundDto>> {
            return localVarFp.apiShopShopOrderRefundGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopOrderRefundIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundIdGet(id: number, options?: any): AxiosPromise<ShopOrderRefundOrderRefundDetailsDto> {
            return localVarFp.apiShopShopOrderRefundIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopOrderRefundOrderRefundUpdateDto} [shopOrderRefundOrderRefundUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundIdPut(id: number, shopOrderRefundOrderRefundUpdateDto?: ShopOrderRefundOrderRefundUpdateDto, options?: any): AxiosPromise<ShopOrderRefundOrderRefundDetailsDto> {
            return localVarFp.apiShopShopOrderRefundIdPut(id, shopOrderRefundOrderRefundUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopOrderRefundOrderRefundCreateDto} [shopOrderRefundOrderRefundCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundPost(shopOrderRefundOrderRefundCreateDto?: ShopOrderRefundOrderRefundCreateDto, options?: any): AxiosPromise<ShopOrderRefundOrderRefundDetailsDto> {
            return localVarFp.apiShopShopOrderRefundPost(shopOrderRefundOrderRefundCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orderGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopOrderRefundRefundsForOrderGet(orderGuid?: string, options?: any): AxiosPromise<Array<ShopOrderRefundOrderRefundDto>> {
            return localVarFp.apiShopShopOrderRefundRefundsForOrderGet(orderGuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopOrderRefundApi - object-oriented interface
 * @export
 * @class ShopOrderRefundApi
 * @extends {BaseAPI}
 */
export class ShopOrderRefundApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderRefundApi
     */
    public apiShopShopOrderRefundGet(options?: any) {
        return ShopOrderRefundApiFp(this.configuration).apiShopShopOrderRefundGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderRefundApi
     */
    public apiShopShopOrderRefundIdDelete(id: number, options?: any) {
        return ShopOrderRefundApiFp(this.configuration).apiShopShopOrderRefundIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderRefundApi
     */
    public apiShopShopOrderRefundIdGet(id: number, options?: any) {
        return ShopOrderRefundApiFp(this.configuration).apiShopShopOrderRefundIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopOrderRefundOrderRefundUpdateDto} [shopOrderRefundOrderRefundUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderRefundApi
     */
    public apiShopShopOrderRefundIdPut(id: number, shopOrderRefundOrderRefundUpdateDto?: ShopOrderRefundOrderRefundUpdateDto, options?: any) {
        return ShopOrderRefundApiFp(this.configuration).apiShopShopOrderRefundIdPut(id, shopOrderRefundOrderRefundUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopOrderRefundOrderRefundCreateDto} [shopOrderRefundOrderRefundCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderRefundApi
     */
    public apiShopShopOrderRefundPost(shopOrderRefundOrderRefundCreateDto?: ShopOrderRefundOrderRefundCreateDto, options?: any) {
        return ShopOrderRefundApiFp(this.configuration).apiShopShopOrderRefundPost(shopOrderRefundOrderRefundCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orderGuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopOrderRefundApi
     */
    public apiShopShopOrderRefundRefundsForOrderGet(orderGuid?: string, options?: any) {
        return ShopOrderRefundApiFp(this.configuration).apiShopShopOrderRefundRefundsForOrderGet(orderGuid, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopPayUNotificationApi - axios parameter creator
 * @export
 */
export const ShopPayUNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PayUOrderNotification} [payUOrderNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPayUNotificationPost: async (payUOrderNotification?: PayUOrderNotification, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PayUNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payUOrderNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PayUOrderNotification} [payUOrderNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopPayUNotificationPost: async (payUOrderNotification?: PayUOrderNotification, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopPayUNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payUOrderNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopPayUNotificationApi - functional programming interface
 * @export
 */
export const ShopPayUNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopPayUNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PayUOrderNotification} [payUOrderNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPayUNotificationPost(payUOrderNotification?: PayUOrderNotification, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPayUNotificationPost(payUOrderNotification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PayUOrderNotification} [payUOrderNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopPayUNotificationPost(payUOrderNotification?: PayUOrderNotification, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopPayUNotificationPost(payUOrderNotification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopPayUNotificationApi - factory interface
 * @export
 */
export const ShopPayUNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopPayUNotificationApiFp(configuration)
    return {
        /**
         * 
         * @param {PayUOrderNotification} [payUOrderNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPayUNotificationPost(payUOrderNotification?: PayUOrderNotification, options?: any): AxiosPromise<void> {
            return localVarFp.apiPayUNotificationPost(payUOrderNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayUOrderNotification} [payUOrderNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopPayUNotificationPost(payUOrderNotification?: PayUOrderNotification, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopPayUNotificationPost(payUOrderNotification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopPayUNotificationApi - object-oriented interface
 * @export
 * @class ShopPayUNotificationApi
 * @extends {BaseAPI}
 */
export class ShopPayUNotificationApi extends BaseAPI {
    /**
     * 
     * @param {PayUOrderNotification} [payUOrderNotification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopPayUNotificationApi
     */
    public apiPayUNotificationPost(payUOrderNotification?: PayUOrderNotification, options?: any) {
        return ShopPayUNotificationApiFp(this.configuration).apiPayUNotificationPost(payUOrderNotification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayUOrderNotification} [payUOrderNotification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopPayUNotificationApi
     */
    public apiShopShopPayUNotificationPost(payUOrderNotification?: PayUOrderNotification, options?: any) {
        return ShopPayUNotificationApiFp(this.configuration).apiShopShopPayUNotificationPost(payUOrderNotification, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopProductApi - axios parameter creator
 * @export
 */
export const ShopProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopProduct/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopProduct/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductProductUpdateDto} [shopProductProductUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductIdPut: async (id: number, shopProductProductUpdateDto?: ShopProductProductUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopProduct/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductProductUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} categoryId 
         * @param {Direction} direction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPositionIdCategoryIdDirectionPatch: async (id: number, categoryId: number, direction: Direction, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductPositionIdCategoryIdDirectionPatch', 'id', id)
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('apiShopShopProductPositionIdCategoryIdDirectionPatch', 'categoryId', categoryId)
            // verify required parameter 'direction' is not null or undefined
            assertParamExists('apiShopShopProductPositionIdCategoryIdDirectionPatch', 'direction', direction)
            const localVarPath = `/api/shop/ShopProduct/Position/{id}/{categoryId}/{direction}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)))
                .replace(`{${"direction"}}`, encodeURIComponent(String(direction)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopProductProductCreateDto} [shopProductProductCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPost: async (shopProductProductCreateDto?: ShopProductProductCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductProductCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductProductCategoryLinksGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProduct/ProductCategoryLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductProductIdSoftDeleteCategoryIdDelete: async (productId: number, categoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiShopShopProductProductIdSoftDeleteCategoryIdDelete', 'productId', productId)
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('apiShopShopProductProductIdSoftDeleteCategoryIdDelete', 'categoryId', categoryId)
            const localVarPath = `/api/shop/ShopProduct/{productId}/softDelete/{categoryId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopProductProductTagsUpdateDto} [shopProductProductTagsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductTagsPut: async (shopProductProductTagsUpdateDto?: ShopProductProductTagsUpdateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProduct/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductProductTagsUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopProductApi - functional programming interface
 * @export
 */
export const ShopProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductProductUpdateDto} [shopProductProductUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductIdPut(id: number, shopProductProductUpdateDto?: ShopProductProductUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductIdPut(id, shopProductProductUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} categoryId 
         * @param {Direction} direction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPositionIdCategoryIdDirectionPatch(id: number, categoryId: number, direction: Direction, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopCategoryProductCategoryProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPositionIdCategoryIdDirectionPatch(id, categoryId, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopProductProductCreateDto} [shopProductProductCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPost(shopProductProductCreateDto?: ShopProductProductCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPost(shopProductProductCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductProductCategoryLinksGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopCategoryProductCategoryProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductProductCategoryLinksGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductProductIdSoftDeleteCategoryIdDelete(productId: number, categoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductProductIdSoftDeleteCategoryIdDelete(productId, categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopProductProductTagsUpdateDto} [shopProductProductTagsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductTagsPut(shopProductProductTagsUpdateDto?: ShopProductProductTagsUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductProductDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductTagsPut(shopProductProductTagsUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopProductApi - factory interface
 * @export
 */
export const ShopProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopProductApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductGet(options?: any): AxiosPromise<Array<ShopProductProductDto>> {
            return localVarFp.apiShopShopProductGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopProductIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductIdGet(id: number, options?: any): AxiosPromise<ShopProductProductDetailsDto> {
            return localVarFp.apiShopShopProductIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductProductUpdateDto} [shopProductProductUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductIdPut(id: number, shopProductProductUpdateDto?: ShopProductProductUpdateDto, options?: any): AxiosPromise<ShopProductProductDetailsDto> {
            return localVarFp.apiShopShopProductIdPut(id, shopProductProductUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} categoryId 
         * @param {Direction} direction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPositionIdCategoryIdDirectionPatch(id: number, categoryId: number, direction: Direction, options?: any): AxiosPromise<Array<ShopCategoryProductCategoryProductDto>> {
            return localVarFp.apiShopShopProductPositionIdCategoryIdDirectionPatch(id, categoryId, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopProductProductCreateDto} [shopProductProductCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPost(shopProductProductCreateDto?: ShopProductProductCreateDto, options?: any): AxiosPromise<ShopProductProductDetailsDto> {
            return localVarFp.apiShopShopProductPost(shopProductProductCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductProductCategoryLinksGet(options?: any): AxiosPromise<Array<ShopCategoryProductCategoryProductDto>> {
            return localVarFp.apiShopShopProductProductCategoryLinksGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductProductIdSoftDeleteCategoryIdDelete(productId: number, categoryId: number, options?: any): AxiosPromise<ShopProductProductDto> {
            return localVarFp.apiShopShopProductProductIdSoftDeleteCategoryIdDelete(productId, categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopProductProductTagsUpdateDto} [shopProductProductTagsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductTagsPut(shopProductProductTagsUpdateDto?: ShopProductProductTagsUpdateDto, options?: any): AxiosPromise<ShopProductProductDetailsDto> {
            return localVarFp.apiShopShopProductTagsPut(shopProductProductTagsUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopProductApi - object-oriented interface
 * @export
 * @class ShopProductApi
 * @extends {BaseAPI}
 */
export class ShopProductApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductGet(options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductIdDelete(id: number, options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductIdGet(id: number, options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopProductProductUpdateDto} [shopProductProductUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductIdPut(id: number, shopProductProductUpdateDto?: ShopProductProductUpdateDto, options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductIdPut(id, shopProductProductUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} categoryId 
     * @param {Direction} direction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductPositionIdCategoryIdDirectionPatch(id: number, categoryId: number, direction: Direction, options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductPositionIdCategoryIdDirectionPatch(id, categoryId, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopProductProductCreateDto} [shopProductProductCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductPost(shopProductProductCreateDto?: ShopProductProductCreateDto, options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductPost(shopProductProductCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductProductCategoryLinksGet(options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductProductCategoryLinksGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {number} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductProductIdSoftDeleteCategoryIdDelete(productId: number, categoryId: number, options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductProductIdSoftDeleteCategoryIdDelete(productId, categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopProductProductTagsUpdateDto} [shopProductProductTagsUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductApi
     */
    public apiShopShopProductTagsPut(shopProductProductTagsUpdateDto?: ShopProductProductTagsUpdateDto, options?: any) {
        return ShopProductApiFp(this.configuration).apiShopShopProductTagsPut(shopProductProductTagsUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopProductDetailApi - axios parameter creator
 * @export
 */
export const ShopProductDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductDetailIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopProductDetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductDetailIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopProductDetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductDetailProductDetailUpdateDto} [shopProductDetailProductDetailUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailIdPut: async (id: number, shopProductDetailProductDetailUpdateDto?: ShopProductDetailProductDetailUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductDetailIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopProductDetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductDetailProductDetailUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopProductDetailProductDetailCreateDto} [shopProductDetailProductDetailCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailPost: async (shopProductDetailProductDetailCreateDto?: ShopProductDetailProductDetailCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductDetailProductDetailCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailProductDetailsProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiShopShopProductDetailProductDetailsProductIdGet', 'productId', productId)
            const localVarPath = `/api/shop/ShopProductDetail/productDetails/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopProductDetailApi - functional programming interface
 * @export
 */
export const ShopProductDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopProductDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductDetailGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductDetailProductDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductDetailGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductDetailIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductDetailIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductDetailIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductDetailProductDetailDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductDetailIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductDetailProductDetailUpdateDto} [shopProductDetailProductDetailUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductDetailIdPut(id: number, shopProductDetailProductDetailUpdateDto?: ShopProductDetailProductDetailUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductDetailProductDetailDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductDetailIdPut(id, shopProductDetailProductDetailUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopProductDetailProductDetailCreateDto} [shopProductDetailProductDetailCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductDetailPost(shopProductDetailProductDetailCreateDto?: ShopProductDetailProductDetailCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductDetailProductDetailDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductDetailPost(shopProductDetailProductDetailCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductDetailProductDetailsProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductDetailProductDetailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductDetailProductDetailsProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopProductDetailApi - factory interface
 * @export
 */
export const ShopProductDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopProductDetailApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailGet(options?: any): AxiosPromise<Array<ShopProductDetailProductDetailDto>> {
            return localVarFp.apiShopShopProductDetailGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopProductDetailIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailIdGet(id: number, options?: any): AxiosPromise<ShopProductDetailProductDetailDetailsDto> {
            return localVarFp.apiShopShopProductDetailIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductDetailProductDetailUpdateDto} [shopProductDetailProductDetailUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailIdPut(id: number, shopProductDetailProductDetailUpdateDto?: ShopProductDetailProductDetailUpdateDto, options?: any): AxiosPromise<ShopProductDetailProductDetailDetailsDto> {
            return localVarFp.apiShopShopProductDetailIdPut(id, shopProductDetailProductDetailUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopProductDetailProductDetailCreateDto} [shopProductDetailProductDetailCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailPost(shopProductDetailProductDetailCreateDto?: ShopProductDetailProductDetailCreateDto, options?: any): AxiosPromise<ShopProductDetailProductDetailDetailsDto> {
            return localVarFp.apiShopShopProductDetailPost(shopProductDetailProductDetailCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductDetailProductDetailsProductIdGet(productId: number, options?: any): AxiosPromise<Array<ShopProductDetailProductDetailDto>> {
            return localVarFp.apiShopShopProductDetailProductDetailsProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopProductDetailApi - object-oriented interface
 * @export
 * @class ShopProductDetailApi
 * @extends {BaseAPI}
 */
export class ShopProductDetailApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductDetailApi
     */
    public apiShopShopProductDetailGet(options?: any) {
        return ShopProductDetailApiFp(this.configuration).apiShopShopProductDetailGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductDetailApi
     */
    public apiShopShopProductDetailIdDelete(id: number, options?: any) {
        return ShopProductDetailApiFp(this.configuration).apiShopShopProductDetailIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductDetailApi
     */
    public apiShopShopProductDetailIdGet(id: number, options?: any) {
        return ShopProductDetailApiFp(this.configuration).apiShopShopProductDetailIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopProductDetailProductDetailUpdateDto} [shopProductDetailProductDetailUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductDetailApi
     */
    public apiShopShopProductDetailIdPut(id: number, shopProductDetailProductDetailUpdateDto?: ShopProductDetailProductDetailUpdateDto, options?: any) {
        return ShopProductDetailApiFp(this.configuration).apiShopShopProductDetailIdPut(id, shopProductDetailProductDetailUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopProductDetailProductDetailCreateDto} [shopProductDetailProductDetailCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductDetailApi
     */
    public apiShopShopProductDetailPost(shopProductDetailProductDetailCreateDto?: ShopProductDetailProductDetailCreateDto, options?: any) {
        return ShopProductDetailApiFp(this.configuration).apiShopShopProductDetailPost(shopProductDetailProductDetailCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductDetailApi
     */
    public apiShopShopProductDetailProductDetailsProductIdGet(productId: number, options?: any) {
        return ShopProductDetailApiFp(this.configuration).apiShopShopProductDetailProductDetailsProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopProductImageApi - axios parameter creator
 * @export
 */
export const ShopProductImageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductImageIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopProductImage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdFileStreamGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductImageIdFileStreamGet', 'id', id)
            const localVarPath = `/api/shop/ShopProductImage/{id}/FileStream`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductImageIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopProductImage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdPatch: async (id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductImageIdPatch', 'id', id)
            const localVarPath = `/api/shop/ShopProductImage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductImageProductImageUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdPut: async (id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductImageIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopProductImage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductImageProductImageUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [position] 
         * @param {any} [file] 
         * @param {string} [fileName] 
         * @param {string} [contentType] 
         * @param {string} [blobName] 
         * @param {number} [id] 
         * @param {string} [createdAt] 
         * @param {number} [createdById] 
         * @param {string} [updatedAt] 
         * @param {number} [updatedById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImagePost: async (position?: number, file?: any, fileName?: string, contentType?: string, blobName?: string, id?: number, createdAt?: string, createdById?: number, updatedAt?: string, updatedById?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


            if (position !== undefined) { 
                localVarFormParams.append('Position', position as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
            if (contentType !== undefined) { 
                localVarFormParams.append('ContentType', contentType as any);
            }
    
            if (blobName !== undefined) { 
                localVarFormParams.append('BlobName', blobName as any);
            }
    
            if (id !== undefined) { 
                localVarFormParams.append('Id', id as any);
            }
    
            if (createdAt !== undefined) { 
                localVarFormParams.append('CreatedAt', createdAt as any);
            }
    
            if (createdById !== undefined) { 
                localVarFormParams.append('CreatedById', createdById as any);
            }
    
            if (updatedAt !== undefined) { 
                localVarFormParams.append('UpdatedAt', updatedAt as any);
            }
    
            if (updatedById !== undefined) { 
                localVarFormParams.append('UpdatedById', updatedById as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageProductImagesProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiShopShopProductImageProductImagesProductIdGet', 'productId', productId)
            const localVarPath = `/api/shop/ShopProductImage/ProductImages/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopProductImageApi - functional programming interface
 * @export
 */
export const ShopProductImageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopProductImageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImageGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductImageProductImageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImageGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImageIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImageIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImageIdFileStreamGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImageIdFileStreamGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImageIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductImageProductImageDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImageIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImageIdPatch(id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductImageProductImageDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImageIdPatch(id, shopProductImageProductImageUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImageIdPut(id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductImageProductImageDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImageIdPut(id, shopProductImageProductImageUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [position] 
         * @param {any} [file] 
         * @param {string} [fileName] 
         * @param {string} [contentType] 
         * @param {string} [blobName] 
         * @param {number} [id] 
         * @param {string} [createdAt] 
         * @param {number} [createdById] 
         * @param {string} [updatedAt] 
         * @param {number} [updatedById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImagePost(position?: number, file?: any, fileName?: string, contentType?: string, blobName?: string, id?: number, createdAt?: string, createdById?: number, updatedAt?: string, updatedById?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductImageProductImageDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImagePost(position, file, fileName, contentType, blobName, id, createdAt, createdById, updatedAt, updatedById, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductImageProductImagesProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductImageProductImageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductImageProductImagesProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopProductImageApi - factory interface
 * @export
 */
export const ShopProductImageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopProductImageApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageGet(options?: any): AxiosPromise<Array<ShopProductImageProductImageDto>> {
            return localVarFp.apiShopShopProductImageGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopProductImageIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdFileStreamGet(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopProductImageIdFileStreamGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdGet(id: number, options?: any): AxiosPromise<ShopProductImageProductImageDetailsDto> {
            return localVarFp.apiShopShopProductImageIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdPatch(id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options?: any): AxiosPromise<ShopProductImageProductImageDetailsDto> {
            return localVarFp.apiShopShopProductImageIdPatch(id, shopProductImageProductImageUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageIdPut(id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options?: any): AxiosPromise<ShopProductImageProductImageDetailsDto> {
            return localVarFp.apiShopShopProductImageIdPut(id, shopProductImageProductImageUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [position] 
         * @param {any} [file] 
         * @param {string} [fileName] 
         * @param {string} [contentType] 
         * @param {string} [blobName] 
         * @param {number} [id] 
         * @param {string} [createdAt] 
         * @param {number} [createdById] 
         * @param {string} [updatedAt] 
         * @param {number} [updatedById] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImagePost(position?: number, file?: any, fileName?: string, contentType?: string, blobName?: string, id?: number, createdAt?: string, createdById?: number, updatedAt?: string, updatedById?: number, options?: any): AxiosPromise<ShopProductImageProductImageDetailsDto> {
            return localVarFp.apiShopShopProductImagePost(position, file, fileName, contentType, blobName, id, createdAt, createdById, updatedAt, updatedById, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductImageProductImagesProductIdGet(productId: number, options?: any): AxiosPromise<Array<ShopProductImageProductImageDto>> {
            return localVarFp.apiShopShopProductImageProductImagesProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopProductImageApi - object-oriented interface
 * @export
 * @class ShopProductImageApi
 * @extends {BaseAPI}
 */
export class ShopProductImageApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImageGet(options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImageGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImageIdDelete(id: number, options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImageIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImageIdFileStreamGet(id: number, options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImageIdFileStreamGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImageIdGet(id: number, options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImageIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImageIdPatch(id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImageIdPatch(id, shopProductImageProductImageUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopProductImageProductImageUpdateDto} [shopProductImageProductImageUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImageIdPut(id: number, shopProductImageProductImageUpdateDto?: ShopProductImageProductImageUpdateDto, options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImageIdPut(id, shopProductImageProductImageUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [position] 
     * @param {any} [file] 
     * @param {string} [fileName] 
     * @param {string} [contentType] 
     * @param {string} [blobName] 
     * @param {number} [id] 
     * @param {string} [createdAt] 
     * @param {number} [createdById] 
     * @param {string} [updatedAt] 
     * @param {number} [updatedById] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImagePost(position?: number, file?: any, fileName?: string, contentType?: string, blobName?: string, id?: number, createdAt?: string, createdById?: number, updatedAt?: string, updatedById?: number, options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImagePost(position, file, fileName, contentType, blobName, id, createdAt, createdById, updatedAt, updatedById, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductImageApi
     */
    public apiShopShopProductImageProductImagesProductIdGet(productId: number, options?: any) {
        return ShopProductImageApiFp(this.configuration).apiShopShopProductImageProductImagesProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopProductPriceApi - axios parameter creator
 * @export
 */
export const ShopProductPriceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductPriceIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductPriceIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductPriceProductPriceUpdateDto} [shopProductPriceProductPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceIdPut: async (id: number, shopProductPriceProductPriceUpdateDto?: ShopProductPriceProductPriceUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductPriceIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopProductPrice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductPriceProductPriceUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopProductPriceProductPriceCreateDto} [shopProductPriceProductPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPricePost: async (shopProductPriceProductPriceCreateDto?: ShopProductPriceProductPriceCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductPrice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductPriceProductPriceCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceProductPricesProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiShopShopProductPriceProductPricesProductIdGet', 'productId', productId)
            const localVarPath = `/api/shop/ShopProductPrice/productPrices/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceProductsPricesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductPrice/productsPrices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopProductPriceApi - functional programming interface
 * @export
 */
export const ShopProductPriceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopProductPriceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPriceGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductPriceProductPriceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPriceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPriceIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPriceIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPriceIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductPriceProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPriceIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductPriceProductPriceUpdateDto} [shopProductPriceProductPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPriceIdPut(id: number, shopProductPriceProductPriceUpdateDto?: ShopProductPriceProductPriceUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductPriceProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPriceIdPut(id, shopProductPriceProductPriceUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopProductPriceProductPriceCreateDto} [shopProductPriceProductPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPricePost(shopProductPriceProductPriceCreateDto?: ShopProductPriceProductPriceCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductPriceProductPriceDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPricePost(shopProductPriceProductPriceCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPriceProductPricesProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductPriceProductPriceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPriceProductPricesProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductPriceProductsPricesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductPriceProductPriceForShopDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductPriceProductsPricesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopProductPriceApi - factory interface
 * @export
 */
export const ShopProductPriceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopProductPriceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceGet(options?: any): AxiosPromise<Array<ShopProductPriceProductPriceDto>> {
            return localVarFp.apiShopShopProductPriceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopProductPriceIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceIdGet(id: number, options?: any): AxiosPromise<ShopProductPriceProductPriceDetailsDto> {
            return localVarFp.apiShopShopProductPriceIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductPriceProductPriceUpdateDto} [shopProductPriceProductPriceUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceIdPut(id: number, shopProductPriceProductPriceUpdateDto?: ShopProductPriceProductPriceUpdateDto, options?: any): AxiosPromise<ShopProductPriceProductPriceDetailsDto> {
            return localVarFp.apiShopShopProductPriceIdPut(id, shopProductPriceProductPriceUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopProductPriceProductPriceCreateDto} [shopProductPriceProductPriceCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPricePost(shopProductPriceProductPriceCreateDto?: ShopProductPriceProductPriceCreateDto, options?: any): AxiosPromise<ShopProductPriceProductPriceDetailsDto> {
            return localVarFp.apiShopShopProductPricePost(shopProductPriceProductPriceCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceProductPricesProductIdGet(productId: number, options?: any): AxiosPromise<Array<ShopProductPriceProductPriceDto>> {
            return localVarFp.apiShopShopProductPriceProductPricesProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductPriceProductsPricesGet(options?: any): AxiosPromise<Array<ShopProductPriceProductPriceForShopDto>> {
            return localVarFp.apiShopShopProductPriceProductsPricesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopProductPriceApi - object-oriented interface
 * @export
 * @class ShopProductPriceApi
 * @extends {BaseAPI}
 */
export class ShopProductPriceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductPriceApi
     */
    public apiShopShopProductPriceGet(options?: any) {
        return ShopProductPriceApiFp(this.configuration).apiShopShopProductPriceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductPriceApi
     */
    public apiShopShopProductPriceIdDelete(id: number, options?: any) {
        return ShopProductPriceApiFp(this.configuration).apiShopShopProductPriceIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductPriceApi
     */
    public apiShopShopProductPriceIdGet(id: number, options?: any) {
        return ShopProductPriceApiFp(this.configuration).apiShopShopProductPriceIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopProductPriceProductPriceUpdateDto} [shopProductPriceProductPriceUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductPriceApi
     */
    public apiShopShopProductPriceIdPut(id: number, shopProductPriceProductPriceUpdateDto?: ShopProductPriceProductPriceUpdateDto, options?: any) {
        return ShopProductPriceApiFp(this.configuration).apiShopShopProductPriceIdPut(id, shopProductPriceProductPriceUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopProductPriceProductPriceCreateDto} [shopProductPriceProductPriceCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductPriceApi
     */
    public apiShopShopProductPricePost(shopProductPriceProductPriceCreateDto?: ShopProductPriceProductPriceCreateDto, options?: any) {
        return ShopProductPriceApiFp(this.configuration).apiShopShopProductPricePost(shopProductPriceProductPriceCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductPriceApi
     */
    public apiShopShopProductPriceProductPricesProductIdGet(productId: number, options?: any) {
        return ShopProductPriceApiFp(this.configuration).apiShopShopProductPriceProductPricesProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductPriceApi
     */
    public apiShopShopProductPriceProductsPricesGet(options?: any) {
        return ShopProductPriceApiFp(this.configuration).apiShopShopProductPriceProductsPricesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopProductStatisticsApi - axios parameter creator
 * @export
 */
export const ShopProductStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductStatisticsIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopProductStatistics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductStatisticsIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopProductStatistics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductStatisticProductStatisticsUpdateDto} [shopProductStatisticProductStatisticsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsIdPut: async (id: number, shopProductStatisticProductStatisticsUpdateDto?: ShopProductStatisticProductStatisticsUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopProductStatisticsIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopProductStatistics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductStatisticProductStatisticsUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopProductStatisticProductStatisticsCreateDto} [shopProductStatisticProductStatisticsCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsPost: async (shopProductStatisticProductStatisticsCreateDto?: ShopProductStatisticProductStatisticsCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopProductStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopProductStatisticProductStatisticsCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsProductStatisticsProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiShopShopProductStatisticsProductStatisticsProductIdGet', 'productId', productId)
            const localVarPath = `/api/shop/ShopProductStatistics/productStatistics/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopProductStatisticsApi - functional programming interface
 * @export
 */
export const ShopProductStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopProductStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductStatisticsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductStatisticProductStatisticsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductStatisticsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductStatisticsIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductStatisticsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductStatisticsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductStatisticProductStatisticsDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductStatisticsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductStatisticProductStatisticsUpdateDto} [shopProductStatisticProductStatisticsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductStatisticsIdPut(id: number, shopProductStatisticProductStatisticsUpdateDto?: ShopProductStatisticProductStatisticsUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductStatisticProductStatisticsDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductStatisticsIdPut(id, shopProductStatisticProductStatisticsUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopProductStatisticProductStatisticsCreateDto} [shopProductStatisticProductStatisticsCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductStatisticsPost(shopProductStatisticProductStatisticsCreateDto?: ShopProductStatisticProductStatisticsCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopProductStatisticProductStatisticsDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductStatisticsPost(shopProductStatisticProductStatisticsCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopProductStatisticsProductStatisticsProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopProductStatisticProductStatisticsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopProductStatisticsProductStatisticsProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopProductStatisticsApi - factory interface
 * @export
 */
export const ShopProductStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopProductStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsGet(options?: any): AxiosPromise<Array<ShopProductStatisticProductStatisticsDto>> {
            return localVarFp.apiShopShopProductStatisticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopProductStatisticsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsIdGet(id: number, options?: any): AxiosPromise<ShopProductStatisticProductStatisticsDetailsDto> {
            return localVarFp.apiShopShopProductStatisticsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopProductStatisticProductStatisticsUpdateDto} [shopProductStatisticProductStatisticsUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsIdPut(id: number, shopProductStatisticProductStatisticsUpdateDto?: ShopProductStatisticProductStatisticsUpdateDto, options?: any): AxiosPromise<ShopProductStatisticProductStatisticsDetailsDto> {
            return localVarFp.apiShopShopProductStatisticsIdPut(id, shopProductStatisticProductStatisticsUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopProductStatisticProductStatisticsCreateDto} [shopProductStatisticProductStatisticsCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsPost(shopProductStatisticProductStatisticsCreateDto?: ShopProductStatisticProductStatisticsCreateDto, options?: any): AxiosPromise<ShopProductStatisticProductStatisticsDetailsDto> {
            return localVarFp.apiShopShopProductStatisticsPost(shopProductStatisticProductStatisticsCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopProductStatisticsProductStatisticsProductIdGet(productId: number, options?: any): AxiosPromise<Array<ShopProductStatisticProductStatisticsDto>> {
            return localVarFp.apiShopShopProductStatisticsProductStatisticsProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopProductStatisticsApi - object-oriented interface
 * @export
 * @class ShopProductStatisticsApi
 * @extends {BaseAPI}
 */
export class ShopProductStatisticsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductStatisticsApi
     */
    public apiShopShopProductStatisticsGet(options?: any) {
        return ShopProductStatisticsApiFp(this.configuration).apiShopShopProductStatisticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductStatisticsApi
     */
    public apiShopShopProductStatisticsIdDelete(id: number, options?: any) {
        return ShopProductStatisticsApiFp(this.configuration).apiShopShopProductStatisticsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductStatisticsApi
     */
    public apiShopShopProductStatisticsIdGet(id: number, options?: any) {
        return ShopProductStatisticsApiFp(this.configuration).apiShopShopProductStatisticsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopProductStatisticProductStatisticsUpdateDto} [shopProductStatisticProductStatisticsUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductStatisticsApi
     */
    public apiShopShopProductStatisticsIdPut(id: number, shopProductStatisticProductStatisticsUpdateDto?: ShopProductStatisticProductStatisticsUpdateDto, options?: any) {
        return ShopProductStatisticsApiFp(this.configuration).apiShopShopProductStatisticsIdPut(id, shopProductStatisticProductStatisticsUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopProductStatisticProductStatisticsCreateDto} [shopProductStatisticProductStatisticsCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductStatisticsApi
     */
    public apiShopShopProductStatisticsPost(shopProductStatisticProductStatisticsCreateDto?: ShopProductStatisticProductStatisticsCreateDto, options?: any) {
        return ShopProductStatisticsApiFp(this.configuration).apiShopShopProductStatisticsPost(shopProductStatisticProductStatisticsCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopProductStatisticsApi
     */
    public apiShopShopProductStatisticsProductStatisticsProductIdGet(productId: number, options?: any) {
        return ShopProductStatisticsApiFp(this.configuration).apiShopShopProductStatisticsProductStatisticsProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShopTagApi - axios parameter creator
 * @export
 */
export const ShopTagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopTagIdDelete', 'id', id)
            const localVarPath = `/api/shop/ShopTag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopTagIdGet', 'id', id)
            const localVarPath = `/api/shop/ShopTag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopTagTagUpdateDto} [shopTagTagUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagIdPut: async (id: number, shopTagTagUpdateDto?: ShopTagTagUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiShopShopTagIdPut', 'id', id)
            const localVarPath = `/api/shop/ShopTag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopTagTagUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ShopTagTagCreateDto} [shopTagTagCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagPost: async (shopTagTagCreateDto?: ShopTagTagCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shop/ShopTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopTagTagCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagTagsProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiShopShopTagTagsProductIdGet', 'productId', productId)
            const localVarPath = `/api/shop/ShopTag/tags/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShopTagApi - functional programming interface
 * @export
 */
export const ShopTagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShopTagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopTagGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopTagTagDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopTagGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopTagIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopTagIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopTagIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopTagTagDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopTagIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopTagTagUpdateDto} [shopTagTagUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopTagIdPut(id: number, shopTagTagUpdateDto?: ShopTagTagUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopTagTagDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopTagIdPut(id, shopTagTagUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ShopTagTagCreateDto} [shopTagTagCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopTagPost(shopTagTagCreateDto?: ShopTagTagCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopTagTagDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopTagPost(shopTagTagCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiShopShopTagTagsProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShopTagTagDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiShopShopTagTagsProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShopTagApi - factory interface
 * @export
 */
export const ShopTagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShopTagApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagGet(options?: any): AxiosPromise<Array<ShopTagTagDto>> {
            return localVarFp.apiShopShopTagGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiShopShopTagIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagIdGet(id: number, options?: any): AxiosPromise<ShopTagTagDetailsDto> {
            return localVarFp.apiShopShopTagIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ShopTagTagUpdateDto} [shopTagTagUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagIdPut(id: number, shopTagTagUpdateDto?: ShopTagTagUpdateDto, options?: any): AxiosPromise<ShopTagTagDetailsDto> {
            return localVarFp.apiShopShopTagIdPut(id, shopTagTagUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShopTagTagCreateDto} [shopTagTagCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagPost(shopTagTagCreateDto?: ShopTagTagCreateDto, options?: any): AxiosPromise<ShopTagTagDetailsDto> {
            return localVarFp.apiShopShopTagPost(shopTagTagCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiShopShopTagTagsProductIdGet(productId: number, options?: any): AxiosPromise<Array<ShopTagTagDto>> {
            return localVarFp.apiShopShopTagTagsProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShopTagApi - object-oriented interface
 * @export
 * @class ShopTagApi
 * @extends {BaseAPI}
 */
export class ShopTagApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopTagApi
     */
    public apiShopShopTagGet(options?: any) {
        return ShopTagApiFp(this.configuration).apiShopShopTagGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopTagApi
     */
    public apiShopShopTagIdDelete(id: number, options?: any) {
        return ShopTagApiFp(this.configuration).apiShopShopTagIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopTagApi
     */
    public apiShopShopTagIdGet(id: number, options?: any) {
        return ShopTagApiFp(this.configuration).apiShopShopTagIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ShopTagTagUpdateDto} [shopTagTagUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopTagApi
     */
    public apiShopShopTagIdPut(id: number, shopTagTagUpdateDto?: ShopTagTagUpdateDto, options?: any) {
        return ShopTagApiFp(this.configuration).apiShopShopTagIdPut(id, shopTagTagUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShopTagTagCreateDto} [shopTagTagCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopTagApi
     */
    public apiShopShopTagPost(shopTagTagCreateDto?: ShopTagTagCreateDto, options?: any) {
        return ShopTagApiFp(this.configuration).apiShopShopTagPost(shopTagTagCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopTagApi
     */
    public apiShopShopTagTagsProductIdGet(productId: number, options?: any) {
        return ShopTagApiFp(this.configuration).apiShopShopTagTagsProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockApi - axios parameter creator
 * @export
 */
export const StockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllFinalProductsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/getAllFinalProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetBottlesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/getBottles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} batchNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdBatchBatchNumberGet: async (productId: number, batchNumber: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdBatchBatchNumberGet', 'productId', productId)
            // verify required parameter 'batchNumber' is not null or undefined
            assertParamExists('apiStockStockProductProductIdBatchBatchNumberGet', 'batchNumber', batchNumber)
            const localVarPath = `/api/Stock/stock/product/{productId}/batch/{batchNumber}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"batchNumber"}}`, encodeURIComponent(String(batchNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdGet: async (productId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdGet', 'productId', productId)
            const localVarPath = `/api/Stock/stock/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdWarehouseWarehouseIdGet: async (productId: number, warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdWarehouseWarehouseIdGet', 'productId', productId)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockStockProductProductIdWarehouseWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Stock/stock/product/{productId}/warehouse/{warehouseId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessGetAllGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Stock/stock/ProductionProcess/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessProductionProcessIdGet: async (productionProcessId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productionProcessId' is not null or undefined
            assertParamExists('apiStockStockProductionProcessProductionProcessIdGet', 'productionProcessId', productionProcessId)
            const localVarPath = `/api/Stock/stock/ProductionProcess/{productionProcessId}`
                .replace(`{${"productionProcessId"}}`, encodeURIComponent(String(productionProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockStockWarehouseWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Stock/stock/warehouse/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWithSubwarehousesWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockStockWarehouseWithSubwarehousesWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Stock/stock/warehouseWithSubwarehouses/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockApi - functional programming interface
 * @export
 */
export const StockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockGetAllFinalProductsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockGetAllFinalProductsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockGetAllGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockGetAllGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockGetBottlesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockGetBottlesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} batchNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductProductIdBatchBatchNumberGet(productId: number, batchNumber: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductProductIdBatchBatchNumberGet(productId, batchNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductProductIdGet(productId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductProductIdGet(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductProductIdWarehouseWarehouseIdGet(productId: number, warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductProductIdWarehouseWarehouseIdGet(productId, warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductionProcessGetAllGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessStockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductionProcessGetAllGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockProductionProcessProductionProcessIdGet(productionProcessId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductionProcessStockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockProductionProcessProductionProcessIdGet(productionProcessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockWarehouseWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockWarehouseWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockApi - factory interface
 * @export
 */
export const StockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllFinalProductsGet(options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockGetAllFinalProductsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetAllGet(options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockGetAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockGetBottlesGet(options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockGetBottlesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {string} batchNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdBatchBatchNumberGet(productId: number, batchNumber: string, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockProductProductIdBatchBatchNumberGet(productId, batchNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdGet(productId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockProductProductIdGet(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productId 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductProductIdWarehouseWarehouseIdGet(productId: number, warehouseId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockProductProductIdWarehouseWarehouseIdGet(productId, warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessGetAllGet(options?: any): AxiosPromise<Array<ProductionProcessStockDto>> {
            return localVarFp.apiStockStockProductionProcessGetAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} productionProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockProductionProcessProductionProcessIdGet(productionProcessId: number, options?: any): AxiosPromise<Array<ProductionProcessStockDto>> {
            return localVarFp.apiStockStockProductionProcessProductionProcessIdGet(productionProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<StockDto>> {
            return localVarFp.apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockApi - object-oriented interface
 * @export
 * @class StockApi
 * @extends {BaseAPI}
 */
export class StockApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockGetAllFinalProductsGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockGetAllFinalProductsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockGetAllGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockGetAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockGetBottlesGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockGetBottlesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {string} batchNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductProductIdBatchBatchNumberGet(productId: number, batchNumber: string, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductProductIdBatchBatchNumberGet(productId, batchNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductProductIdGet(productId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductProductIdGet(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productId 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductProductIdWarehouseWarehouseIdGet(productId: number, warehouseId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductProductIdWarehouseWarehouseIdGet(productId, warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductionProcessGetAllGet(options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductionProcessGetAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} productionProcessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockProductionProcessProductionProcessIdGet(productionProcessId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockProductionProcessProductionProcessIdGet(productionProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockWarehouseWarehouseIdGet(warehouseId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockWarehouseWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockApi
     */
    public apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId: number, options?: any) {
        return StockApiFp(this.configuration).apiStockStockWarehouseWithSubwarehousesWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockOperationApi - axios parameter creator
 * @export
 */
export const StockOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [productId] 
         * @param {number} [warehouseId] 
         * @param {number} [stockOperationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationBatchNumbersGet: async (productId?: number, warehouseId?: number, stockOperationId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/batchNumbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }

            if (warehouseId !== undefined) {
                localVarQueryParameter['warehouseId'] = warehouseId;
            }

            if (stockOperationId !== undefined) {
                localVarQueryParameter['stockOperationId'] = stockOperationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} pipedriveDealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationByPipedriveDealPipedriveDealIdGet: async (pipedriveDealId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipedriveDealId' is not null or undefined
            assertParamExists('apiStockOperationByPipedriveDealPipedriveDealIdGet', 'pipedriveDealId', pipedriveDealId)
            const localVarPath = `/api/StockOperation/byPipedriveDeal/{pipedriveDealId}`
                .replace(`{${"pipedriveDealId"}}`, encodeURIComponent(String(pipedriveDealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {StockOperationType} [operationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationDocumentNumberGet: async (date?: string, operationType?: StockOperationType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/documentNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (operationType !== undefined) {
                localVarQueryParameter['operationType'] = operationType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForDateGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/getOrdersForDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForYearGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/getOrdersForYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdDelete', 'id', id)
            const localVarPath = `/api/StockOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdGet', 'id', id)
            const localVarPath = `/api/StockOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdPut: async (id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdPut', 'id', id)
            const localVarPath = `/api/StockOperation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdStatusPut: async (id: number, status?: StockOperationStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationIdStatusPut', 'id', id)
            const localVarPath = `/api/StockOperation/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationInvoicePreviewGet: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/InvoicePreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestDraftGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/latestDraft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestPublishedGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/latestPublished`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/minimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationMinimalIdGet', 'id', id)
            const localVarPath = `/api/StockOperation/minimal/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForDateGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/operationsForDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForYearGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/operationsForYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationPost: async (stockOperationCreateDto?: StockOperationCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationProductionStockOperationPost: async (stockOperationCreateDto?: StockOperationCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/ProductionStockOperation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationStatus} [status] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationStatusesPut: async (status?: StockOperationStatus, requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [documentNumber] 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationValidateDocumentNumberGet: async (documentNumber?: string, id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperation/validateDocumentNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (documentNumber !== undefined) {
                localVarQueryParameter['documentNumber'] = documentNumber;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockOperationApi - functional programming interface
 * @export
 */
export const StockOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [productId] 
         * @param {number} [warehouseId] 
         * @param {number} [stockOperationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationBatchNumbersGet(productId?: number, warehouseId?: number, stockOperationId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BatchNumberDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationBatchNumbersGet(productId, warehouseId, stockOperationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} pipedriveDealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {StockOperationType} [operationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationDocumentNumberGet(date?: string, operationType?: StockOperationType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationDocumentNumberGet(date, operationType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationGetOrdersForDateGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationGetOrdersForDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationGetOrdersForYearGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationGetOrdersForYearGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdPut(id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdPut(id, stockOperationUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationIdStatusPut(id: number, status?: StockOperationStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationIdStatusPut(id, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationInvoicePreviewGet(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicePreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationInvoicePreviewGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationLatestDraftGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationLatestDraftGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationLatestPublishedGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationLatestPublishedGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationMinimalGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationMinimalGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationMinimalIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationMinimalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationMinimalIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationOperationsForDateGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationOperationsForDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationOperationsForYearGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationOperationsForYearGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationPost(stockOperationCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationProductionStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationProductionStockOperationPost(stockOperationCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationStatus} [status] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationStatusesPut(status?: StockOperationStatus, requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationStatusesPut(status, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [documentNumber] 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationValidateDocumentNumberGet(documentNumber?: string, id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationValidateDocumentNumberGet(documentNumber, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockOperationApi - factory interface
 * @export
 */
export const StockOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockOperationApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [productId] 
         * @param {number} [warehouseId] 
         * @param {number} [stockOperationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationBatchNumbersGet(productId?: number, warehouseId?: number, stockOperationId?: number, options?: any): AxiosPromise<Array<BatchNumberDto>> {
            return localVarFp.apiStockOperationBatchNumbersGet(productId, warehouseId, stockOperationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} pipedriveDealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId: number, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {StockOperationType} [operationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationDocumentNumberGet(date?: string, operationType?: StockOperationType, options?: any): AxiosPromise<string> {
            return localVarFp.apiStockOperationDocumentNumberGet(date, operationType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGet(options?: any): AxiosPromise<Array<StockOperationDto>> {
            return localVarFp.apiStockOperationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForDateGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationGetOrdersForDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationGetOrdersForYearGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationGetOrdersForYearGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiStockOperationIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdGet(id: number, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdPut(id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationIdPut(id, stockOperationUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationIdStatusPut(id: number, status?: StockOperationStatus, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationIdStatusPut(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationInvoicePreviewGet(id?: number, options?: any): AxiosPromise<InvoicePreviewDto> {
            return localVarFp.apiStockOperationInvoicePreviewGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestDraftGet(options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationLatestDraftGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationLatestPublishedGet(options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationLatestPublishedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalGet(options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationMinimalGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationMinimalIdGet(id: number, options?: any): AxiosPromise<StockOperationMinimalDto> {
            return localVarFp.apiStockOperationMinimalIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForDateGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationOperationsForDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationOperationsForYearGet(date?: string, options?: any): AxiosPromise<Array<StockOperationMinimalWithWarehouseDto>> {
            return localVarFp.apiStockOperationOperationsForYearGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): AxiosPromise<StockOperationDetailsDto> {
            return localVarFp.apiStockOperationPost(stockOperationCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationCreateDto} [stockOperationCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationProductionStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any): AxiosPromise<StockOperationDto> {
            return localVarFp.apiStockOperationProductionStockOperationPost(stockOperationCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationStatus} [status] 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationStatusesPut(status?: StockOperationStatus, requestBody?: Array<number>, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiStockOperationStatusesPut(status, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [documentNumber] 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationValidateDocumentNumberGet(documentNumber?: string, id?: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiStockOperationValidateDocumentNumberGet(documentNumber, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockOperationApi - object-oriented interface
 * @export
 * @class StockOperationApi
 * @extends {BaseAPI}
 */
export class StockOperationApi extends BaseAPI {
    /**
     * 
     * @param {number} [productId] 
     * @param {number} [warehouseId] 
     * @param {number} [stockOperationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationBatchNumbersGet(productId?: number, warehouseId?: number, stockOperationId?: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationBatchNumbersGet(productId, warehouseId, stockOperationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} pipedriveDealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationByPipedriveDealPipedriveDealIdGet(pipedriveDealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {StockOperationType} [operationType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationDocumentNumberGet(date?: string, operationType?: StockOperationType, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationDocumentNumberGet(date, operationType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationGetOrdersForDateGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationGetOrdersForDateGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationGetOrdersForYearGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationGetOrdersForYearGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdDelete(id: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdGet(id: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationUpdateDto} [stockOperationUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdPut(id: number, stockOperationUpdateDto?: StockOperationUpdateDto, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdPut(id, stockOperationUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationIdStatusPut(id: number, status?: StockOperationStatus, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationIdStatusPut(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationInvoicePreviewGet(id?: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationInvoicePreviewGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationLatestDraftGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationLatestDraftGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationLatestPublishedGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationLatestPublishedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationMinimalGet(options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationMinimalGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationMinimalIdGet(id: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationMinimalIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationOperationsForDateGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationOperationsForDateGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationOperationsForYearGet(date?: string, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationOperationsForYearGet(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationCreateDto} [stockOperationCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationPost(stockOperationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationCreateDto} [stockOperationCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationProductionStockOperationPost(stockOperationCreateDto?: StockOperationCreateDto, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationProductionStockOperationPost(stockOperationCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationStatus} [status] 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationStatusesPut(status?: StockOperationStatus, requestBody?: Array<number>, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationStatusesPut(status, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [documentNumber] 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationApi
     */
    public apiStockOperationValidateDocumentNumberGet(documentNumber?: string, id?: number, options?: any) {
        return StockOperationApiFp(this.configuration).apiStockOperationValidateDocumentNumberGet(documentNumber, id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StockOperationUpdateHistoryApi - axios parameter creator
 * @export
 */
export const StockOperationUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperationUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryIdGet', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/history/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} batchNumber 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet: async (id: number, batchNumber: string, unitId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet', 'id', id)
            // verify required parameter 'batchNumber' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet', 'batchNumber', batchNumber)
            const localVarPath = `/api/StockOperationUpdateHistory/history/product/{id}/batch/{batchNumber}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"batchNumber"}}`, encodeURIComponent(String(batchNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet: async (id: number, warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet', 'id', id)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/StockOperationUpdateHistory/history/product/{id}/reservation/{warehouseId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet: async (id: number, warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet', 'id', id)
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/StockOperationUpdateHistory/history/product/{id}/{warehouseId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdPut: async (id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStockOperationUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/StockOperationUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryPost: async (stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/StockOperationUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stockOperationUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StockOperationUpdateHistoryApi - functional programming interface
 * @export
 */
export const StockOperationUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StockOperationUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} batchNumber 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id: number, batchNumber: string, unitId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockHistoryMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id, batchNumber, unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id: number, warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockOperationUpdateHistoryDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id, warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id: number, warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockHistoryMinimalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id, warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryIdPut(id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryIdPut(id, stockOperationUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StockOperationUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StockOperationUpdateHistoryApi - factory interface
 * @export
 */
export const StockOperationUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StockOperationUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryGet(options?: any): AxiosPromise<Array<StockOperationUpdateHistoryDto>> {
            return localVarFp.apiStockOperationUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryIdGet(id: number, options?: any): AxiosPromise<Array<StockOperationUpdateHistoryDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} batchNumber 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id: number, batchNumber: string, unitId?: number, options?: any): AxiosPromise<Array<StockHistoryMinimalDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id, batchNumber, unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id: number, warehouseId: number, options?: any): AxiosPromise<Array<StockOperationUpdateHistoryDetailsDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id, warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id: number, warehouseId: number, options?: any): AxiosPromise<Array<StockHistoryMinimalDto>> {
            return localVarFp.apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id, warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiStockOperationUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<StockOperationUpdateHistoryDetailsDto> {
            return localVarFp.apiStockOperationUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryIdPut(id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options?: any): AxiosPromise<StockOperationUpdateHistoryDetailsDto> {
            return localVarFp.apiStockOperationUpdateHistoryIdPut(id, stockOperationUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options?: any): AxiosPromise<StockOperationUpdateHistoryDetailsDto> {
            return localVarFp.apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StockOperationUpdateHistoryApi - object-oriented interface
 * @export
 * @class StockOperationUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class StockOperationUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryGet(options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryIdGet(id: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} batchNumber 
     * @param {number} [unitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id: number, batchNumber: string, unitId?: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryProductIdBatchBatchNumberGet(id, batchNumber, unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id: number, warehouseId: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryProductIdReservationWarehouseIdGet(id, warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id: number, warehouseId: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryHistoryProductIdWarehouseIdGet(id, warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryIdDelete(id: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryIdGet(id: number, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StockOperationUpdateHistoryUpdateDto} [stockOperationUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryIdPut(id: number, stockOperationUpdateHistoryUpdateDto?: StockOperationUpdateHistoryUpdateDto, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryIdPut(id, stockOperationUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StockOperationUpdateHistoryCreateDto} [stockOperationUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOperationUpdateHistoryApi
     */
    public apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto?: StockOperationUpdateHistoryCreateDto, options?: any) {
        return StockOperationUpdateHistoryApiFp(this.configuration).apiStockOperationUpdateHistoryPost(stockOperationUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StrainApi - axios parameter creator
 * @export
 */
export const StrainApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStrainIdDelete', 'id', id)
            const localVarPath = `/api/Strain/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStrainIdGet', 'id', id)
            const localVarPath = `/api/Strain/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StrainUpdateDto} [strainUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdPut: async (id: number, strainUpdateDto?: StrainUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiStrainIdPut', 'id', id)
            const localVarPath = `/api/Strain/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strainUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StrainCreateDto} [strainCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainPost: async (strainCreateDto?: StrainCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Strain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strainCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StrainApi - functional programming interface
 * @export
 */
export const StrainApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StrainApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StrainDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrainDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StrainUpdateDto} [strainUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainIdPut(id: number, strainUpdateDto?: StrainUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrainDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainIdPut(id, strainUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StrainCreateDto} [strainCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStrainPost(strainCreateDto?: StrainCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrainDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStrainPost(strainCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StrainApi - factory interface
 * @export
 */
export const StrainApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StrainApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainGet(options?: any): AxiosPromise<Array<StrainDto>> {
            return localVarFp.apiStrainGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiStrainIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdGet(id: number, options?: any): AxiosPromise<StrainDetailsDto> {
            return localVarFp.apiStrainIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StrainUpdateDto} [strainUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainIdPut(id: number, strainUpdateDto?: StrainUpdateDto, options?: any): AxiosPromise<StrainDetailsDto> {
            return localVarFp.apiStrainIdPut(id, strainUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StrainCreateDto} [strainCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStrainPost(strainCreateDto?: StrainCreateDto, options?: any): AxiosPromise<StrainDetailsDto> {
            return localVarFp.apiStrainPost(strainCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StrainApi - object-oriented interface
 * @export
 * @class StrainApi
 * @extends {BaseAPI}
 */
export class StrainApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainGet(options?: any) {
        return StrainApiFp(this.configuration).apiStrainGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainIdDelete(id: number, options?: any) {
        return StrainApiFp(this.configuration).apiStrainIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainIdGet(id: number, options?: any) {
        return StrainApiFp(this.configuration).apiStrainIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StrainUpdateDto} [strainUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainIdPut(id: number, strainUpdateDto?: StrainUpdateDto, options?: any) {
        return StrainApiFp(this.configuration).apiStrainIdPut(id, strainUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StrainCreateDto} [strainCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrainApi
     */
    public apiStrainPost(strainCreateDto?: StrainCreateDto, options?: any) {
        return StrainApiFp(this.configuration).apiStrainPost(strainCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UnitOfMeasureApi - axios parameter creator
 * @export
 */
export const UnitOfMeasureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} baseUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet: async (baseUnitId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUnitId' is not null or undefined
            assertParamExists('apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet', 'baseUnitId', baseUnitId)
            const localVarPath = `/api/UnitOfMeasure/auxiliaryUnits/{baseUnitId}`
                .replace(`{${"baseUnitId"}}`, encodeURIComponent(String(baseUnitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureBaseUnitsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitOfMeasure/baseUnits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitOfMeasure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitOfMeasureIdDelete', 'id', id)
            const localVarPath = `/api/UnitOfMeasure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitOfMeasureIdGet', 'id', id)
            const localVarPath = `/api/UnitOfMeasure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdPut: async (id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUnitOfMeasureIdPut', 'id', id)
            const localVarPath = `/api/UnitOfMeasure/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unitOfMeasureUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasurePost: async (unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/UnitOfMeasure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unitOfMeasureCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitOfMeasureApi - functional programming interface
 * @export
 */
export const UnitOfMeasureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitOfMeasureApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} baseUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitOfMeasureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureBaseUnitsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitOfMeasureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureBaseUnitsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnitOfMeasureDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitOfMeasureDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasureIdPut(id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitOfMeasureDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasureIdPut(id, unitOfMeasureUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUnitOfMeasurePost(unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitOfMeasureDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUnitOfMeasurePost(unitOfMeasureCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnitOfMeasureApi - factory interface
 * @export
 */
export const UnitOfMeasureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitOfMeasureApiFp(configuration)
    return {
        /**
         * 
         * @param {number} baseUnitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId: number, options?: any): AxiosPromise<Array<UnitOfMeasureDto>> {
            return localVarFp.apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureBaseUnitsGet(options?: any): AxiosPromise<Array<UnitOfMeasureDto>> {
            return localVarFp.apiUnitOfMeasureBaseUnitsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureGet(options?: any): AxiosPromise<Array<UnitOfMeasureDto>> {
            return localVarFp.apiUnitOfMeasureGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiUnitOfMeasureIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdGet(id: number, options?: any): AxiosPromise<UnitOfMeasureDetailsDto> {
            return localVarFp.apiUnitOfMeasureIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasureIdPut(id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options?: any): AxiosPromise<UnitOfMeasureDetailsDto> {
            return localVarFp.apiUnitOfMeasureIdPut(id, unitOfMeasureUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUnitOfMeasurePost(unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options?: any): AxiosPromise<UnitOfMeasureDetailsDto> {
            return localVarFp.apiUnitOfMeasurePost(unitOfMeasureCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnitOfMeasureApi - object-oriented interface
 * @export
 * @class UnitOfMeasureApi
 * @extends {BaseAPI}
 */
export class UnitOfMeasureApi extends BaseAPI {
    /**
     * 
     * @param {number} baseUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId: number, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureAuxiliaryUnitsBaseUnitIdGet(baseUnitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureBaseUnitsGet(options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureBaseUnitsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureGet(options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureIdDelete(id: number, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureIdGet(id: number, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UnitOfMeasureUpdateDto} [unitOfMeasureUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasureIdPut(id: number, unitOfMeasureUpdateDto?: UnitOfMeasureUpdateDto, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasureIdPut(id, unitOfMeasureUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitOfMeasureCreateDto} [unitOfMeasureCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitOfMeasureApi
     */
    public apiUnitOfMeasurePost(unitOfMeasureCreateDto?: UnitOfMeasureCreateDto, options?: any) {
        return UnitOfMeasureApiFp(this.configuration).apiUnitOfMeasurePost(unitOfMeasureCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VinificationAdditiveApi - axios parameter creator
 * @export
 */
export const VinificationAdditiveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VinificationAdditive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVinificationAdditiveIdDelete', 'id', id)
            const localVarPath = `/api/VinificationAdditive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVinificationAdditiveIdGet', 'id', id)
            const localVarPath = `/api/VinificationAdditive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdPut: async (id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVinificationAdditiveIdPut', 'id', id)
            const localVarPath = `/api/VinificationAdditive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vinificationAdditiveUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditivePost: async (vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VinificationAdditive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vinificationAdditiveCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VinificationAdditiveApi - functional programming interface
 * @export
 */
export const VinificationAdditiveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VinificationAdditiveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VinificationAdditiveDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VinificationAdditiveDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditiveIdPut(id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VinificationAdditiveDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditiveIdPut(id, vinificationAdditiveUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVinificationAdditivePost(vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VinificationAdditiveDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVinificationAdditivePost(vinificationAdditiveCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VinificationAdditiveApi - factory interface
 * @export
 */
export const VinificationAdditiveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VinificationAdditiveApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveGet(options?: any): AxiosPromise<Array<VinificationAdditiveDto>> {
            return localVarFp.apiVinificationAdditiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiVinificationAdditiveIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdGet(id: number, options?: any): AxiosPromise<VinificationAdditiveDetailsDto> {
            return localVarFp.apiVinificationAdditiveIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditiveIdPut(id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options?: any): AxiosPromise<VinificationAdditiveDetailsDto> {
            return localVarFp.apiVinificationAdditiveIdPut(id, vinificationAdditiveUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVinificationAdditivePost(vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options?: any): AxiosPromise<VinificationAdditiveDetailsDto> {
            return localVarFp.apiVinificationAdditivePost(vinificationAdditiveCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VinificationAdditiveApi - object-oriented interface
 * @export
 * @class VinificationAdditiveApi
 * @extends {BaseAPI}
 */
export class VinificationAdditiveApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveGet(options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveIdDelete(id: number, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveIdGet(id: number, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {VinificationAdditiveUpdateDto} [vinificationAdditiveUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditiveIdPut(id: number, vinificationAdditiveUpdateDto?: VinificationAdditiveUpdateDto, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditiveIdPut(id, vinificationAdditiveUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VinificationAdditiveCreateDto} [vinificationAdditiveCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VinificationAdditiveApi
     */
    public apiVinificationAdditivePost(vinificationAdditiveCreateDto?: VinificationAdditiveCreateDto, options?: any) {
        return VinificationAdditiveApiFp(this.configuration).apiVinificationAdditivePost(vinificationAdditiveCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WarehouseApi - axios parameter creator
 * @export
 */
export const WarehouseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Warehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseIdDelete', 'id', id)
            const localVarPath = `/api/Warehouse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseIdGet', 'id', id)
            const localVarPath = `/api/Warehouse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdPut: async (id: number, warehouseUpdateDto?: WarehouseUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseIdPut', 'id', id)
            const localVarPath = `/api/Warehouse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseParentWarehousesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Warehouse/parentWarehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WarehouseCreateDto} [warehouseCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehousePost: async (warehouseCreateDto?: WarehouseCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Warehouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseSubWarehousesWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiWarehouseSubWarehousesWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/Warehouse/subWarehouses/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseApi - functional programming interface
 * @export
 */
export const WarehouseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseIdPut(id: number, warehouseUpdateDto?: WarehouseUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseIdPut(id, warehouseUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseParentWarehousesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseParentWarehousesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WarehouseCreateDto} [warehouseCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehousePost(warehouseCreateDto?: WarehouseCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehousePost(warehouseCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseSubWarehousesWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseSubWarehousesWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WarehouseApi - factory interface
 * @export
 */
export const WarehouseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseGet(options?: any): AxiosPromise<Array<WarehouseDto>> {
            return localVarFp.apiWarehouseGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiWarehouseIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdGet(id: number, options?: any): AxiosPromise<WarehouseDetailsDto> {
            return localVarFp.apiWarehouseIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseIdPut(id: number, warehouseUpdateDto?: WarehouseUpdateDto, options?: any): AxiosPromise<WarehouseDetailsDto> {
            return localVarFp.apiWarehouseIdPut(id, warehouseUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseParentWarehousesGet(options?: any): AxiosPromise<Array<WarehouseDto>> {
            return localVarFp.apiWarehouseParentWarehousesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WarehouseCreateDto} [warehouseCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehousePost(warehouseCreateDto?: WarehouseCreateDto, options?: any): AxiosPromise<WarehouseDetailsDto> {
            return localVarFp.apiWarehousePost(warehouseCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseSubWarehousesWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<WarehouseDto>> {
            return localVarFp.apiWarehouseSubWarehousesWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseApi - object-oriented interface
 * @export
 * @class WarehouseApi
 * @extends {BaseAPI}
 */
export class WarehouseApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseGet(options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseIdDelete(id: number, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseIdGet(id: number, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {WarehouseUpdateDto} [warehouseUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseIdPut(id: number, warehouseUpdateDto?: WarehouseUpdateDto, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseIdPut(id, warehouseUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseParentWarehousesGet(options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseParentWarehousesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WarehouseCreateDto} [warehouseCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehousePost(warehouseCreateDto?: WarehouseCreateDto, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehousePost(warehouseCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseApi
     */
    public apiWarehouseSubWarehousesWarehouseIdGet(warehouseId: number, options?: any) {
        return WarehouseApiFp(this.configuration).apiWarehouseSubWarehousesWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WarehouseUpdateHistoryApi - axios parameter creator
 * @export
 */
export const WarehouseUpdateHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WarehouseUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryHistoryWarehouseIdGet: async (warehouseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'warehouseId' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryHistoryWarehouseIdGet', 'warehouseId', warehouseId)
            const localVarPath = `/api/WarehouseUpdateHistory/history/{warehouseId}`
                .replace(`{${"warehouseId"}}`, encodeURIComponent(String(warehouseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdDelete: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryIdDelete', 'id', id)
            const localVarPath = `/api/WarehouseUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryIdGet', 'id', id)
            const localVarPath = `/api/WarehouseUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdPut: async (id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiWarehouseUpdateHistoryIdPut', 'id', id)
            const localVarPath = `/api/WarehouseUpdateHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseUpdateHistoryUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryPost: async (warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WarehouseUpdateHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(warehouseUpdateHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WarehouseUpdateHistoryApi - functional programming interface
 * @export
 */
export const WarehouseUpdateHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WarehouseUpdateHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WarehouseUpdateHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryIdDelete(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryIdPut(id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryIdPut(id, warehouseUpdateHistoryUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WarehouseUpdateHistoryDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WarehouseUpdateHistoryApi - factory interface
 * @export
 */
export const WarehouseUpdateHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WarehouseUpdateHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryGet(options?: any): AxiosPromise<Array<WarehouseUpdateHistoryDto>> {
            return localVarFp.apiWarehouseUpdateHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} warehouseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId: number, options?: any): AxiosPromise<Array<WarehouseUpdateHistoryDto>> {
            return localVarFp.apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiWarehouseUpdateHistoryIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdGet(id: number, options?: any): AxiosPromise<WarehouseUpdateHistoryDetailsDto> {
            return localVarFp.apiWarehouseUpdateHistoryIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryIdPut(id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options?: any): AxiosPromise<WarehouseUpdateHistoryDetailsDto> {
            return localVarFp.apiWarehouseUpdateHistoryIdPut(id, warehouseUpdateHistoryUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options?: any): AxiosPromise<WarehouseUpdateHistoryDetailsDto> {
            return localVarFp.apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WarehouseUpdateHistoryApi - object-oriented interface
 * @export
 * @class WarehouseUpdateHistoryApi
 * @extends {BaseAPI}
 */
export class WarehouseUpdateHistoryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryGet(options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} warehouseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId: number, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryHistoryWarehouseIdGet(warehouseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryIdDelete(id: number, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryIdGet(id: number, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {WarehouseUpdateHistoryUpdateDto} [warehouseUpdateHistoryUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryIdPut(id: number, warehouseUpdateHistoryUpdateDto?: WarehouseUpdateHistoryUpdateDto, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryIdPut(id, warehouseUpdateHistoryUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WarehouseUpdateHistoryCreateDto} [warehouseUpdateHistoryCreateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarehouseUpdateHistoryApi
     */
    public apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto?: WarehouseUpdateHistoryCreateDto, options?: any) {
        return WarehouseUpdateHistoryApiFp(this.configuration).apiWarehouseUpdateHistoryPost(warehouseUpdateHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


